const illustrations = {
  nuts: `<svg viewBox="0 0 120 120" aria-hidden="true"><ellipse cx="60" cy="83" rx="43" ry="20" fill="#c9b489"/><path d="M20 74c8 33 72 33 80 0" fill="#efe8d8" stroke="#9b8d71" stroke-width="2"/><g fill="#bda064" stroke="#8f7646" stroke-width="1.5"><ellipse cx="38" cy="59" rx="10" ry="16" transform="rotate(-25 38 59)"/><ellipse cx="58" cy="54" rx="10" ry="16" transform="rotate(14 58 54)"/><ellipse cx="79" cy="61" rx="10" ry="16" transform="rotate(31 79 61)"/><ellipse cx="49" cy="75" rx="10" ry="16" transform="rotate(-8 49 75)"/><ellipse cx="71" cy="75" rx="10" ry="16" transform="rotate(12 71 75)"/></g><g fill="#73925b"><path d="M35 48c3-8 8-10 14-9-3 7-8 10-14 9Z"/><path d="M77 48c6-5 12-5 17-1-6 5-12 5-17 1Z"/></g></svg>`,
  oils: `<svg viewBox="0 0 120 120" aria-hidden="true"><defs><linearGradient id="g1" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#3e533a"/><stop offset="1" stop-color="#1f2c21"/></linearGradient><linearGradient id="g2" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#6c7c42"/><stop offset="1" stop-color="#34451e"/></linearGradient></defs><rect x="22" y="25" width="30" height="78" rx="8" fill="url(#g1)"/><rect x="28" y="12" width="18" height="20" rx="4" fill="#2c312a"/><rect x="30" y="52" width="14" height="27" rx="2" fill="#e8dfc5"/><rect x="66" y="18" width="31" height="85" rx="8" fill="url(#g2)"/><rect x="72" y="7" width="19" height="20" rx="4" fill="#292d28"/><rect x="73" y="48" width="17" height="31" rx="2" fill="#ead9a3"/><path d="M55 100c4-12 13-19 23-22" stroke="#8da56a" stroke-width="3" fill="none"/><ellipse cx="58" cy="95" rx="7" ry="4" fill="#70884e"/><ellipse cx="77" cy="81" rx="7" ry="4" fill="#70884e"/></svg>`,
  tea: `<svg viewBox="0 0 120 120" aria-hidden="true"><path d="M26 38h57v48c0 13-10 23-23 23H49c-13 0-23-10-23-23Z" fill="#f8f5e9" stroke="#79906c" stroke-width="2"/><path d="M84 50h8c14 0 16 24 0 27h-8" fill="none" stroke="#79906c" stroke-width="4"/><path d="M34 58c18-8 32 8 46 0v22c-14 8-28-8-46 0Z" fill="#c8d6a6"/><path d="M48 28c-6-10 7-13 1-23M66 29c-6-10 7-13 1-23" stroke="#9aa095" stroke-width="2" fill="none"/><g fill="#6f9057"><ellipse cx="43" cy="88" rx="9" ry="4" transform="rotate(25 43 88)"/><ellipse cx="65" cy="91" rx="9" ry="4" transform="rotate(-20 65 91)"/></g></svg>`,
  salt: `<svg viewBox="0 0 120 120" aria-hidden="true"><path d="M20 89c9-17 26-27 46-27s36 10 44 27" fill="#efe6d0" stroke="#9b8b6c" stroke-width="2"/><path d="M28 88h74" stroke="#9b8b6c" stroke-width="3"/><g fill="#b47457"><rect x="28" y="43" width="34" height="22" rx="7" transform="rotate(-12 28 43)"/><rect x="49" y="35" width="39" height="24" rx="7" transform="rotate(8 49 35)"/></g><g fill="#bda064" stroke="#8f7646"><ellipse cx="79" cy="71" rx="8" ry="12" transform="rotate(20 79 71)"/><ellipse cx="94" cy="75" rx="8" ry="12" transform="rotate(-18 94 75)"/></g><path d="M74 23h25v36H74z" fill="#fbfbf9" stroke="#8e9890" stroke-width="2"/><path d="M79 30h15M79 36h15" stroke="#8e9890"/><circle cx="82" cy="51" r="1.7" fill="#8e9890"/><circle cx="88" cy="51" r="1.7" fill="#8e9890"/><circle cx="94" cy="51" r="1.7" fill="#8e9890"/></svg>`,
  help: `<svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="42" fill="#eef2ea" stroke="#7c8f74" stroke-width="2"/><path d="M48 46c2-8 10-12 18-9 7 3 10 12 4 18-4 4-8 5-8 12" stroke="#4c5f43" stroke-width="5" fill="none" stroke-linecap="round"/><circle cx="60" cy="82" r="4" fill="#4c5f43"/></svg>`
};

/* Sperrliste - Stand 30.07., Cluster aus dem Projekt-Export */
const SPERRE = /(bluthochdruck|hyperton|diabet|blutzucker|insulin|gicht|harnsäure|reizdarm|niere|leber|cholesterin|krebs|tumor|demenz|alzheimer|entzündung|arthrose|rheuma|erkält|husten|halsschmerz|schnupfen|fieber|grippe|infekt|bronchitis|heiser|immunsystem|abwehrkr|kopfschmerz|migräne|schlafstör|einschlaf|schlaflos|allergie|heuschnupfen|histamin|unverträglich|verstopfung|sodbrennen|darm|müd|konzentr|depression|\bangst\b|sonnenschutz|sonnenbrand|gelenk|\bhaut\b|\baugen\b|krank|schmerz|abnehmen|diät|schlank|\bdick\b|zunehm|pfunde|speck|figur|kalorien sparen|longevity|anti.?aging|altern|hilft gegen|wirkt gegen|heilt|therapie|lindert|vorbeug|schwangerschaft|stillzeit|gesund|gesünder|entgift|detox|magen|bauch|völlegef|blähung|verdau)/;

/* Konkrete, benennbare Krankheiten: hier bleibt auch die Zutaten-Liste weg - eine Liste waere selbst die Aussage */
const NAMED_DISEASE = /(demenz|alzheimer|krebs|tumor|diabet)/;

/* Umlenkungen: gesperrte Frage wird zur Geschmacksfrage, kein Krankheits- oder Wirkbezug im Antworttext */
const UMLENK = [
 { re:/(erkält|husten|halsschmerz|schnupfen|fieber|grippe|infekt|bronchitis|heiser|immunsystem|abwehrkr)/,
   result:{
    summary:'Zur Frage selbst sagt auteniQ nichts. Zu Geschmack und Werten schon.',
    tags:['warm','Ingwer','Zitrone','Honig'],
    eyebrow:'Geschmacksfrage',title:'Kräutertee mit Ingwer und Zitrone',intro:'Würzig-scharf durch Ingwer, dazu Säure aus der Zitronenschale.',
    visual:'tea',
    redirect:'Magst du etwas Warmes mit Ingwer, Zitrone oder Honig? Darauf gibt es eine Antwort, denn das ist eine Frage nach Geschmack.',
    metrics:[['4','Zutaten'],['0 mg','Koffein je Tasse'],['95 °C','Wassertemperatur'],['8 min','Ziehzeit']],
    refine:false,
    why:'Ingwer und Zitrone stehen offen auf dem Etikett, ganz ohne Wirkversprechen.',
    limit:'du etwas völlig Kaltes oder Koffeinhaltiges suchst.',
    evidence:'4 von 4 Zutaten belegt',
    source:'Zutatenliste vom Etikett · keine Wirkaussage, nur Geschmack.'
   }},
 { re:/(schlafstör|einschlaf|schlaflos)/,
   result:{
    summary:'Auch hier bleibt die Antwort beim Geschmack, nicht bei der Wirkung.',
    tags:['abends','koffeinfrei','Lavendel','Melisse','Kamille'],
    eyebrow:'Geschmacksfrage',title:'Magst du Lavendel, Melisse oder Kamille?',intro:'Drei koffeinfreie Kräuter für den Abend. Die Wahl bleibt bei dir.',
    visual:'tea',
    redirect:'Magst du Lavendel, Melisse oder Kamille für den Abend? Darauf gibt es eine Antwort, denn das ist eine Frage nach Geschmack.',
    metrics:[['3','Kräuter zur Wahl'],['0 mg','Koffein je Tasse'],['8 min','Ziehzeit'],['mild','Geschmack']],
    refine:false,
    why:'Koffeinfrei und mild im Geschmack, ohne jede Wirkaussage.',
    limit:'du etwas Kräftiges oder Koffeinhaltiges suchst.',
    evidence:'3 von 3 Angaben belegt',
    source:'Zutaten und Koffeinwert vom Etikett.'
   }},
 { re:/(kopfschmerz|migräne)/,
   result:{
    summary:'Die Antwort bleibt beim Geschmack.',
    tags:['koffeinfrei','Minze','Ingwer'],
    eyebrow:'Geschmacksfrage',title:'Magst du Minze oder Ingwer?',intro:'Klar und kühlend die eine, würzig-scharf die andere. Beide koffeinfrei.',
    visual:'tea',
    redirect:'Magst du etwas Koffeinfreies mit Minze oder Ingwer? Darauf gibt es eine Antwort, denn das ist eine Frage nach Geschmack.',
    metrics:[['2','Kräuter zur Wahl'],['0 mg','Koffein je Tasse'],['6 min','Ziehzeit'],['kühl/würzig','Geschmack']],
    refine:false,
    why:'Zwei Zutaten, klar deklariert, ohne Wirkaussage.',
    limit:'du ein süßeres oder wärmeres Aroma suchst.',
    evidence:'3 von 3 Angaben belegt',
    source:'Zutatenliste vom Etikett.'
   }},
 { re:/(darm|verstopfung)/,
   result:{
    bannerType:'arzt',
    summary:'Zur Frage selbst sagt auteniQ nichts. Zu den Ballaststoffwerten schon.',
    tags:['Ballaststoffe','messbar','je Portion'],
    eyebrow:'Höchster Wert im Sortiment',title:'Würziger Kürbis Riegel',
    intro:'20,7 g Ballaststoffe je 100 g. Das ist der höchste belegte Wert im Sortiment.',
    visual:'nuts',
    redirect:'Was auteniQ liefern kann, sind die Ballaststoffwerte je Portion. Die Einordnung bleibt bei dir.',
    metrics:[['20,7 g','Ballaststoffe je 100 g'],['8,3 g','je Riegel (40 g)'],['hoher','Ballaststoffgehalt'],['40 g','Portion']],
    refine:false,
    why:'„Hoher Ballaststoffgehalt\" ist eine Nährwertangabe mit fester Schwelle ab 6 g je 100 g — keine Wirkaussage.',
    limit:'du eine Aussage zur Verdauung erwartest. Für Gemüse- und Dattelballaststoffe ist keine zugelassen.',
    evidence:'5 von 5 Sorten mit belegtem Ballaststoffwert',
    source:'Ballaststoffe: Herstellerangabe Malunt · Einstufung nach Anhang der Verordnung 1924/2006.'
   }},
 { re:/(magen|bauch|völlegef|blähung|verdau)/,
   result:{
    /* Bis 13.08.2026 stand hier "Fenchel-Anis-Tee" und die Frage
       "Magst du Fenchel, Anis oder Ingwer?" - beides fuehrt das
       Sortiment nicht. Das Zutaten-Menue darunter war am 31.07.2026
       schon auf Kamille, Minze, Ingwer und Kurkuma korrigiert worden,
       der Text daneben nicht. Kuno bot damit etwas an und zeigte
       etwas anderes. Dieselbe Fehlerart wie bei den Holzkisten:
       ein Versprechen ohne Ware dahinter.
       Fenchel und Anis bleiben eine offene Sortimentsluecke. */
    summary:'Auch hier antwortet auteniQ über den Geschmack.',
    tags:['Kamille','Minze','Ingwer','Kurkuma'],
    eyebrow:'Geschmacksfrage',title:'Mild und krautig',intro:'Weich und rund, ohne Schärfe.',
    visual:'tea',
    redirect:'Magst du etwas Mildes mit Kamille, Minze, Ingwer oder Kurkuma? Darauf gibt es eine Antwort, denn das ist eine Frage nach Geschmack.',
    metrics:[['0 mg','Koffein je Tasse'],['mild','Geschmack']],
    refine:false,
    why:'Zutaten offen deklariert, ganz ohne Wirkaussage.',
    limit:'du Fenchel oder Anis suchst — beides führt das Sortiment nicht.',
    evidence:'Zutaten aus Produkttitel und Zutatenliste',
    source:'Zutatenliste vom Etikett.'
   }}
];

const results = {
  snack: {
    summary:'Du suchst einen herzhaften Snack für abends, möchtest Salz begrenzen und keine Süßstoffe.',
    tags:['Snack','abends','herzhaft','salzbewusst','ohne Süßstoffe'],
    eyebrow:'Beste Übereinstimmung',title:'Ungesalzene Bio-Pistazien',intro:'Herzhaft, knusprig und klar portionierbar. Die Auswahl basiert auf den von dir genannten Kriterien.',visual:'nuts',
    base:{kcal:162,protein:5.2,salt:0.01},basePortion:25,
    metrics:[['1','Zutat'],['0,02 g','Salz je 100 g'],['0 g','zugesetzter Zucker'],['nein','Süßstoffe']],
    refine:true,why:'Wenig Salz, keine Süßstoffe und nur eine Zutat. Die Portionsgröße bleibt für dich sichtbar.',
    limit:'du eine sehr große Menge bei möglichst wenig Energie essen möchtest. Nüsse bleiben energiereich.',
    evidence:'4 von 4 entscheidenden Werten belegt',source:'Etikett · Produkt-DNA · zuletzt geprüft · keine Werte geschätzt.'
  },
  oils: {
    summary:'Du suchst hohe Polyphenolwerte, möchtest beim Geschmack aber möglichst wenig Schärfe.',
    tags:['Olivenöl','Polyphenole','mild','Zielkonflikt erkannt'],
    eyebrow:'Sinnvollste Lösung',title:'Zwei Öle nutzen, jedes für seine Aufgabe',intro:'Ein mildes Öl für Salat und jeden Tag. Ein kräftiges für die kleine, gezielte Menge.',visual:'oils',
    /* Die erste Kachel zeigte bis 16.08.2026 nur die Ziffer "2".
       Alexander: "Das ist nicht klar, da kann nicht nur die Ziffer
       zwei stehen." Eine Zahl ohne Bezugsgroesse ist keine Aussage -
       dieselbe Regel wie beim Grundpreis. Jetzt steht dort, WAS zwei
       sind und WOFUER jedes der beiden gedacht ist. */
    metrics:[['Zwei Öle','ein mildes, ein kräftiges'],['mild','für Salat und jeden Tag'],['kräftig','für die kleine, gezielte Menge'],['Labor','Wert muss belegt sein']],
    refine:false,why:'Geschmack und Polyphenolziel werden getrennt gelöst. Dadurch muss kein einzelnes Öl beides nur halb erfüllen.',
    limit:'du nur eine Flasche verwenden möchtest oder für die aktuelle Charge noch kein Laborwert vorliegt.',
    evidence:'Sensorik und Laborwert getrennt ausgewiesen',source:'Sensorik aus Verkostung · Polyphenole nur aus chargenbezogener Analyse · fehlende Laborwerte werden gezeigt.'
  },
  tea: {
    summary:'Du suchst ein ungesüßtes Getränk ohne Zucker und ohne Süßstoffe, das mehr Abwechslung als Wasser bietet.',
    tags:['Getränk','ungesüßt','ohne Zucker','ohne Süßstoffe','kalt möglich'],
    eyebrow:'Passende Richtung',title:'Kalt aufgegossener Grüntee',intro:'Ungesüßt, aromatisch und als Cold Brew unkompliziert vorzubereiten. Die Auswahl lässt sich nach Koffein und Geschmack verfeinern.',visual:'tea',
    metrics:[['0 g','zugesetzter Zucker'],['nein','Süßstoffe'],['kalt','aufgießbar'],['mild','bis herb wählbar']],
    refine:false,why:'Das Getränk bleibt ungesüßt, bekommt aber über Sorte und Ziehzeit ein klares Geschmacksprofil.',
    limit:'du vollständig koffeinfrei trinken möchtest. Dann sollte gezielt nach einer koffeinfreien Alternative gefiltert werden.',
    evidence:'Zutaten und Zubereitung belegt',source:'Produktangaben · Rezeptwissen · Koffein nur anzeigen, wenn der konkrete Wert dokumentiert ist.'
  },
  salt: {
    summary:'Du möchtest wissen, wie viel Salz eine selbst gewählte Menge Schinken und Pistazien zusammen enthält.',
    tags:['Schinken','Pistazien','Salz berechnen','eigene Mengen'],
    eyebrow:'Mengenrechner',title:'Salz aus beiden Portionen sichtbar machen',intro:'Du gibst die Mengen ein. Das System addiert die belegten Salzwerte und zeigt, welches Produkt den größten Anteil liefert.',visual:'salt',
    metrics:[['25 g','Schinken'],['30 g','Pistazien'],['1,39 g','Salz gesamt'],['Schinken','größter Anteil']],
    refine:false,why:'Die Antwort bewertet nicht pauschal, sondern rechnet deine tatsächliche Auswahl transparent zusammen.',
    limit:'für einen der Artikel kein belegter Salzwert vorliegt. Dann wird keine Summe geschätzt.',
    evidence:'2 von 2 Salzwerten belegt',source:'Salz je 100 g aus Etikett · Mengenrechnung im System · keine persönliche Tagesmenge empfohlen.'
  },
  ingredients: {
    summary:'Du möchtest eine möglichst kurze Zutatenliste, ohne Zusatzstoffe im Hintergrund.',
    tags:['wenige Zutaten','ohne Aroma','ohne Emulgator'],
    eyebrow:'1 Zutat',title:'Reines Pistazienmus',intro:'Nur Pistazien, sonst nichts. Die Zutatenliste steht offen daneben, auch wenn sie kurz ist.',visual:'nuts',
    metrics:[['1','Zutat'],['nein','Palmöl'],['nein','Emulgator'],['nein','Aroma']],
    refine:false,why:'Eine Zutat lässt sich nicht kürzen. Zusatzstoffe kommen schlicht nicht vor.',
    limit:'du eine streng pflanzliche oder besonders salzarme Auswahl suchst - dafür passt eher ein anderer Artikel.',
    evidence:'4 von 4 Angaben aus der Zutatenliste belegt',source:'Zutatenliste vom Etikett · eine kurze Liste ist ein Fakt, kein automatisches Qualitätsurteil.'
  },
  generic: {
    summary:'Dein Anliegen ist angekommen, aber zwei unterschiedliche Ziele sind möglich.',
    tags:['freie Frage','eine Rückfrage nötig'],
    eyebrow:'Kurz nachgefragt',title:'Was ist dir wichtiger?',intro:'So wird die Antwort genauer, statt zu raten.',visual:'help',
    noProduct:true,
    choice:[
      {title:'Möglichst wenige Zutaten',desc:'Auswahl nach Zutatenzahl und Ausschlüssen.',ask:'Ich möchte nur Produkte mit maximal zwei Zutaten.'},
      {title:'Ein bestimmter Wert je Portion',desc:'Die Menge wird gerechnet, statt nur ein Häkchen zu setzen.',ask:'Ich suche einen herzhaften Snack für abends, möglichst wenig Salz und ohne Süßstoffe.'}
    ],
    evidence:'',source:'Ohne erkanntes Kriterium erscheint bewusst keine Produktliste.'
  },
  blocked: {
    summary:'Zu dieser Frage zeigt auteniQ bewusst keine Produktliste.',
    tags:['Frage außerhalb'],
    eyebrow:'Frag lieber so',title:'Zutaten, Werte oder Geschmack',intro:'Darauf gibt es eine ehrliche Antwort.',visual:'help',
    noProduct:true,
    redirect:'auteniQ kennt die Zahlen der Produkte, nicht deinen Befund. Nach Geschmack, Zutaten und Werten kannst du jederzeit fragen.',
    choice:[
      {title:'Nach Zutaten fragen',desc:'zum Beispiel maximal zwei Zutaten.',ask:'Ich möchte nur Produkte mit maximal zwei Zutaten.'},
      {title:'Nach Geschmack fragen',desc:'zum Beispiel mild oder kräftig.',ask:'Welches Olivenöl hat viele Polyphenole, schmeckt aber nicht so scharf?'}
    ],
    evidence:'',source:'Ein ehrliches Nein ist ein gültiges Ergebnis und wird protokolliert.'
  },
  krankheit: {
    bannerType:'krankheit',
    summary:'Zu einer konkreten Krankheit zeigt auteniQ keine Liste - auch keine mit reinen Zahlen.',
    tags:['keine Produktliste'],
    eyebrow:'Ohne Produktliste',title:'Fachwissen und unabhängige Studienlage',
    intro:'Eine Liste unter dieser Frage wäre selbst schon die Aussage. Deshalb bleibt sie weg - nicht die Antwort insgesamt.',
    visual:'help',
    noProduct:true,
    redirect:'Bei anhaltenden Beschwerden hilft Fachwissen weiter — eine Ärztin, ein Arzt, Fachliteratur oder ein guter Fachbeitrag. auteniQ kennt die Zahlen der Produkte, nicht deinen Befund. Zur unabhängigen Studienlage veröffentlichen die Cochrane Library, PubMed und die Deutsche Gesellschaft für Ernährung (DGE) frei zugängliche Übersichtsarbeiten - unabhängig von einzelnen Produkten.',
    choice:[
      {title:'Nach Zutaten fragen',desc:'zum Beispiel maximal zwei Zutaten.',ask:'Ich möchte nur Produkte mit maximal zwei Zutaten.'},
      {title:'Nach Nährwerten fragen',desc:'zum Beispiel Ballaststoffe oder Eiweiß je Portion.',ask:'Snack mit vielen Ballaststoffen'}
    ],
    evidence:'',source:'Kein Produkt wird einer konkreten Krankheit zugeordnet - auch nicht über reine Zahlen.'
  }
};

/* Stufe A - Naehrwertangabe, keine Sperre noetig */
results.protein = {
 summary:'Du suchst Eiweiß je Portion. Das ist eine Nährwertangabe und braucht keine Umschreibung.',
 tags:['Eiweiß','je Portion','Nährwertangabe'],
 eyebrow:'Proteinquelle',title:'Die fünf Gemüseriegel',
 intro:'Alle fünf Sorten überschreiten die 12-Prozent-Schwelle und dürfen damit Proteinquelle heißen.',
 visual:'nuts',
 metrics:[['12,2–14 g','Eiweiß je 100 g'],['14–18 %','Anteil am Brennwert'],['ca. 5 g','je Riegel (40 g)'],['Quelle','Einstufung']],
 refine:false,
 why:'Proteinquelle gilt ab 12 Prozent des Brennwerts. Tomate liegt mit 17,8 Prozent vorn, Rote Bete mit 14,0 Prozent hinten.',
 limit:'du einen Proteinriegel suchst. Dafür sind 5 g je Riegel zu wenig, und „hoher Proteingehalt\" verlangt 20 Prozent — das erreicht keine Sorte.',
 evidence:'5 von 5 Sorten mit belegtem Eiweißwert',
 source:'Eiweiß vom Etikett · Einstufung nach Anhang der Verordnung 1924/2006 · Schwellen: Quelle 12 %, hoher Gehalt 20 %.'
};

results.fiber = {
 summary:'Du suchst Ballaststoffe. Auch das ist eine Nährwertangabe mit fester Schwelle.',
 tags:['Ballaststoffe','je Portion','Nährwertangabe'],
 eyebrow:'Hoher Ballaststoffgehalt',title:'Würziger Kürbis Riegel',
 intro:'20,7 g je 100 g — alle fünf Sorten liegen über der 6-Gramm-Schwelle.',
 visual:'nuts',
 metrics:[['20,7 g','Ballaststoffe je 100 g'],['8,3 g','je Riegel (40 g)'],['28 %','von 30 g DGE-Richtwert'],['11–20,7 g','Bandbreite der Sorten']],
 refine:false,
 why:'Ab 3 g je 100 g gilt Ballaststoffquelle, ab 6 g hoher Ballaststoffgehalt. Alle fünf Sorten erreichen die höhere Stufe.',
 limit:'du eine Aussage zur Verdauung erwartest. Die ist nur für bestimmte Faserquellen wie Weizenkleie zugelassen, nicht für Gemüse.',
 evidence:'5 von 5 Sorten mit belegtem Ballaststoffwert',
 source:'Ballaststoffe: Herstellerangabe Malunt · Richtwert 30 g täglich: Deutsche Gesellschaft für Ernährung.'
};

results.gesund = {
 bannerType:'wert',
 summary:'„Gesund\" lässt sich nicht in eine Zahl übersetzen. Fünf andere Dinge schon.',
 tags:['messbare Kriterien'],
 eyebrow:'Sag, was zählt',title:'Ballaststoffe, Eiweiß, Zucker, Salz, Zutaten',
 intro:'Wähle ein Kriterium, dann rechnet auteniQ es an deiner Portion aus.',
 visual:'help',
 noProduct:true,
 redirect:'Messbar sind Ballaststoffe, Eiweiß, Zucker, Salz und die Zahl der Zutaten. Die Bewertung bleibt bei dir.',
 choice:[
  {title:'Viele Ballaststoffe',desc:'Werte je 100 g und je Portion, mit Einstufung.',ask:'Snack mit vielen Ballaststoffen'},
  {title:'Wenige Zutaten',desc:'Auswahl nach Zutatenzahl und Ausschlüssen.',ask:'Ich möchte nur Produkte mit maximal zwei Zutaten.'}
 ],
 evidence:'',source:'„Gesund\" ist als pauschaler Verweis nur mit einer konkreten zugelassenen Angabe zulässig (Art. 10 Abs. 3).'
};

/* -----------------------------------------------------------------
   Gefunden von Alexander am 13.08.2026, Fragenprotokoll:
   "Ich suche einen Einmonatsvorrat fuers Buero: Snacks in erster Linie
   oder was man so auch gesundes oder gutes Essen kann."
   Das ist eine Einkaufsfrage. Sie lief in die Sperre, weil das Wort
   "gesundes Essen" darin steht - und endete ohne einen einzigen
   Artikel. Alexander bemerkte anschliessend, bei den Buero-Snacks
   haetten die Pistazien gefehlt; sie hatten nie eine Chance, weil gar
   nichts erschien.

   Was sich aendert und was ausdruecklich nicht:
   - Es erscheint weiterhin KEIN Produktraster unter der Frage
     (noProduct bleibt true). Eine Liste unter "gesund" waere eine
     Wirkbehauptung, egal wie die Artikel heissen.
   - Neu ist ein Weg heraus: nennt derselbe Satz eine Warengruppe, wird
     sie als anklickbare Rueckfrage angeboten. Der Kunde stellt damit
     selbst eine Sortimentsfrage ohne das Wort "gesund" - und bekommt
     die Ware auf eine Frage, die sie tragen darf. Das ist dieselbe
     Umlenkung wie bei den Beschwerdefragen, nur eine Stufe harmloser.
   Fuehrend bleibt der Skill auteniq-health-claim-regelwerk.
   ----------------------------------------------------------------- */
function gesundAntwort(s){
  const g = gruppeVon(s);
  /* Snacks sind keine Warengruppe in WARENGRUPPEN, sondern eine eigene
     Antwort - deshalb hier gesondert. Genau dieser Fall war Alexanders
     Buero-Frage. */
  const snack = !g && /(snack|nüsse|nuss|knabber|naschen)/.test(s);
  if(!g && !snack) return results.gesund;
  const kopie = Object.assign({}, results.gesund);
  kopie.choice = [ g
    ? { title: g.label+' ansehen',
        desc:  'Das Sortiment dieser Warengruppe, sortiert nach Verkaufshäufigkeit.',
        ask:   g.label }
    : { title: 'Snacks ansehen',
        desc:  'Die Snacks im Sortiment, sortiert nach Verkaufshäufigkeit.',
        ask:   'Welche Snacks gibt es?' }
  ].concat(results.gesund.choice);
  kopie.intro = 'Wähle ein Kriterium, dann rechnet auteniQ es an deiner Portion aus. Oder sieh dir direkt an, was in der genannten Warengruppe liegt.';
  return kopie;
}

results.longevity = {
 bannerType:'versprechen',
 summary:'Für Longevity existiert keine zugelassene Aussage. Messwerte gibt es trotzdem.',
 tags:['Stoff und Menge','ohne Wirkaussage'],
 eyebrow:'Stoff und Menge',title:'Was messbar im Sortiment steckt',
 intro:'Diese Stoffe sind mit Menge hinterlegt. Eine Wirkung steht bewusst nirgends.',
 visual:'help',
 redirect:'Was in den Produkten steckt und in welcher Menge, steht unten. Die Deutung bleibt bei dir.',
 metrics:[['20 µg','Vitamin D3 je Portion'],['50 µg','D3 forte je Portion'],['100 mg','Coenzym Q10'],['–','Spermidin: kein Wert',1]],
 refine:false,
 why:'Vitamin D3 hat einen zugelassenen Wortlaut, sobald die Portion 15 Prozent der Referenzmenge erreicht. Beide Öle liegen darüber.',
 limit:'du eine Longevity-Wirkung erwartest. Für Coenzym Q10 und Spermidin existiert keine zugelassene Aussage — dort bleibt es bei Stoff und Menge.',
 evidence:'2 von 4 Werten belegt',
 source:'Mikronährstoffe der übrigen Nahrungsergänzungen sind noch nicht erhoben. Fehlende Werte bleiben leer.'
};

results.genuss = {
 summary:'Du suchst besonderen Geschmack, Genuss und Spitzenqualität. Das ist eine Frage nach der Auswahl, nicht nach der Menge.',
 tags:['Spitzenqualität','handverlesen','Kenner-Empfehlung'],
 eyebrow:'Handverlesen',title:'Die Spitzenqualität-Auswahl: 13 Artikel',
 intro:'Nicht jede Sorte im Sortiment trägt dieses Etikett. Drei Öle, drei Essige, ein Schinken, vier Nüsse und zwei Tee-Sets zeigen, wonach ausgewählt wird.',
 visual:'oils',
 metrics:[['100 % Ibérico Bellota','Cinco Jotas Lingote'],['900–1800 mg/kg','Polyphenole, Holiston Ultra Premium'],['ab 3 Goldmedaillen','Kriterium beim Essig'],['LaLola1947 & KEIKO','seit 01.08.2026 dabei'],['handverlesen','kein Bestseller-Kriterium']],
 refine:false,
 why:'Ausgewählt nach Verkostung, Herkunft und - beim Essig - der Medaillenstufe des Herstellers. Das sind messbare Kriterien, keine Werbeworte.',
 limit:'du eine möglichst breite Auswahl statt einer engen Empfehlung suchst — dann lohnt ein Blick ins ganze Sortiment.',
 evidence:'13 von 13 Auswahlkriterien belegt',
 source:'Auswahl nach Verkostung und Herkunftsprüfung, Stand 31.07.2026, erweitert 01.08.2026 (Pekannuss, La-Lola-Pistazien, KEIKO). Bestseller-Status fließt bewusst nicht in diese Auswahl ein — Verkaufszahl ist kein Geschmacksurteil.'
};

/* Ausserhalb des Themas, aber ehrlich beantwortet statt ignoriert. */
results.versand = {
 summary:'Diese Frage betrifft eine einzelne Bestellung. Das weiß auteniQ nicht - das Sortiment und seine Werte schon.',
 tags:['Bestellstatus','außerhalb des Themas'],
 eyebrow:'Andere Anlaufstelle',title:'Für den Bestellstatus ist direkt das Team da',
 intro:'auteniQ kennt Produkte, Preise und Werte - keine einzelnen Bestellungen. Schneller geht es direkt: kontakt@auteniq.de oder +49 (0) 5335 22 99 99 0, am besten mit der Bestellnummer.',
 visual:'help',
 noProduct:true,
 choice:[
  {title:'Nach einem Produkt fragen',desc:'zum Beispiel Preis, Zutaten oder Werte.',ask:'Welches Olivenöl hat viele Polyphenole?'},
  {title:'Sortiment durchsehen',desc:'Kategorien mit Bild und Preis.',ask:'Honig'}
 ],
 evidence:'',source:'Kontaktdaten aus dem Kontakt-Bereich des Shops, Stand 31.07.2026.'
};

results.verbrauch = {
 summary:'Wie lange eine Menge reicht, hängt vom persönlichen Verbrauch ab. Den kennt auteniQ nicht.',
 tags:['Verbrauch','keine Annahme erfunden'],
 eyebrow:'Dafür fehlt eine Angabe',title:'Verbrauch je Person ist nicht hinterlegt',
 intro:'Ohne eine belegte Verbrauchsmenge wäre jede Zahl geraten. Mit einer genannten Annahme - zum Beispiel Milliliter je Person und Tag - lässt sich das jederzeit ausrechnen.',
 visual:'help',
 noProduct:true,
 choice:[{title:'Füllmenge und Grundpreis ansehen',desc:'Reale Zahlen ohne Verbrauchsschätzung.',ask:'Olivenöl 3 Liter'}],
 evidence:'',source:'Kein Verbrauchswert je Person im Sortiment hinterlegt - wird nicht geschätzt.'
};

results.budget = {
 summary:'Du möchtest klein starten und hast ein Preislimit genannt. Das rechnet auteniQ ehrlich nach, auch wenn es eng wird.',
 tags:['Preislimit','zum Probieren','ehrliche Antwort'],
 eyebrow:'Ehrliche Antwort',title:'Ein gutes Öl unter 20 € gibt es — ein Kennenlernpaket bis 30 € noch nicht',
 intro:'Ein einzelnes gutes Öl passt in dein Budget. Ein fertiges Kennenlernpaket für 30 € führt das Sortiment aktuell nicht.',
 visual:'oils',
 metrics:[['15,90 €','Gota de Oro, 1 L, Cuvée von Mateo'],['20,90 €','Eleology Nature’s Blend, 500 ml'],['ab 98,90 €','günstigstes aktuelles Kennenlernpaket'],['0','Sets aktuell unter 30 €']],
 refine:false,
 why:'Gota de Oro liegt mit 15,90 € klar unter deiner Grenze. Mateo verkostet hunderte Partien pro Ernte und komponiert die Cuvée aus den besten.',
 limit:'du unbedingt ein fertiges Set statt eines Einzelprodukts möchtest. Das günstigste Set kostet aktuell 98,90 €.',
 evidence:'2 von 2 Preisen live aus dem Shop geprüft',
 source:'Preise direkt aus dem Shop, 30.07.2026. Kein Set unter 30 € vorhanden — ehrlich benannt statt beschönigt.'
};

/* Preis-Schnappschuss echter aktiver Artikel, gezogen aus dem Shop am 31.07.2026.
   Auf der echten Seite ersetzt die Preis-/Tag-Liste aus page.dna.liquid diesen Block 1:1 - gleiche Funktion, live statt Schnappschuss. */
const CATALOG = [
 {t:'36 Monate gereifter Vorderschinken (Paleta) 100% Ibérico Bellota',p:335.0,tags:['schinken']},
 {t:'60 Monate gereifter Hinterschinken 100% Ibérico Bellota',p:625.0,tags:['schinken']},
 {t:'Aceto Balsamico di Modena, 4 Goldmedaillen, 250 ml',p:37.9,tags:['essig']},
 {t:'Arbequina-Oliven Mestral, mild-fruchtig (Tafeloliven, kein Öl)',p:4.9,tags:['oliven']},
 {t:'Chardonnay-Balsamico-Essig „Aragem“, 250 ml',p:12.9,tags:['essig']},
 {t:'Bio Aceto Balsamico di Modena, 1 Silbermedaille, 250 ml',p:17.9,tags:['essig']},
 {t:'Bio Aceto Balsamico di Modena, 2 Goldmedaillen, 250 ml',p:22.9,tags:['essig']},
 {t:'Bio Aceto Balsamico di Modena, 3 Goldmedaillen, 250 ml',p:31.9,tags:['essig']},
 {t:'Bio Goji Beeren',p:12.9,tags:['snack']},
 {t:'Bio Macadamia Nüsse, 250 g',p:19.9,tags:['nuss','snack']},
 {t:'Bio Walnusskerne, 250 g',p:10.9,tags:['nuss','snack']},
 {t:'Bio-Olivenöl nativ extra Mestral Arbequina, 3 L',p:58.0,tags:['oel']},
 {t:'Bio-Olivenöl nativ extra »Chef’s Table« von Eleology, 5 L',p:95.0,tags:['oel']},
 {t:'Bio-Olivenöl nativ extra »Nature’s Blend« von Eleology, 500 ml',p:20.9,tags:['oel']},
 {t:'Olivenöl nativ extra Cuvée „Gota de Oro“, 1 L',p:15.9,tags:['oel']},
 {t:'Holiston Premium Olivenöl nativ extra, 500 ml',p:44.9,tags:['oel']},
 {t:'Holiston Ultra Premium Olivenöl nativ extra, 500 ml',p:55.0,tags:['oel','spitzenqualitaet']},
 {t:'Edles Würzöl mit schwarzem Trüffel, 250 ml',p:10.9,tags:['oel']},
 {t:'Gourmet-Würzöl mit schwarzem Knoblauch, 250 ml',p:10.9,tags:['oel']},
 {t:'Bio-Pistazien geröstet & gesalzen, 1 kg',p:30.9,tags:['nuss','snack']},
 {t:'Bio-Pistazien geröstet & ungesalzen, 1 kg',p:30.9,tags:['nuss','snack']},
 {t:'Bio-Pistazienkerne geschält, 1 kg',p:49.9,tags:['nuss','snack']},
 {t:'Bio-Pistazienmus, 200 g',p:22.9,tags:['nuss']},
 {t:'Bio-Zartbitterschokoladen-Set fairafric, 8er',p:27.9,tags:['schoko']},
 {t:'Bio Schokoladen & Frucht-Set fairafric, 8er',p:30.9,tags:['schoko']},
 {t:'Bunte Bio-Schokoladen Auswahl fairafric, 8er',p:27.9,tags:['schoko']},
 {t:'Blütenhonig der spanischen Sommerwiesen, 910 g',p:14.9,tags:['honig']},
 {t:'Duftender Zitronenblütenhonig, 910 g',p:17.9,tags:['honig']},
 {t:'Duftender Lavendelhonig, 910 g',p:17.9,tags:['honig']},
 {t:'Garrigue-Wildkräuterhonig, 910 g',p:17.9,tags:['honig']},
 {t:'Cremiger Heidehonig, 910 g',p:20.9,tags:['honig']},
 {t:'Borduito braune Mandelcreme, 500 g',p:18.9,tags:['nuss']},
 {t:'Borduito weiße Mandelcreme, 500 g',p:17.9,tags:['nuss']},
 {t:'Borduito ganze Mandeln geröstet, 1 kg',p:24.9,tags:['nuss','snack']},
 {t:'Borduito geschälte Mandeln, 1 kg',p:23.9,tags:['nuss','snack']},
 {t:'Borduito ungeschälte Mandeln Natur, 1 kg',p:21.9,tags:['nuss','snack']},
 {t:'Capuliato „Ciappa“ Kirschtomaten, 400 g',p:15.9,tags:['tomaten']},
 {t:'Capuliato „Ciappa“ gehackt, 350 g',p:9.9,tags:['tomaten']},
 {t:'Chiasamen von Sölls Hof, 1 kg',p:19.9,tags:['nuss']},
 {t:'Coenzym Q10 Kapseln, 100 mg',p:29.9,tags:['nahrungsergaenzung']},
 {t:'Condimento Agrodolce Bianco, 250 ml',p:15.5,tags:['essig']},
 {t:'Cinco Jotas Lingote, entbeinter Schinkenwürfel, ca. 450 g',p:107.0,tags:['schinken','spitzenqualitaet']}
];

/* Schnappschuss der Shopify-Sortierung "Meistverkauft" (echte Bestellzahlen), gezogen am 31.07.2026.
   Auf der echten Seite: Kollektion mit Sortierung "Meistverkauft" per Liquid einbinden - aktualisiert sich automatisch mit jeder Bestellung, keine manuelle Pflege. */
const BESTSELLER_SNAPSHOT = [
 {t:'Bio-Olivenöl nativ extra Mestral Arbequina, 3 L',p:58.0},
 {t:'Premium-Olivenöl nativ extra Mestral Arbequina, 3 L',p:53.0},
 {t:'Blütenhonig der spanischen Sommerwiesen, 910 g',p:14.9},
 {t:'Duftender Zitronenblütenhonig, 910 g',p:17.9},
 {t:'Duftender Lavendelhonig, 910 g',p:17.9},
 {t:'Edles Würzöl mit schwarzem Trüffel, 250 ml',p:10.9},
 {t:'Garrigue-Wildkräuterhonig, 910 g',p:17.9},
 {t:'Chardonnay-Balsamico-Essig „Aragem“, 250 ml',p:12.9}
];

function parsePriceLimit(s){
  const m = s.match(/(?:unter|bis|max(?:imal)?)\s*(\d+)|(\d+)\s*€/);
  if(!m) return null;
  return Number(m[1]||m[2]);
}
function categoryOf(s){
  /* \b funktioniert bei "öl" nicht - ö ist fuer JS kein Wortzeichen, die
     Grenze wird nie erkannt. "welches Öl..." fiel deshalb bisher immer
     durch. Eigene Grenzpruefung. Gefunden im Fragenprotokoll 31.07.2026. */
  /* Die Preisantworten rechnen seit 13.08.2026 gegen PRODUKTE statt
     gegen CATALOG. Beide Listen kennzeichnen die Warengruppe anders:
     CATALOG ueber tags, PRODUKTE ueber k. Ein Test, der beides kann. */
  const gr = (label,tag,k)=>({label,test:p=>p.tags?p.tags.includes(tag):p.k===k});
  if(s.includes('olivenöl')||s.includes('olivenoel')||/(^|[^a-zäöüß])öl($|[^a-zäöüß])/.test(s)) return gr('Olivenöl','oel','oel');
  if(s.includes('schinken')) return gr('Schinken','schinken','schinken');
  if(s.includes('honig')) return gr('Honig','honig','honig');
  if(s.includes('schoko')) return gr('Schokolade','schoko','schoko');
  if(s.includes('mandel')) return {label:'Mandeln',test:p=>/mandel/i.test(p.t)};
  if(s.includes('essig') || s.includes('balsamico')) return gr('Essig','essig','essig');
  return null;
}
function buildBudgetDynamic(s){
  const lim = parsePriceLimit(s); if(lim==null) return null;
  const cat = categoryOf(s);
  /* Bis 13.08.2026 lief diese Suche gegen CATALOG - eine Teilliste mit
     42 Titeln ohne Artikelnummer. "Habt ihr Produkte unter 10 Euro?"
     meldete deshalb 2 Treffer, obwohl 31 Artikel darunter liegen.
     Gerechnet wird jetzt gegen PRODUKTE, denselben Bestand, aus dem
     auch die Karten kommen. */
  let matches = PRODUKTE.filter(p=>p.p>0 && p.p<=lim);
  if(cat) matches = matches.filter(cat.test);
  /* Bis 13.08.2026 nach Preis sortiert. Alexander im Test: "Koennte man
     das ordnen nach Kaufhaeufigkeit? Was wirklich am meisten gekauft
     wurde, steht vorne links." Der Preis bleibt Zweitkriterium - er
     entscheidet unter Artikeln ohne Verkaufsrang. */
  matches = nachVerkauf(matches);
  const top = matches.slice(0,12);
  const mitRang = top.filter(p=>rangVon(p)!==OHNE_RANG).length;
  if(!top.length){
    return {
      bannerType:'preis',
      summary:'Für dieses Preislimit zeigt auteniQ ehrlich: kein Treffer, statt eine Notlösung.',
      tags:['Preislimit','kein Treffer'],
      eyebrow:'Ehrliche Antwort',title:'Kein Artikel'+(cat?(' bei '+cat.label):'')+' unter '+lim+' €',
      intro:'Kein Artikel passt aktuell in dieses Limit. Ein höheres Limit oder eine andere Kategorie führt zu Treffern.',
      visual:'help',noProduct:true,
      redirect:'Für '+lim+' €'+(cat?(' bei '+cat.label):'')+' liegt aktuell kein Artikel im Sortiment.',
      choice:[{title:'Ohne Preisgrenze suchen',desc:'Zeigt die günstigsten Treffer unabhängig vom Limit.',ask:(cat?cat.label:'Olivenöl')+' möglichst günstig'}],
      evidence:'',source:'Preise live aus dem Shop geprüft, 31.07.2026 · kein Treffer beschönigt.'
    };
  }
  return {
    summary:'Du hast ein Preislimit genannt'+(cat?(' für '+cat.label):'')+'. Das rechnet auteniQ direkt gegen den Shop, nicht gegen ein Beispiel.',
    tags:['Preislimit','automatisch berechnet'],
    eyebrow:'Unter '+lim+' €',
    title:(matches.length>top.length ? (top.length+' von '+matches.length+' Treffern') : (top.length+' Treffer'))
          +(cat?(' bei '+cat.label):'')+' unter '+lim+' €',
    pick:()=>top,
    intro:mitRang
      ? 'Sortiert nach Verkaufshäufigkeit, meistgekaufter Artikel zuerst. Wo kein Verkaufsrang vorliegt, entscheidet der Preis.'
      : 'Für diese Treffer liegt kein Verkaufsrang vor. Sortiert nach Preis, günstigster zuerst.',
    visual:'oils',
    metrics:[],
    refine:false,
    why:'Direkt aus den aktuellen Shop-Preisen gefiltert und nach den echten Bestellzahlen geordnet - eine echte Auswahl, kein Beispieltext.',
    limit:'du ein fertiges Set statt Einzelartikeln suchst - dafür gilt eine eigene Prüfung auf Sets.',
    evidence:top.length+' von '+top.length+' Preisen live aus dem Shop · '+mitRang+' davon mit Verkaufsrang',
    source:'Schnappschuss der aktiven Artikel, 31.07.2026. Auf der echten Seite zieht diese Liste automatisch die aktuellen Shop-Preise.'
  };
}
/* Superlativ ohne Zahl: "billigstes/guenstigstes X" oder "X mit dem
   niedrigsten/hoechsten Preis" - anders als buildBudgetDynamic, das eine
   Preisgrenze braucht. Vier von zehn "nicht verstanden"-Fragen im
   Fragenprotokoll waren genau dieses Muster. Gefunden 31.07.2026. */
function buildSuperlativDynamic(s){
  const min=/(billig|günstig|niedrigst)/.test(s);
  const max=/(teuerst|höchsten preis|hochpreisig)/.test(s);
  if(!min && !max) return null;
  const cat = categoryOf(s);
  /* Wie bei der Preisgrenze: gegen den vollen Bestand rechnen, nicht
     gegen die 42-Titel-Teilliste CATALOG. Gefunden 13.08.2026. */
  let matches = PRODUKTE.filter(p=>p.p>0);
  if(cat) matches = matches.filter(cat.test);
  if(!matches.length) return null;
  matches = matches.slice().sort((a,b)=> min ? a.p-b.p : b.p-a.p);
  const top = matches[0];
  const label = min ? 'Günstigster' : 'Teuerster';
  return {
    summary:'Du fragst nach dem Preisextrem'+(cat?(' bei '+cat.label):'')+'. Das liest auteniQ direkt aus dem Shop, nicht aus einer Einschätzung.',
    tags:['Preisvergleich','automatisch berechnet'],
    eyebrow:label+(cat?(' bei '+cat.label):''), title:top.t,
    intro:top.p.toFixed(2).replace('.',',')+' € — '+(min?'der niedrigste':'der höchste')+' Preis'+(cat?(' bei '+cat.label):' im Schnappschuss')+'.',
    visual:'oils',
    metrics:matches.slice(0,6).map(p=>[p.p.toFixed(2).replace('.',',')+' €',p.t]),
    refine:false,
    why:'Direkt aus den aktuellen Shop-Preisen sortiert - eine echte Auswahl, kein Beispieltext.',
    limit:'sich der Preis seit dem Schnappschuss geändert hat. Dann gilt der Preis im Shop.',
    evidence:matches.length+' von '+matches.length+' Preisen live aus dem Shop',
    source:'Schnappschuss der aktiven Artikel, 31.07.2026.'
  };
}
function buildBestsellerDynamic(){
  const top = BESTSELLER_SNAPSHOT;
  return {
    summary:'Die aktuell meistverkauften Artikel, direkt aus den echten Bestellzahlen.',
    tags:['Bestseller','aus echten Verkäufen'],
    eyebrow:'Meistverkauft',title:'Die Top '+top.length+' nach echten Verkaufszahlen',
    intro:'Diese Reihenfolge kommt aus den Bestellungen, nicht aus einer redaktionellen Auswahl.',
    visual:'oils',
    metrics:top.map((p,i)=>[(i+1)+'.',p.t+' — '+p.p.toFixed(2).replace('.',',')+' €']),
    refine:false,
    why:'Shopify führt für jede Kollektion eine Sortierung nach echten Verkaufszahlen ("Meistverkauft"). Diese Liste ist ein Schnappschuss davon.',
    limit:'Bestseller nicht automatisch die höchste Qualitätsstufe bedeuten - dafür gibt es die getrennte Spitzenqualität-Auswahl.',
    evidence:'8 von 8 Rängen aus echten Bestellzahlen',
    source:'Shopify-Sortierung "Meistverkauft", Schnappschuss vom 31.07.2026. Auf der echten Seite aktualisiert sich diese Liste automatisch mit jeder Bestellung.'
  };
}
function classify(text){
  const s=(text||'').toLowerCase().trim();
  if(!s) return results.generic;
  if(/(longevity|anti.?aging)/.test(s)) return results.longevity;
  if(/(gesünder|gesundes essen|gesund essen|gesunde ernährung|was ist gesund|gesunde snacks|gesund naschen)/.test(s)) return gesundAntwort(s);
  if(SPERRE.test(s)){
    /* Allergie zuerst: "Heuschnupfen" enthaelt "schnupfen" und landete
       sonst in der Erkaeltungs-Umlenkung. Gefunden 31.07.2026. */
    if(/(allergie|heuschnupfen|histamin|unverträglich)/.test(s)) return results.blocked;
    /* Naechste Teilwort-Kollision derselben Fehlerart: "stornieren"
       enthaelt "niere" und loeste die Sperrliste aus. Eine Bestellung
       stornieren hat nichts mit der Niere zu tun. Gefunden 31.07.2026. */
    if(/(bestellung|lieferung|rechnung).*(stornieren|abbestellen)/.test(s)) return results.versand;
    for(const u of UMLENK){ if(u.re.test(s)) return u.result; }
    if(NAMED_DISEASE.test(s)) return results.krankheit;
    /* Sperrt nur das allgemeine Wort "gesund" - keine Beschwerde, keine
       Krankheit -, dann ist die gesund-Antwort die richtige: dieselbe
       Zurueckhaltung, aber mit einem Weg weiter. Alexanders Buero-Frage
       vom 13.08.2026 ("Snacks ... oder was man so auch gesundes oder
       gutes Essen kann") traf die feste Wortliste oben nicht, weil
       zwischen "gesundes" und "Essen" noch "oder gutes" steht - und
       endete deshalb ohne alles. */
    if(/gesund|gesünder|entgift|detox/.test(s)) return gesundAntwort(s);
    return results.blocked;
  }
  /* Erst NACH der Sperrliste: Bestellstatus, Versand, Rechnung und Konto
     liegen ausserhalb dessen, was auteniQ ueber Produkte weiss - eine
     ehrliche eigene Antwort statt der Zutaten/Naehrwerte-Rueckfrage, die
     hier nicht passt. "Paket" bewusst NICHT im Muster: das Wort meint im
     Sortiment auch Vorrats-/Kennenlernpakete. Alexander rechnet damit,
     dass das Suchfeld oefter fuer solche Fragen genutzt wird ("und all
     solche Sachen") - deshalb bewusst als Familie angelegt, nicht nur
     fuer Lieferung. Gefunden im Fragenprotokoll 31.07.2026, 3 von 10
     offenen Faellen. Muss hinter der Sperrliste stehen, sonst wuerde
     "... und wann kommt meine Lieferung" eine Krankheitsfrage uebertoenen. */
  if(/(meine (bestellung|lieferung)|wo bleibt|ist .*(versendet|verschickt)|liefer(zeit|dauer|status)|wie lange dauert die lieferung|sendungsverfolgung|\btracking\b|rechnung (nochmal|noch mal|zuschicken|erneut)|rechnungskopie|meine bestellung (stornieren|ändern)|mein konto|mein(e|) passwort)/.test(s)) return results.versand;
  /* Reichweite/Verbrauch je Person: dafuer fehlt eine belegte Menge im
     Sortiment. Nicht schaetzen, sondern das offen sagen. Gefunden 31.07.2026. */
  if(/(wie lange (hält|haelt|reicht)|reichweite).*(person|personen|haushalt|familie)/.test(s)) return results.verbrauch;
  if(/(longevity|anti.?aging|altern)/.test(s)) return results.longevity;
  if(/(gesund|gesünder)/.test(s)) return results.gesund;
  if(/(ballaststoff|faserstoff)/.test(s)) return results.fiber;
  if(/(eiweiß|eiweiss|protein)/.test(s)) return results.protein;
  if(/(bestseller|meistverkauft|meist verkauft|beliebteste|top ?\d*\s*produkt|renner)/.test(s)) return buildBestsellerDynamic();
  if(/(kennenlern|einsteiger|klein starten|zum probieren)/.test(s)) return results.budget;
  { const dyn = buildBudgetDynamic(s); if(dyn) return dyn; }
  { const sup = buildSuperlativDynamic(s); if(sup) return sup; }
  if(/(budget|preislimit|günstig)/.test(s)) return results.budget;
  /* Die Zwei-Oele-Loesung ist eine Antwort auf einen ZIELKONFLIKT:
     hohe Polyphenole UND wenig Schaerfe in einem Satz. Bis 16.08.2026
     zog jede Frage, in der ueberhaupt "Olivenoel" oder "Polyphenol"
     vorkam, diese Antwort - auch ein schlichtes "Ich haette gerne
     Olivenoel und Honig". Der Kunde las dann "Zwei Oele statt eines
     faulen Kompromisses" und die Kennzahl "2 aufeinander abgestimmte
     Oele", ohne je nach einem Kompromiss gefragt zu haben.
     Alexander am 16.08.2026: "Das ist fuer einen Kunden keine
     vernuenftige Information. Warum sollte das Mestral Biooel mit
     einem anderen Oel zusammenarbeiten?"
     Ohne Zielkonflikt faellt die Frage jetzt durch bis zur
     Warengruppe "Olivenoel und Wuerzoel" - beziehungsweise zur
     Polyphenol- oder Sensorik-Antwort, wenn danach gefragt wird. */
  if(s.includes('polyphen') && /(mild|nicht so scharf|nicht scharf|wenig schärfe|ohne schärfe|nicht zu scharf|sanft|nicht bitter|nicht kratz)/.test(s)) return results.oils;
  if(/(zutat|palmöl|emulg|\baroma\b)/.test(s)) return results.ingredients;
  if(s.includes('getränk') || s.includes('getraenk') || s.includes('ungesüßt') || s.includes('ungesuesst') || s.includes('tee') || s.includes('kaltaufg') || s.includes('trinken') || s.includes('trinkt')) return results.tea;
  if(s.includes('schinken') && s.includes('salz')) return results.salt;
  if(/(genuss|geschmack|spitzenqualität|spitzenprodukt|premium|hochwertig|\bedel\b|feinschmecker|verwöhn)/.test(s)) return results.genuss;
  /* "Welche sind die besten Produkte in eurem Shop, die ich unbedingt
     probieren soll?" landete am 13.08.2026 in der Warengruppe "Sets und
     Geschenke" - allein wegen des Wortes "probier". Alexander: "Da geht
     es irgendwie klein los. Ich haette erwartet, der Schinken kommt."
     Der Schinkenwuerfel 10007 steht in der Spitzenqualitaet-Auswahl,
     die Frage erreichte sie nur nie.

     Zwei Fallen, die hier absichtlich umgangen werden:
     - "beste" steckt als Teilwort in "Bestellung". Deshalb eine eigene
       Grenzpruefung statt \b (siehe Abschnitt 0, Regel 3 und 4).
     - Steht eine Warengruppe im Satz ("welcher Honig ist der beste"),
       gewinnt die Warengruppe. Sonst wuerde jede Bestenfrage innerhalb
       einer Gruppe in der Spitzenqualitaet landen. */
  if(/(^|[^a-zäöüß])(beste[nrs]?|empfehlenswert|lieblings\w*|highlight\w*)($|[^a-zäöüß])/.test(s)
     && !gruppeGenannt(s)) return results.genuss;
  if(s.includes('snack') || s.includes('salz') || s.includes('abends') || s.includes('nüsse') || s.includes('nuss') || s.includes('pistaz') || s.includes('mandel')) return results.snack;
  return results.generic;
}
/* ---------------------------------------------------------------
   Produktebene - Schnappschuss der aktiven Artikel aus Shopify,
   abgerufen am 31.07.2026. Felder: s = Artikelnummer, t = Titel,
   p = Preis, k = Warengruppe, g = Shop-Tags, i = Bilddatei.
   Preise und Titel unveraendert aus dem Shop. Nichts geschaetzt.
   --------------------------------------------------------------- */
const IMG = 'https://cdn.shopify.com/s/files/1/0961/6336/5203/files/';
const PRODUKTE = [
/* Honig */
{s:'10001',k:'honig',t:'Blütenhonig der spanischen Sommerwiesen | 910-g-Glas',p:14.90,i:'Bluetenhonig.png?v=1764771334'},
{s:'10013',k:'honig',t:'Kräftiger Bergwaldhonig aus Spaniens Eichenwäldern | 910-g-Glas',p:17.90,i:'Bergbluetenhonig.png?v=1764771251'},
{s:'10003',k:'honig',t:'Duftender Lavendelhonig aus Spaniens Hochebene | 910-g-Glas',p:17.90,i:'Lavendelhonig.png?v=1764771283'},
{s:'10014',k:'honig',t:'Mediterraner Orangenblütenhonig | 910-g-Glas',p:17.90,i:'orangenbluetenhonig.png?v=1764771378'},
{s:'10004',k:'honig',t:'Duftender Zitronenblütenhonig | 910-g-Glas',p:17.90,i:'zitronenbluetenhonig-4.png?v=1764771205'},
{s:'10009',k:'honig',t:'Garrigue-Wildkräuterhonig aus Spaniens Mittelmeerbuschland | 910-g-Glas',p:17.90,i:'Wildkraeuterhonig.png?v=1764771415'},
{s:'10002',k:'honig',t:'Cremiger Heidehonig aus Spaniens Bergheiden | 910-g-Glas',p:20.90,i:'Heidehonig.png?v=1764771449'},
/* Olivenoel und Wuerzoel
   Optionale Polyphenol-Felder, ergaenzt am 13.08.2026: poly_min,
   poly_max, poly_beleg. Bisher stand die Zahl nur als Text im
   Produkttitel und war damit nicht rechenbar - sortieren liess sich
   nichts. Nur die drei Oele, fuer die ueberhaupt eine Zahl vorliegt,
   bekommen die Felder; die sechs anderen bleiben bewusst ohne Feld,
   damit "kein Wert" nicht als 0 gerechnet wird. Fehlt poly_max, ist
   die Angabe ein Einzelwert ohne Spanne (10021: "ca. 271 mg/kg").
   Belegstufe C = Herstellerangabe ohne Analyse, B = eigener Shop-Text.
   Der ausfuehrliche Nachweis je Artikel steht in POLYPHENOL
   (schicht2.js), nicht hier. */
{s:'10021',k:'oel',t:'Bio-Olivenöl nativ extra Mestral Arbequina | Kaltgepresst | 3 L',p:58.00,i:'mestral-bio-olivenol-photoroom.webp?v=1773324133',poly_min:271,poly_beleg:'B'},
{s:'10019',k:'oel',t:'Premium-Olivenöl nativ extra Mestral Arbequina | Polyphenolreich | 3 L',p:53.00,i:'olivenoel-mestral-2.png?v=1764760855'},
{s:'10020',k:'oel',t:'Olivenöl nativ extra Cuvée „Gota de Oro“ | 1 L Glasflasche',p:15.90,i:'gota_de_oro_5.png?v=1765802594',poly_min:231,poly_beleg:'B'},
{s:'10107',k:'oel',t:'Holiston Ultra Premium Olivenöl nativ extra | Rhodos | 900–1800 mg/kg Polyphenole | 500 ml',p:55.00,i:'HOLISTON_ULTRA1.jpg?v=1774274364',spitze:1,poly_min:900,poly_max:1800,poly_beleg:'C'},
{s:'10108',k:'oel',t:'Holiston Premium Olivenöl nativ extra | Rhodos | 600–1.000 mg/kg Polyphenole | 500 ml',p:44.90,i:'HOLISTON_PREMIUM.jpg?v=1774274317',spitze:1,poly_min:600,poly_max:1000,poly_beleg:'C'},
{s:'10162',k:'oel',t:'Bio-Olivenöl nativ extra »Nature’s Blend« von Eleology | 500 ml',p:20.90,i:'nature-blend-front.png?v=1775805071',spitze:1},
{s:'10163',k:'oel',t:'Bio-Olivenöl nativ extra »Chef’s Table« von Eleology | 5-Liter-Dose',p:95.00,i:'chefs-table-front_8d98d8e2-2ecf-4e49-93a3-3ed9f15c590e.png?v=1775807036'},
{s:'10016',k:'oel',t:'Edles Würzöl mit schwarzem Trüffel | 250 ml',p:10.90,i:'aceite_con_trufa.jpg?v=1761663028'},
{s:'10017',k:'oel',t:'Gourmet-Würzöl mit fermentiertem schwarzem Knoblauch | 250 ml',p:10.90,i:'aceite_ajo_negro.jpg?v=1761659235'},
/* Tafeloliven, kein Oel. Standen bis 13.08.2026 unter k:'oel' und
   waren damit fuer jede Oel-Frage der billigste Treffer - "euer
   billigstes Olivenoel" haette 4,90 Euro Tafeloliven geliefert.
   Aufgefallen, als die Preisantworten von der Teilliste CATALOG auf
   den vollen Bestand umgestellt wurden; CATALOG hatte den Unterschied
   schon vermerkt ("Tafeloliven, kein Öl"), PRODUKTE nicht. */
{s:'10172',k:'oliven',t:'Arbequina-Oliven Mestral | mild, fein-fruchtig | 440 g',p:4.90,i:'BO000370_8957f6a0-d52e-4280-bdb5-f41062001587.jpg?v=1779394539'},
/* Essig und Balsamico */
{s:'10029',k:'essig',t:'Bio Aceto Balsamico di Modena | 1 Silbermedaille | 250 ml',p:17.90,i:'112-1MedagliaArgentoBiologicochampagnotta250ml_550x_e25397a2-3b1f-4cb6-9198-71d950504f85.webp?v=1771316308'},
{s:'10030',k:'essig',t:'Bio Aceto Balsamico di Modena | 2 Goldmedaillen | 250 ml',p:22.90,i:'212-2Medaglied_OroBiologicochampagnotta250ml_550x_cc39e80c-d297-4827-a0b3-1747d5a0b104.webp?v=1771316641'},
{s:'10031',k:'essig',t:'Bio Aceto Balsamico di Modena | 3 Goldmedaillen | 250 ml',p:31.90,i:'312-Biologico3Medagliechampagnotta250ml_550x_22aa7a6e-3d2d-4f31-82fb-719ee00e36fd.webp?v=1771316890',spitze:1},
{s:'10056',k:'essig',t:'Aceto Balsamico di Modena | 4 Goldmedaillen | 250 ml',p:37.90,i:'410A.011GT_1100x_d82b97d9-9c79-4e37-a33e-7d47e5c455d4.png?v=1772535940',spitze:1},
{s:'10018',k:'essig',t:'Aromastarker Chardonnay-Balsamico-Essig „Aragem“ | 250 ml',p:12.90,i:'Balsamic_CH_12fd0a75-0479-4300-b393-8ba14564a1a7.jpg?v=1761581105'},
{s:'10032',k:'essig',t:'Essigspezialität mit Aceto Balsamico di Modena und Trüffel | 100 ml',p:17.90,i:'880-A-Aromatizzatoaltartufo100ml_550x_f502695f-05df-45d5-9179-86d0f876c988.webp?v=1771318121',spitze:1},
{s:'10036',k:'essig',t:'Condimento Agrodolce Bianco | Weiße Essigspezialität | 250 ml',p:15.50,i:'1015.011GT_1100x_ce33843b-627b-4dcc-ba6e-8e353034abd3.png?v=1771319484'},
{s:'10038',k:'essig',t:'Süßsauer „Agrodolce mit Früchten“ Dressing | 250 ml',p:14.90,i:'1440-AgrodolcealloZenzero_550x_2faabcc6-c5db-4162-af30-4003c031b9d2.webp?v=1771319799'},
{s:'10083',k:'essig',t:'Essigcreme Balsamico di Modena | cremig | 250 ml',p:10.90,i:'acetaia-giusti-balsamico-creme.webp?v=1773653714'},
{s:'10033',k:'essig',t:'Saba | gekochter Traubenmost als natürlicher Süßstoff | 250 ml',p:15.90,i:'737-Saba250ml_550x_7feff136-d35f-48b3-b6bf-912f5292494c.webp?v=1771318191'},
/* Iberico Schinken */
{s:'10007',k:'schinken',t:'Entbeinter Schinkenwürfel (Lingote) aus Hinterschinken | ca. 450 g',p:107.00,i:'regalo_lingote_con_platorgbe29e574dce293d6c44bc66d276c2d3f63f41d4b8b2ff8c061f54dbb26831e249f5221965298d85fd7f4d7a8d1def74ae6a2f68e95ff48f2e7737cb99.jpg?v=1773924518',spitze:1},
{s:'10006',k:'schinken',t:'Exklusives Verkostungsset – Jamón, Paleta, Lomo & Presa 100 % Ibérico Bellota',p:67.00,i:'regalo_ritual4_4ases_rgbbf6502d4b3b834f37c3433d69ff88494ae34960edf1c1d0c493a338ae73577a4c68e0319ba1c71a5d520d30968704058641d33d593aaec5c889e7684.jpg?v=1763561245'},
{s:'10015',k:'schinken',t:'Lomo | Wurst aus Schweinelende | halbe Lendenstange',p:51.00,i:'plp-presa-13949faa06c034cbfb21c80212197cc81f95942ff.jpg?v=1773924453'},
{s:'10012',k:'schinken',t:'36 Monate gereifter Vorderschinken (Paleta) 100 % Ibérico Bellota',p:335.00,i:'paletadeshuesadaplatoycajaf3a23c44630e97bb8ef709c575dddc98b4c2d3e1.jpg?v=1773924516'},
{s:'10010',k:'schinken',t:'Handentbeinter Jamón in 3 einzeln verpackten Stücken',p:559.00,i:'jamon_deshuesado_3_piezas_con_caja4eef96a8704e79ba46522105e829975caba7209b3f353950f1bfbe9e74de97297688f46fcb6bcb99_1.jpg?v=1763646996'},
{s:'10000',k:'schinken',t:'60 Monate fein gereifter Hinterschinken | Bellota | 100 % Ibérico',p:625.00,i:'vig5470ff78f70c780d7b78d581fb3a195417be403bc88a_72512d90-400b-48f2-bc5c-b52f83feaa35.jpg?v=1763566934'},
/* Nuesse */
{s:'10125',k:'nuss',t:'Rohkost Bio Nussmischung Pur von Keimling | 200 g',p:8.90,i:'19994_DOY_Nuss-Mix-Pur_L_01.webp?v=1773060511'},
{s:'10126',k:'nuss',t:'Bio Walnusskerne von Keimling | 250 g',p:10.90,i:'2895__01__Walnusskerne_1920x1920_FRONT.webp?v=1773059885'},
{s:'10128',k:'nuss',t:'Bio Macadamia Nüsse von Keimling | Rohkost | 250 g',p:19.90,i:'2800__01__Macadamiansse_ganze-Kern_1920x1920_FRONT.webp?v=1773060230'},
{s:'10127',k:'nuss',t:'Rohkost Bio Cashew-Stücke von Keimling | 1 kg',p:27.90,i:'28227__01__Cashewstuecke_1kg_Doypack_1920x1920_5fdda0d3-eeaa-46be-bd34-50adf71a3e6e.webp?v=1773058027'},
{s:'10240',k:'nuss',t:'Premium-Pekannusshälften Mammoth von Pecango',p:34.90,i:'pekannuss.jpg?v=1774266903',spitze:1},
{s:'10185',k:'nuss',t:'SaarNuss Bio-Erdnüsse in der Schale | 1 kg',p:5.90,i:'Professional-e-commerce-product-photograph-of-raw-unshelled-peanuts-some-peanut.jpg?v=1782901354'},
{s:'10167',k:'nuss',t:'Bio-Pistazien geröstet & ungesalzen von LaLola1947 | 1 kg',p:30.90,i:'TostadoSinSal_Cuadrado-600x600.jpg?v=1777274510',spitze:1},
{s:'10168',k:'nuss',t:'Bio-Pistazien geröstet & gesalzen von LaLola1947 | 1 kg',p:30.90,i:'TostadoConSal_Cuadrado-600x600.jpg?v=1777271387',spitze:1},
{s:'10169',k:'nuss',t:'Bio-Pistazienkerne geschält von LaLola1947 | 1 kg',p:49.90,i:'Mondado_Cuadrado-600x600.jpg?v=1777294681',spitze:1},
{s:'10051',k:'nuss',t:'Borduito geschälte Mandeln aus Apulien | 1 kg',p:23.90,i:'Borduito_pelate2-600x600.jpg?v=1772720566'},
{s:'10054',k:'nuss',t:'Borduito ganze Mandeln geröstet | Bio | 1 kg',p:24.90,i:'Borduito_sgusciate-2.jpg?v=1772720070'},
{s:'10063',k:'nuss',t:'Borduito geschälte und geröstete Mandeln | 1 kg',p:24.90,i:'Borduito_pelate2-600x600.jpg?v=1772720566'},
{s:'10064',k:'nuss',t:'Borduito ungeschälte Mandeln Natur | 1 kg',p:21.90,i:'Borduito_sgusciate-2-600x600_59a24f16-b5d2-4671-bc54-644c415b5a6f.jpg?v=1772725643'},
{s:'10053',k:'nuss',t:'Borduito gehackte Mandeln aus Apulien | 1 kg',p:23.90,i:'Borduito_granella-pelate2-600x600.jpg?v=1772721160',kein_snack:1},
{s:'10052',k:'nuss',t:'Borduito geschältes Mandelmehl aus Apulien | 1 kg',p:23.90,i:'Borduito_farina-pelate1-600x600.jpg?v=1772717642',kein_snack:1},
{s:'10058',k:'saat',t:'Leinsamen von Sölls Hof | Schwäbische Alb | 1 kg',p:9.90,i:'leinsamen1kg.webp?v=1772809227',kein_snack:1},
{s:'10059',k:'saat',t:'Chiasamen von Sölls Hof | Schwäbische Alb | 1 kg',p:19.90,i:'chiasamen.webp?v=1772812073',kein_snack:1},
{s:'10060',k:'saat',t:'Quinoa von Sölls Hof | Schwäbische Alb | 500 g',p:12.90,i:'quinoa.webp?v=1773071529',kein_snack:1},
{s:'10061',k:'saat',t:'Sölls Hof Geschenkset Saatenpäckle | 4 Saaten | 800 g',p:24.90,i:'Geschenkbox.webp?v=1773145797',kein_snack:1},
/* Trockenfruechte */
{s:'10067',k:'trockenfrucht',t:'Datteln Medjool Giant | Bio-Jumbo-Datteln mit Stein',p:8.90,i:'1010__01__Datteln-Medjool__1920x1920_FRONT.webp?v=1773046182'},
{s:'—',k:'trockenfrucht',t:'Premium Large Bio-Medjool-Datteln »Rift Valley« | 1 kg',p:19.90,i:'Saskia_Datteln4.png?v=1781631837'},
{s:'10069',k:'trockenfrucht',t:'Mango Kent Supreme | Bio-Mango-Streifen sonnengereift | 500 g',p:17.90,i:'13023__01__Mango-Kent_1920x1920_9c56f679-696f-4052-82fb-f0b61c7ca7a9.webp?v=1773049417'},
{s:'10070',k:'trockenfrucht',t:'Getrocknete Bio Ananas-Stücke | First-Class aus Tansania | 400 g',p:18.90,i:'13204__01__Ananas-Stucke_1920x1920_ERWEITERT.webp?v=1773050947'},
{s:'10071',k:'trockenfrucht',t:'Bio Goji Beeren | Glücksbeeren aus China',p:12.90,i:'14300__01__Gojibeeren_1920x1920_FRONT.webp?v=1773052175'},
{s:'10072',k:'trockenfrucht',t:'Rohkost Bio Sauerkirschen aus Usbekistan',p:11.90,i:'1460__01__Sauerkirschen_1920x1920_FRONT.webp?v=1773053357'},
{s:'10073',k:'trockenfrucht',t:'Gefriergetrocknete Mango | 100 % Mango ohne Zusätze',p:21.90,i:'1801__01__Mango-gefriergetrocknet_1920x1920_FRONT.webp?v=1773054066'},
/* Schokolade */
{s:'10181',k:'schoko',t:'Bio-Zartbitterschokoladen Set von fairafric | 8 vegane Tafeln von 70 % bis 92 %',p:27.90,i:'DunkleSchokoladeSet.png?v=1774350541'},
{s:'10180',k:'schoko',t:'Bio Schokoladen & Frucht-Set von fairafric | 8 vegane Spezialitäten',p:30.90,i:'SchokoSetfairafric.png?v=1774362028'},
{s:'10179',k:'schoko',t:'Bunte Bio-Schokoladen Auswahl von fairafric | 8 Tafeln von cremig bis intensiv',p:27.90,i:'fairafricbunterMix.png?v=1774374177'},
{s:'10074',k:'schoko',t:'Rohkost Bio Konfekt Schoko Pur | Schoko-Kugeln ohne Zucker',p:15.90,i:'1720__01__Raw-Energy-Balls-Schoko-Pur_1920x1920_FRONT.webp?v=1773054955'},
{s:'10075',k:'schoko',t:'Rohkost Bio Konfekt Schoko-Walnuss | ohne Zucker & Milch',p:13.90,i:'1720__01__Raw-Energy-Balls-Schoko-Pur_1920x1920_FRONT.webp?v=1773054955'},
{s:'10076',k:'schoko',t:'Vegan Choco Bites Mango-Ananas | Bio-Edelkakao aus Peru',p:23.90,i:'1741__01__Vegan-Schoko-Bits-Mango-Ananas_1920x1920_FRONT.webp?v=1773055759'},
{s:'10129',k:'schoko',t:'Schoko-Datteln mit Mandel | Medjool Giant Bio umhüllt',p:25.90,i:'1745__01__Schokodatteln_1920x1920_FRONT.webp?v=1773057047'},
{s:'10028',k:'schoko',t:'Pralinen mit Balsamico-Essig aus Modena | 250 g',p:21.90,i:'G42-Ciocco250gr_550x_19775a71-eb71-41dd-9697-1879eb8ca22b.webp?v=1771314981'},
/* Gemueseriegel */
{s:'10245',k:'riegel',t:'Mediterraner Tomaten-Riegel | Bio-Tomate mit Kräutern & Saaten',p:9.90,i:'malunt_tomate.png?v=1781179357'},
{s:'10248',k:'riegel',t:'Pikante Paprika Riegel | Bio-Paprika mit Chili & Saaten',p:9.90,i:'Pikante_Paprika_ohne_12Riegel.png?v=1781181324'},
{s:'10251',k:'riegel',t:'Gerösteter Karotten-Riegel | Bio-Karotte mit Curry & Sesam',p:9.90,i:'Geroestete_Karotte_ohne_12Riegel.png?v=1781181390'},
{s:'10254',k:'riegel',t:'Würziger Kürbis Riegel | Bio-Kürbis mit Zwiebel & Kurkuma',p:9.90,i:'Wuerziger_Kuerbis.png?v=1781181521'},
{s:'10257',k:'riegel',t:'Gekräuterte Rote Bete Riegel | Bio-Gemüsepower mit Kräutern',p:9.90,i:'Gekraeuterte_Rote_Bete_ohne_12Riegel.png?v=1781181429'},
/* Nussmus */
{s:'10091',k:'nussmus',t:'Borduito Bio weiße Mandelcreme | 500 g',p:17.90,i:'Borduitonewfebbraio20269.png?v=1773668781'},
{s:'10153',k:'nussmus',t:'Borduito Bio braune Mandelcreme | 500 g',p:18.90,i:'Borduitonewfebbraio202610.png?v=1773670029'},
{s:'10165',k:'nussmus',t:'Bio-Pistazienmus von LaLola1947 | 200 g',p:22.90,i:'Pasta_Cuadrado-600x600.jpg?v=1777270713'},
{s:'10123',k:'nussmus',t:'Pistaziencreme von LaLola1947 | 15 % Pistazien',p:10.90,i:'Untable_Pistacho.jpg?v=1774365805'},
/* Getrocknete Tomaten */
{s:'10044',k:'tomate',t:'Capuliato „Ciappa“ | Bio-Tomaten fein gehackt | 350 g',p:9.90,i:'capuliato-pomodori-secchi-tritati-bio-in-buste-da-500-g.jpg?v=1772110660'},
{s:'10045',k:'tomate',t:'Capuliato „Ciappa“ | Bio-Kirschtomaten | 400 g',p:15.90,i:'ciliegino-essiccato-bio-in-buste-da-500-gr.jpg?v=1772112301'},
{s:'10046',k:'tomate',t:'Julienne „Ciappa“ | Bio-Tomatenstreifen | 350 g',p:9.90,i:'julienne-organic-sun-dried-chopped-toamatoes-packaging-420-g.jpg?v=1772112845'},
{s:'10047',k:'tomate',t:'Datterini „Ciappa“ | Bio-Datterini-Tomaten | 400 g',p:15.90,i:'organic-sun-dried-datterini-tomatoes-packaging-400-g-ciappa.jpg?v=1772113373'},
/* Fruchtgummi und Suesses */
{s:'10090',k:'suesses',t:'Fruchtgummi Mix-Set | 6 zuckerarme Sorten | 6 x 100 g',p:19.90,i:'Zuckerarme-Fruchtgummis-Rockets-Nutrition-6er-Bundle-Ansicht-mit-HG-Gelb_1920x1920_d608af23-a4bd-41ee-826a-72517c137370.webp?v=1774355109'},
{s:'10171',k:'suesses',t:'Bio Kaffee Fruchtgummi | Kaffee- & Guarana-Extrakt | 8 x 100 g',p:11.90,i:'260114_Rockets-Kaffee-Bio-Fruchtgummi_1920x1920_d4f2603d-d623-4c80-98d3-c23bd29e981c.webp?v=1774617310',koffein:1},
{s:'10170',k:'suesses',t:'Bio Vitamin C Fruchtgummi | Zuckerarm | 8 x 100 g',p:11.90,i:'Vitamin-C-Fruchtgummi-1920x1920_1920x1920_4e7c85f0-418d-4310-9a54-7298a7eef4fe.webp?v=1772473061',kein_snack:1},
{s:'10042',k:'suesses',t:'Italienischer Osterkuchen mit Aceto Balsamico di Modena IGP | 1 kg',p:39.90,i:'G18-ColombaGiusti_2_550x_b3dd7a63-2254-481f-ba16-64f286a48d34.webp?v=1771323233'},
/* Tee - KEIKO */
{s:'10130',k:'tee',t:'Kabuse Soshun | Japanischer Bio-Grüntee aus Schattenanbau',p:23.90,i:'15566-3_kabuse-soshun_2023-12-22_600x600_d75d8a9c-00f8-478a-9e57-d2b0be26cf11.webp?v=1774513817',koffein:1},
{s:'10154',k:'tee',t:'Kabuse No. 1 | Japanischer Bio-Grüntee aus Schattenanbau',p:13.90,i:'13460-3_kabuse-no1_2023-12-22_600x600_b4f9a123-f20a-4f42-a715-06f4e22c7c5f.webp?v=1774515419',koffein:1},
{s:'10155',k:'tee',t:'Easy Ice Tea Kabuse | Bio-Grüntee mit Matcha | heiß & kalt',p:12.90,i:'13446-1_Easy-Ice-Tea_2024-01-18.webp?v=1774519277',koffein:1,kalt:1},
{s:'10132',k:'tee',t:'Ingwer-Zitronen Bancha | Japanischer Bio-Grüntee',p:8.90,i:'19763_keiko_ingwer-zitronen-bancha_600x600_3a0c41be-5acd-4663-9e77-931d1f812a93.webp?v=1774521218',koffein:1,kalt:1,zutat:'ingwer zitrone'},
{s:'10156',k:'tee',t:'Hojicha | Gerösteter Bio-Grüntee aus Japan',p:13.90,i:'18735.1_Kabuse-Hojicha_600x600_8a669822-d81e-478a-8929-2dbddf7ffd2c.png?v=1775724391',koffein:1,kalt:1},
{s:'10243',k:'tee',t:'Shincha Classic | Kabuse Sencha, Bio Japan Grüntee | Frühjahrsernte',p:24.50,i:'16646.1_Kabuse-Shincha-Classic_992111c7-75ae-4b6f-85ad-49fd6c04df32.png?v=1783072601',koffein:1},
{s:'10137',k:'tee',t:'Yakushima Wakoucha | Japanischer Bio-Schwarztee',p:19.90,i:'14387_keiko_schwarztee_yakushima_600x600_47b768d2-0594-4642-b13a-a4743d27f0ba.webp?v=1774524801',koffein:1},
{s:'10133',k:'matcha',t:'Matcha Loving Latte | Bio-Matcha-Pulver',p:16.90,i:'29543.2_Keiko_Matcha-Loving-Latte_50g_600x600_ad3a9007-929d-4222-a611-3d513c609088.png?v=1774521490',koffein:1},
{s:'10134',k:'matcha',t:'Matcha Benifuuki Chai | Bio-Grüntee-Pulver mit Chai-Gewürzen',p:14.90,i:'24124.2_Keiko_Matcha-Benifuuki-Chai_50g.png?v=1774521963',koffein:1},
{s:'10135',k:'matcha',t:'Matcha Mantoku | Bio-Matcha-Pulver, geröstet',p:39.00,i:'21012-1matcha-mantoku_600x600_5eb06b8c-25c9-4270-b210-b16bdd69fb9c.webp?v=1774522150',koffein:1},
{s:'10138',k:'matcha',t:'Premium Bio Matcha | Bio-Matcha-Pulver',p:29.90,i:'21356-1matcha-premium_600x600_f415e2ef-4ec0-444d-83ac-31d9d94006e1.webp?v=1774526376',koffein:1},
/* Tee - samova */
{s:'10209',k:'tee',t:'samova Bio-Kamillentee »Smooth Operator« | 100 % ganze Bio-Kamillenblüten',p:4.95,i:'smooth_operator_space_box_perspektive_webshop.jpg?v=1780240377',zutat:'kamille'},
{s:'10206',k:'tee',t:'samova Bio-Kräutertee »Gin Soul« | Wacholder, Lavendel & Rosenblüte',p:12.95,i:'gin-soul-space-front-webshop.jpg?v=1780398494',kalt:1,zutat:'lavendel'},
{s:'10200',k:'tee',t:'samova Bio-Kräutertee »Master Mint« | reine Pfefferminze',p:4.95,i:'master_mint_space_box_perspektive_webshop.jpg?v=1780398723',kalt:1,zutat:'minze'},
{s:'10197',k:'tee',t:'samova Bio-Kräutertee »Heidi’s Delight« | Schweizer Bergkräuter, minzig',p:4.95,i:'heidis_delight_space_box_perspektive_webshop.jpg?v=1780398708',kalt:1,zutat:'minze'},
{s:'10208',k:'tee',t:'samova Bio-Rooibos »Orange Safari« | koffeinfrei mit Orange & Vanille',p:4.95,i:'orange_safari_space_box_perspektive_webshop.jpg?v=1780240237',kalt:1},
{s:'10196',k:'tee',t:'samova Bio-Rooibos »Scuba Garden« | Spirulina, Cranberry & Orange',p:4.95,i:'scuba_garden_space_box_perspektive_webshop.jpg?v=1780398702',kalt:1},
{s:'10212',k:'tee',t:'samova Bio-Rooibos »Karibu Sun« | wärmende Gewürze & Zimt',p:12.95,i:'karibu_sun_space_box_perspektive_webshop.jpg?v=1780398958',kalt:1},
{s:'10198',k:'tee',t:'samova Bio-Gewürztee »Space Cookie« | Chai-Komposition mit Kakao',p:4.95,i:'space_cookies_space_box_perspektive_webshop.jpg?v=1780398713'},
{s:'10194',k:'tee',t:'samova Bio-Früchtetee »Maybe Baby« | fruchtig-süß, von Natur aus rot',p:4.95,i:'maybe_baby_space_box_perspektive_webshop.jpg?v=1780398691',kalt:1},
{s:'10205',k:'tee',t:'samova Bio-Früchtetee »Garden Party« | Apfel, Mango & Goji',p:12.95,i:'garden_party_space_box_perspektive_webshop.jpg?v=1780398968',kalt:1},
{s:'10226',k:'tee',t:'samova Bio-Früchtetee »Digital Detox Express« | fruchtig-herb',p:4.95,i:'digital_detox_express_perpektive_webshop_e17ccb49-42f0-4fbc-90ec-ecc7603cb3c0.jpg?v=1780994906',kalt:1},
{s:'10230',k:'tee',t:'samova Bio-Kräutertee »Saint Peter’s Express« | Nordsee-Komposition',p:4.95,i:'saint_peters_express_perpektive_webshop_4607f927-60cb-40b9-9000-fbb9a6664d18.jpg?v=1780994914',kalt:1},
{s:'10207',k:'tee',t:'samova Bio-Kräuter-Grüntee »Inner Light« | Zitronengras & Ingwer',p:4.95,i:'inner_light_space_box_perspektive_webshop.jpg?v=1780240067',koffein:1,zutat:'ingwer'},
{s:'10191',k:'tee',t:'samova Bio-Grüntee »Team Spirit« | Lemongrass & weißer Tee',p:4.95,i:'team_spirit_space_box_perspektive_webshop.jpg?v=1780225634',koffein:1,kalt:1},
{s:'10199',k:'tee',t:'samova Bio-Grüntee »Low Rider« | sanfter Kukicha Karigane',p:4.95,i:'low_rider_space_box_perspektive_webshop.jpg?v=1780398717',koffein:1},
{s:'10202',k:'tee',t:'samova Bio-Grüntee »Jasmine Green« | blumiger Jasmin aus China',p:12.95,i:'jasmine_green_space_box_perspektive_webshop.jpg?v=1780398732',koffein:1},
{s:'10195',k:'tee',t:'samova Bio-Schwarztee »Istanbul Nights« | Schwarztee & Minze',p:4.95,i:'istanbul_nights_space_box_perspektive_webshop.jpg?v=1780398696',koffein:1,kalt:1,zutat:'minze'},
{s:'10201',k:'tee',t:'samova Bio-Schwarztee »English Breakfast« | Assam-Ceylon-Mischung',p:4.95,i:'english_breakfast_space_box_perspektive_webshop.jpg?v=1780398728',koffein:1,kalt:1},
{s:'10192',k:'tee',t:'samova Bio-Schwarztee »High Darling« | Bio-Darjeeling aus dem Hochland',p:4.95,i:'high_darling_space_box_perspektive_webshop.jpg?v=1780399186',koffein:1,kalt:1},
{s:'10214',k:'tee',t:'samova Bio-Schwarztee »Lazy Daze« | reine Earl Grey Komposition',p:4.95,i:'lazy_daze_space_box_perspektive_webshop.jpg?v=1781006127',koffein:1},
{s:'10229',k:'tee',t:'samova Bio-Schwarztee »Business Trip Express« | reiner Bio-Ceylon',p:4.95,i:'business_trip_express_perpektive_webshop_3af03ca1-2845-47b7-a2b6-98de93cfdbad.jpg?v=1780994910',koffein:1,kalt:1},
{s:'10210',k:'tee',t:'samova Bio-Schwarztee »Straight Forward« | kräftiger Assam pur',p:12.95,i:'straight-forward-space-webshop.jpg?v=1780402589',koffein:1},
{s:'10204',k:'tee',t:'samova Bio-Schwarztee »Rodeo Rose« | Guarana & Rosenblüten',p:12.95,i:'rodeo_rose_space_box_perspektive_webshop.jpg?v=1780398961',koffein:1,kalt:1},
{s:'10211',k:'tee',t:'samova »Tea Tasting« | Probier-Set mit 20 Sorten',p:4.95,i:'tea-tasting-space-front-webshop.jpg?v=1780240523'},
{s:'10234',k:'tee',t:'samova »Tasting-Box 3er« | Bio-Tee-Geschenkset',p:19.95,i:'3er_tasting_box_geschenk.jpg?v=1782905434'},
{s:'10235',k:'tee',t:'samova »Tasting-Box 6er« | Bio-Tee-Geschenkset',p:34.95,i:'tea-tasting-6er-mini-open.jpg?v=1782905433'},
/* Nahrungsergaenzung - nur ueber ausdrueckliche Nachfrage erreichbar */
{s:'10150',k:'erg',t:'Vitamin D3 K2 Kapseln | 5000 IE D3 + 200 µg K2 MK-7 | 60 Kapseln',p:14.90,i:'VitaminD3K2Kapseln.webp?v=1776163503'},
{s:'10143',k:'erg',t:'Magnesium Komplex Kapseln | 7 Mg-Verbindungen | laborgeprüft',p:29.90,i:'magnesium.webp?v=1775137048'},
{s:'10140',k:'erg',t:'Coenzym Q10 Kapseln | 100 mg CavaQ10® | 30-Tage-Vorrat',p:29.90,i:'q10.webp?v=1775134957'},
{s:'10142',k:'erg',t:'Kreatin-Pulver | Creavitalis® Monohydrat > 99,9 % | 300 g',p:25.90,i:'kreatin.webp?v=1775136965'},
{s:'10147',k:'erg',t:'Spermidin PRO Kapseln | 6 mg | 60 Kapseln',p:49.90,i:'spermidinpro.webp?v=1776163111'},
{s:'10152',k:'erg',t:'Dr. Jacob’s Vitamin-B-Komplex | 120 Kapseln',p:19.90,i:'NBK-1_800x800_e932894a-8b5b-468a-b93d-aceff48c23cc.webp?v=1775549917'},
{s:'10103',k:'erg',t:'Dr. Jacob’s Vitamin D3K2 Öl | 20 ml',p:19.95,i:'ND3K2-1_800x800_4a4dd604-1ffc-42b0-ac1b-dcda77541654.webp?v=1773823261'},
{s:'10105',k:'erg',t:'Q10 Synergie | 80 g',p:32.50,i:'NQ10-1_800x800_83c26aeb-12f2-4a8d-b44e-a5f0ac242a7a.webp?v=1773824099'},
{s:'10043',k:'erg',t:'Biowiema Bio-Vitalstoffkomplex | 500 ml',p:60.00,i:'BiowiemaVitalstoffkomplex.png?v=1771850932'},
{s:'10149',k:'erg',t:'Vitamin D Testkit | Trockenblut-Analyse für zu Hause',p:29.90,i:'TestVitaminD.webp?v=1776167767'},
/* Sets und Geschenke */
{s:'WV-101',k:'set',t:'Spanische Honigvielfalt | 7 Sorten, 6,37 kg',p:110.00,i:'Honig-Komplettset_7er_von_Miel_del_tio_Juan_Cruz_Alle_Sorten_6da76b86-7c89-4bec-a3f4-a6e99491c52f.png?v=1784737488'},
{s:'WV-102',k:'set',t:'Honig-Trio | 3 Sorten je 910 g | Sommerwiese · Zitronenblüte · Lavendel',p:45.90,i:'render_bec2aa42-edec-4397-bf87-f863dfbc5f8d.jpg?v=1784906001'},
{s:'WV-902',k:'set',t:'KEIKO Grüntee-Kennenlernset aus Japan | drei Charaktere',p:35.00,i:'KEIKO_Gruentee-Kennenlernset_aus_Japan_971d9d74-71ca-439a-ace3-b51fa57d2936.png?v=1784735776',spitze:1},
{s:'WV-901',k:'set',t:'KEIKO Matcha-Entdeckerset aus Japan | drei Stilrichtungen',p:62.00,i:'KEIKO_Matcha-Entdeckerset_aus_Japan_Premium_Bio_Matcha_d77562ec-b551-4548-90a3-2e04920f8a8c.png?v=1784735772',spitze:1},
{s:'WV-1101',k:'set',t:'Gemüseriegel-Sortimentsbox | 5 Sorten à 4 Riegel',p:43.90,i:'render_ab66677a-d41b-4956-b280-3e1e000788e9.jpg?v=1784906087'},
{s:'WV-1209',k:'set',t:'Natürliches Frühstück | Basis-Set | Datteln + Mandeln + Mandelcreme',p:53.90,i:'render_6e284b84-5cea-40b2-acb8-e9e398eff04d.jpg?v=1784906023'},
{s:'WV-201',k:'set',t:'Giusti Medaillen-Quartett | Aceto Balsamico di Modena IGP | 4 × 250 ml',p:90.00,i:'Giusti_Goldmedaillen-Vertikale_Aceto_Balsamico_di_Modena_IGP_7aeb0055-1a4d-439c-989d-80221a7f24a1.png?v=1784741735'},
{s:'WV-202',k:'set',t:'Giusti Bio-Balsamico Trio | drei Reifestufen | 3 × 250 ml',p:61.00,i:'Giusti_Bio-Balsamico_Trio_1b26c4aa-a47d-4d9b-abbe-535afaa0996c.png?v=1784741740'},
{s:'WV-501',k:'set',t:'Borduito Mandeln-Sortiment Komplett | 5 Sorten | 5 × 1 kg',p:88.00,i:'Borduito_Mandeln-Sortiment_Komplett_aus_Apulien_2_61a9d543-d7ef-43b3-ab9a-99fc0997e430.png?v=1784742039'},
{s:'WV-602',k:'set',t:'LaLola1947 Pistazien Snack-Trio | 3 Bestseller im Set',p:58.00,i:'LaLola1947_Pistazien_Snack-Trio_2_ff2b35b8-20d0-4d56-ab56-eb9635a7be59.png?v=1784732686'},
{s:'WV-1207',k:'set',t:'Genusspaket | Ibérico | Cuvée-Olivenöl „Gota de Oro“ | Bergblütenhonig',p:129.00,i:'eroeffnungsgenusspaket-5_482b8d47-4550-44b7-8511-7d887d55769b.png?v=1784733583'},
{s:'WV-1206',k:'set',t:'Gourmet-Kennenlernset | 3 L Bio-Olivenöl · 5J Ritual Nº4 · Zitronenblütenhonig',p:119.00,i:'Feinkostpaket_3eade05d-1ea9-4ce8-ad3c-40186bf49c51.png?v=1784737544'},
{s:'WV-303',k:'set',t:'Polyphenol-Power-Duo | Holiston Premium & Ultra Premium | 2 × 500 ml',p:84.90,i:'Polyphenol-Power-Duo_f42c838e-a7ff-446d-bf40-fd004d583a19.png?v=1784729463'},
/* Kollektion "Hochwertige Genuss-Sets" (Shop-Tag genussset). Alexander
   am 13.08.2026: "Bei den Geschenkpaketen faellt mir auf, dass die
   Kisten nicht da sind. Diese Holzkisten mit den verschiedenen
   Kollektionen - die muessen da rein als Geschenk auf jeden Fall."
   Live am 13.08.2026 geprueft: 10041 ist der EINZIGE Artikel im ganzen
   Shop mit einer Holzkiste. Suche nach Holzbox, Truhe, Geschenkkiste
   und Kollektion bleibt ohne Treffer. 10026 ist derselbe Dreier ohne
   Kiste, die 22 Euro Unterschied sind die Kiste. */
{s:'10041',k:'set',t:'Trio Holzkiste | 2,3 und 4 Goldmedaillen | Aceto Balsamico di Modena IGP',p:74.00,i:'1177-A-Tris23e4medaglie_1100x_ab171233-5aae-46e7-8bb5-9dd8b7e6a278.webp?v=1771323037',kiste:1},
{s:'10026',k:'set',t:'Giusti „Collezione Storica“ Trio-Set | 2–3–4 Goldmedaillen | Aceto Balsamico di Modena IGP',p:52.00,i:'1285-A-Tris2-3-4Medaglie100ml_1100x_48e4f65c-46ad-4a13-8d6b-ceb9b9663b72.webp?v=1771313829'},
{s:'10027',k:'set',t:'Tris Essigspezialitäten | Trüffel, Feige, Himbeere | Aceto Balsamico di Modena IGP',p:43.90,i:'1113A-TrisAromatizzati_1100x_d844dcd9-1c12-4fa1-9f64-c63d7aaa644c.webp?v=1771314021'}
];
PRODUKTE.forEach(p=>{p.i=IMG+p.i});

/* Fuellmenge aus dem Titel lesen. Nur eindeutige Muster, sonst nichts. */
function mengeAusTitel(t){
  const norm=s=>Number(String(s).replace(',','.'));
  let m=t.match(/(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(g|ml)\b/i);
  if(m) return {menge:Number(m[1])*norm(m[2]),einheit:m[3].toLowerCase()};
  m=t.match(/(\d+(?:[.,]\d+)?)\s*(kg|l)\b/i);
  if(m) return {menge:norm(m[1])*1000,einheit:m[2].toLowerCase()==='kg'?'g':'ml'};
  m=t.match(/(\d+(?:[.,]\d+)?)[-\s]*(g|ml)\b/i);
  if(m) return {menge:norm(m[1]),einheit:m[2].toLowerCase()};
  return null;
}
/* Grundpreis je Kilogramm bzw. Liter - so verlangt es die
   Preisangabenverordnung fuer Lebensmittel. */
function grundpreis(p){
  const f=mengeAusTitel(p.t);
  if(!f||!f.menge) return null;
  return {wert:p.p/f.menge*1000, einheit:f.einheit==='g'?'kg':'l'};
}
function zahl(n){
  const g=Math.abs(n)>=100?0:(Math.abs(n)>=10?1:2);
  return Number(n).toFixed(g).replace('.',',').replace(/,00?$/,'');
}

/* Warengruppen-Antwort: greift NUR, wenn keine Sperre und keine
   Fachregel gegriffen hat. Reihenfolge beachten - laengere Woerter
   zuerst, damit kein Teilwort ein anderes ueberdeckt. */
const WARENGRUPPEN = [
 /* Oel steht ganz vorn, weil eine Oel-Frage bis 16.08.2026 immer von
    classify() abgefangen wurde und die Warengruppe nie erreichte. Seit
    die Zwei-Oele-Loesung nur noch beim echten Zielkonflikt greift,
    braucht Oel hier einen eigenen Eintrag - sonst landet ein schlichtes
    "Olivenoel" in der Rueckfrage statt beim Sortiment.
    Eigene Grenzpruefung statt \b: "oel" und "öl" sind zu kurz, und ö
    gilt fuer JavaScript nicht als Wortzeichen (Abschnitt 0, Regel 4).
    "Oliven" ohne Oel trifft diesen Eintrag nicht - das faengt weiter
    unten der Tafeloliven-Eintrag. */
 {re:/(^|[^a-zäöüß])(olivenöl|olivenoel|würzöl|wuerzoel|öle|oele|öl|oel)($|[^a-zäöüß])/, k:'oel', label:'Olivenöl und Würzöl', hinweis:'Nativ extra heißt: nur mechanisch gepresst, ohne Wärme oder Lösungsmittel.'},
 {re:/(honig)/,                       k:'honig',        label:'Honig',                 hinweis:'Die Nährwerte sind bei allen Sorten gleich. Der Unterschied liegt im Geschmack.'},
 {re:/(balsamico|essig|aceto)/,       k:'essig',        label:'Essig und Balsamico',   hinweis:'Sortiert nach Reifestufe und Preis.'},
 {re:/(schinken|iberico|ibérico|jamon|jamón|lomo|paleta)/, k:'schinken', label:'Ibérico',  hinweis:'Vor dem Servieren auf Zimmertemperatur bringen.'},
 {re:/(matcha)/,                      k:'matcha',       label:'Matcha',                hinweis:'Alle Pulver enthalten Koffein.'},
 {re:/(schokolad|schoko|kakao|praline)/, k:'schoko',    label:'Schokolade',            hinweis:''},
 {re:/(riegel|gemüseriegel|gemueseriegel)/, k:'riegel', label:'Gemüseriegel',          hinweis:'Bei den Riegeln fehlt bisher das Stückgewicht, deshalb steht dort keine Zahl je Stück.'},
 {re:/(nussmus|mandelcreme|pistaziencreme|pistazienmus|aufstrich)/, k:'nussmus', label:'Nussmus und Cremes', hinweis:''},
 {re:/(dattel|medjool|trockenfrucht|trockenfrüchte|mango|ananas|goji|sauerkirsch)/, k:'trockenfrucht', label:'Trockenfrüchte', hinweis:''},
 {re:/(tomate|capuliato|datterini)/,  k:'tomate',       label:'Getrocknete Tomaten',   hinweis:''},
 /* Alexander am 15.08.2026: "Wenn ich Gemuese schreibe, kommen nur die
    Gemueseriegel, wir haben aber auch die getrockneten Tomaten."
    Steht NACH dem Riegel-Eintrag, damit "Gemueseriegel" weiter bei den
    Riegeln landet - "Gemuese" allein sammelt beide Gruppen ein. */
 {re:/(gemüse|gemuese)/,             ks:['riegel','tomate'], k:'gemuese', label:'Gemüse',      hinweis:'Gemüseriegel und getrocknete Tomaten — was im Sortiment aus Gemüse gemacht ist.'},
 /* Eigene Grenzpruefung statt \b: "Olivenöl" enthaelt "oliven", und ein
    "ö" gilt fuer JavaScript nicht als Wortzeichen (Abschnitt 0, Regel 4). */
 {re:/(^|[^a-zäöüß])(tafeloliven|oliven)($|[^a-zäöüß])/, k:'oliven', label:'Tafeloliven', hinweis:'Tafeloliven zum Essen, kein Öl.'},
 {re:/(fruchtgummi)/,                 k:'suesses',      label:'Fruchtgummi und Süßes', hinweis:''},
 /* "Boxen", "Kiste" und "verschenken" fehlten bis 13.08.2026 - eine
    Frage nach "Geschenkpakete oder Boxen" traf nur ueber "geschenk". */
 {re:/(geschenk|\bset\b|sets|probier|paket|box|boxen|kiste|holzkiste|präsent|praesent|mitbringsel|verschenk)/, k:'set',  label:'Sets und Geschenke',    hinweis:'Bei Sets zählt der Preis des Sets, nicht die Summe der Einzelteile.'},
 {re:/(vitamin|magnesium|kapsel|supplement|nahrungsergänzung|nahrungsergaenzung)/, k:'erg', label:'Nahrungsergänzung', hinweis:'Angaben je Kapsel oder Portion stehen auf dem Etikett.'},
 {re:/(saat|leinsamen|chia|quinoa)/,  k:'saat',         label:'Saaten',                hinweis:''}
];
/* "probieren" und "Paket" sind weiche Woerter: sie stehen in der
   Set-Regel, meinen aber im Satz oft gar keine Warengruppe ("die ich
   unbedingt probieren soll"). Fuer die Frage, OB eine Warengruppe
   genannt wurde, zaehlen sie deshalb nicht allein. Die Warengruppen-
   Antwort selbst greift weiter darauf zu. Gefunden 13.08.2026. */
const WEICHE_GRUPPENWOERTER = /probier\w*|paket\w*/g;
function gruppeVon(s){
  const hart = (s||'').replace(WEICHE_GRUPPENWOERTER,' ');
  return WARENGRUPPEN.find(w=>w.re.test(hart)) || null;
}
function gruppeGenannt(s){ return gruppeVon(s)!==null; }

/* Geschmackswoerter, die in der Frage stehen koennen. Gefiltert wird
   nur damit, wenn das Wort auch an einem Artikel steht. Sonst sagt die
   Antwort, dass es noch nicht filterbar ist - statt 0 Treffer. */
const GESCHMACK=/(mild|kräftig|cremig|flüssig|duftend|blumig|fruchtig|floral|zitrusfrisch|kräuterig|balsamisch|malzig|harzig|mineralisch|vielschichtig|feinkristallin|feincremig|feinkörnig|grobkörnig|herb|süß|würzig|geröstet|mediterran|säuerlich|ungesalzen|gesalzen|geschält|polyphenolreich|kaltgepresst|minzig|karamellig|natur)/g;

function warengruppenAntwort(s){
  const w = WARENGRUPPEN.find(w=>w.re.test(s));
  if(!w) return null;
  const treffer = PRODUKTE.filter(p=> w.ks ? w.ks.indexOf(p.k)>=0 : p.k===w.k);
  if(!treffer.length) return null;
  /* Seit 15.08.2026 zaehlen alle Geschmacksbegriffe eines Artikels,
     nicht nur das eine Titelwort - bei den verkosteten Honigen sind das
     fuenf Noten plus die Konsistenz. Zusaetzlich wird geprueft, ob ein
     vorhandener Begriff woertlich in der Frage steht; so wirkt auch ein
     Wort, das die feste Liste oben nicht kennt. */
  const gewuenscht=[...new Set(s.match(GESCHMACK)||[])];
  const vorhanden=new Set();
  treffer.forEach(p=>notizen(p).forEach(n=>vorhanden.add(n)));
  const woertlich=[...vorhanden].filter(n=>s.indexOf(n)>=0);
  const passend=[...new Set(gewuenscht.filter(g=>vorhanden.has(g)).concat(woertlich))];
  const offen=gewuenscht.filter(g=>!vorhanden.has(g) && passend.indexOf(g)<0);
  let zusatz='';
  if(passend.length) zusatz=' Gefiltert nach: '+passend.join(' · ')+'.';
  if(offen.length)   zusatz+=' „'+offen.join('“, „')+'“ lässt sich noch nicht filtern — die Verkostung ist noch nicht erhoben.';
  /* Wer nach einem Geschenk fragt, sieht die Holzkiste zuerst - sie ist
     der einzige Artikel im Sortiment, der als Kiste verpackt kommt.
     Sonst entscheidet die Verkaufshaeufigkeit. Gemeldet 13.08.2026. */
  const geschenk = w.k==='set' && /(geschenk|verschenk|box|boxen|kiste|präsent|praesent|mitbringsel)/.test(s);
  const sortiert = nachVerkauf(treffer);
  const liste = geschenk
    ? sortiert.filter(p=>p.kiste).concat(sortiert.filter(p=>!p.kiste))
    : sortiert;
  const ordnung = geschenk
    ? ' Die Holzkiste steht vorn, danach zählt die Verkaufshäufigkeit.'
    : ' Sortiert nach Verkaufshäufigkeit, meistgekaufter Artikel zuerst.';
  return {
    summary:'Du hast eine Warengruppe genannt. auteniQ zeigt, was davon im Sortiment liegt.',
    tags:[w.label, treffer.length+' Artikel'].concat(passend),
    vorfilter:passend,
    eyebrow:'Warengruppe', title:w.label+', '+treffer.length+' Artikel',
    intro:(w.hinweis||'')+ordnung+zusatz,
    visual:'help', refine:false,
    pick:()=>liste,
    metrics:[],
    why:'Die Liste kommt aus dem Sortiment, die Reihenfolge aus den echten Bestellzahlen — nicht aus einer Auswahl von Hand.',
    limit:'du zusätzlich nach Geschmack sortieren willst. Die Verkostungswerte fehlen noch.',
    evidence:treffer.length+' von '+treffer.length+' Preisen aus dem Shop · '+treffer.filter(p=>rangVon(p)!==OHNE_RANG).length+' davon mit Verkaufsrang',
    source:'Aktive Artikel, Schnappschuss vom 31.07.2026 · Reihenfolge aus der Shopify-Sortierung „Meistverkauft", 13.08.2026 · Grundpreis nur, wenn die Füllmenge im Titel steht.'
  };
}

/* -----------------------------------------------------------------
   VERKAUFSRANG - die Shopify-Sortierung "Meistverkauft", am 13.08.2026
   live aus /collections/all?sort_by=best-selling gezogen.

   Alexander am 13.08.2026 beim Test der Preisgrenze: "Koennte man das
   ordnen nach Kaufhaeufigkeit? Was wirklich am meisten gekauft wurde,
   steht vorne links." Vorher sortierte jede Liste nach Preis oder nach
   der zufaelligen Reihenfolge im Schnappschuss - der meistgekaufte
   Artikel konnte dadurch ganz hinten stehen oder ganz wegfallen.

   Zwei bewusste Entscheidungen:
   - Das kostenlose Probepaeckchen 10139 steht live auf Rang 13, ist
     hier aber nicht aufgenommen. Ein 0,00-Euro-Artikel verzerrt jede
     Kaufempfehlung.
   - Vier Live-Raenge fehlen, weil der Artikel im Schnappschuss nicht
     existiert oder im Berater bewusst nicht auftaucht: das Buch
     "Ernaehrung. Meine Quintessenz" (Buecher bleiben aussen vor, siehe
     Abschnitt 18 des Skills) und die drei Rockets-Fruchtgummis.

   Auf der echten Seite kommt diese Reihenfolge live aus Shopify und
   pflegt sich mit jeder Bestellung selbst. Hier ist sie ein Schnappschuss.
   ----------------------------------------------------------------- */
const VERKAUFSRANG = {
  '10021':1,  '10019':2,  '10001':3,  '10004':4,  '10003':5,  '10009':6,
  '10014':7,  '10016':8,  '10013':9,  '10018':10, '10107':11, '10007':12,
  '10015':13, '10017':14, '10006':15, '10020':16, '10056':17, '10002':18,
  '10108':19, '10165':20, '10162':21, '10091':22, '10240':23, '10071':24,
  '10044':25, '10030':26, '10167':27, '10133':28, '10103':29, '10083':30,
  '10067':31, '10038':32, '10031':33, '10207':34, '10202':35
};
/* Ohne Rang heisst: nicht unter den meistverkauften Artikeln - nicht
   "wird nie gekauft". Solche Artikel stehen hinter den gerangten, dort
   entscheidet der Preis. Nie eine Zahl erfinden. */
const OHNE_RANG = 9999;
function rangVon(p){ return VERKAUFSRANG[p && p.s] || OHNE_RANG; }
function nachVerkauf(liste){
  return liste.slice().sort((a,b)=>{
    const ra=rangVon(a), rb=rangVon(b);
    return ra!==rb ? ra-rb : a.p-b.p;
  });
}
/* Fuer Listen, die nur Titel kennen (CATALOG in logik.js hat keine
   Artikelnummer). Vergleicht ueber die Wortmenge des Titels, damit
   "Bio-Olivenoel ... Mestral Arbequina, 3 L" denselben Rang bekommt
   wie der Artikel im Sortiment. Kein Treffer heisst OHNE_RANG. */
function rangVonTitel(titel){
  const norm = t => t.toLowerCase().replace(/[^a-z0-9äöüß]+/g,' ')
     .replace(/\b(bio|nativ|extra|von|der|die|das|aus|mit|und|im|ml|kg|monate|gereifter|100)\b/g,' ')
     .replace(/\s+/g,' ').trim();
  const worte = norm(titel).split(' ').filter(w=>w.length>3);
  if(!worte.length) return OHNE_RANG;
  let best=OHNE_RANG, score=0.6;
  for(const p of PRODUKTE){
    if(!VERKAUFSRANG[p.s]) continue;
    const hat=new Set(norm(p.t).split(' '));
    const s=worte.filter(w=>hat.has(w)).length/worte.length;
    if(s>score){ score=s; best=VERKAUFSRANG[p.s]; }
  }
  return best;
}

/* Produktlisten fuer die vorhandenen Antworten. Ohne Eintrag hier
   erscheint bewusst KEIN Raster - das gilt fuer alle Sperrfaelle. */
const PICK = {
  /* Nach Verkaufshaeufigkeit statt nach Reihenfolge im Schnappschuss.
     Alexander am 13.08.2026: bei "Snacks fuers Buero" fehlten die
     Pistazien. Ursache war kein fehlender Artikel, sondern ein harter
     Schnitt bei acht Stueck in zufaelliger Reihenfolge - von 25
     Snack-Artikeln fielen 17 unsichtbar hinten runter. */
  snack:   ()=>nachVerkauf(PRODUKTE.filter(p=>(p.k==='nuss'||p.k==='trockenfrucht'||p.k==='riegel')&&!p.kein_snack&&!p.koffein)).slice(0,12),
  oils:    ()=>PRODUKTE.filter(p=>p.k==='oel'),
  tea:     ()=>PRODUKTE.filter(p=>p.k==='tee'&&p.kalt).slice(0,8),
  salt:    ()=>PRODUKTE.filter(p=>p.s==='10007'||p.s==='10167'||p.s==='10168'),
  fiber:   ()=>PRODUKTE.filter(p=>p.k==='riegel'),
  protein: ()=>PRODUKTE.filter(p=>p.k==='nuss'&&!p.kein_snack).slice(0,8),
  genuss:  ()=>PRODUKTE.filter(p=>p.spitze),
  budget:  ()=>PRODUKTE.filter(p=>p.k==='set').sort((a,b)=>a.p-b.p).slice(0,6)
};
/* -----------------------------------------------------------------
   ZUTATEN-INDEX
   Welche Zutat steckt nachweislich in welchem Artikel - abgelesen aus
   Produkttitel und Zutatenliste, nichts hineingedeutet. Dieser Index
   ist die EINZIGE Stelle, an der die Verbindung Frage -> Zutat -> Ware
   entsteht. Er darf nie als oeffentlicher Shop-Tag erscheinen, sonst
   waere die Zuordnung eine Wirkbehauptung auf der Seite.
   ----------------------------------------------------------------- */
const ZUTAT_INDEX = {
  '10209':'kamille',            /* Smooth Operator, 100 % Kamillenblueten */
  '10206':'lavendel wacholder', /* Gin Soul */
  '10200':'minze',              /* Master Mint, reine Pfefferminze */
  '10197':'minze bergkraeuter', /* Heidi's Delight */
  '10195':'minze',              /* Istanbul Nights, mit Koffein */
  '10132':'ingwer zitrone',     /* Ingwer-Zitronen Bancha, mit Koffein */
  '10207':'ingwer zitronengras',/* Inner Light, mit Koffein */
  '10212':'zimt',               /* Karibu Sun */
  '10254':'kurkuma zwiebel',    /* Wuerziger Kuerbis Riegel */
  '10251':'curry sesam',        /* Geroesteter Karotten-Riegel */
  '10245':'kraeuter',           /* Mediterraner Tomaten-Riegel */
  '10257':'kraeuter',           /* Gekraeuterte Rote Bete Riegel */
  '10248':'chili',              /* Pikante Paprika Riegel */
  '10156':'geroestet',          /* Hojicha */
  '10208':'orange vanille'      /* Orange Safari */
};
PRODUKTE.forEach(p=>{ if(ZUTAT_INDEX[p.s]) p.zutat=ZUTAT_INDEX[p.s]; });
function mitZutat(re,ohneKoffein){
  return PRODUKTE.filter(p=>re.test(p.zutat||'') && !(ohneKoffein&&p.koffein));
}
/* Doppelte Karten vermeiden, wenn zwei Regeln denselben Artikel treffen */
function einmalig(liste){
  const gesehen=new Set();
  return liste.filter(p=>gesehen.has(p.s)?false:(gesehen.add(p.s),true));
}

/* Zutaten-Menue der Umlenkungen. Ein Menue je Beschwerdefamilie, an
   genau einer Stelle - damit nicht wieder ein Artikel verschwindet,
   weil zwei Umlenkungen dieselbe Frage treffen. */
const ZUTAT_PICK = {
  'ingwer zitrone honig':     ()=>einmalig(PRODUKTE.filter(p=>p.k==='honig').concat(mitZutat(/ingwer|zitrone/))),
  'lavendel melisse kamille': ()=>einmalig(mitZutat(/lavendel|kamille|melisse/,true)),
  'minze ingwer':             ()=>einmalig(mitZutat(/minze|ingwer/)),
  /* Magen, Bauch, Voellegefuehl, Darm, Verstopfung: EIN Menue.
     Kamille, Minze, Ingwer, Kurkuma - dazu die Riegel, weil dort die
     Ballaststoffzahl auf dem Etikett steht. Fenchel und Anis fuehrt
     das Sortiment nicht, deshalb stehen sie nicht im Menue. */
  'magen darm':               ()=>einmalig(mitZutat(/kamille|minze|ingwer|kurkuma/,true)
                                   .concat(PRODUKTE.filter(p=>p.k==='riegel')))
};


/* -----------------------------------------------------------------
   BIO — Alexander am 15.08.2026: "Wenn ich nur ein Wort Bio schreibe
   oder 'zeige alle Bioartikel', dann sollen alle Bioartikel kommen."

   Zwei Quellen, in dieser Reihenfolge:
   1. der Produkttitel traegt das Wort "Bio" (Schnappschuss)
   2. auf der echten Seite setzt der Live-Abgleich p.bio zusaetzlich
      aus dem Shop-Tag "bio" - siehe kuno-render.js. Ein bereits
      gesetztes Flag wird dabei nie zurueckgenommen.

   Eigene Grenzpruefung statt \b, weil "oe" und "ue" fuer JavaScript
   keine Wortzeichen sind. Teilwort-Fallen: "Antibiotika" und
   "Bioverfuegbarkeit" enthalten "bio", sind aber keine Bio-Frage.
   ----------------------------------------------------------------- */
const BIO_TITEL = /(^|[^a-zäöüß])bio([^a-zäöüß]|$)/;
PRODUKTE.forEach(p=>{ if(BIO_TITEL.test(p.t.toLowerCase())) p.bio=1; });

const BIO_FRAGE = /(^|[^a-zäöüß])(bioartikel|bio-artikel|bioprodukte|bio-produkte|bioqualität|bioqualitaet|bioware|bio)($|[^a-zäöüß])/;
const BIO_FALLE = /(antibiot|bioverfüg|bioverfueg|biologisch abbaubar|biotonne|biologie)/;

/* Warengruppen ohne Eintrag in WARENGRUPPEN. Eigene Grenzpruefung bei
   "oel", weil "Olivenoel" das Wort enthaelt und "oe" kein Wortzeichen ist. */
const BIO_GRUPPE_EXTRA = [
 {re:/(^|[^a-zäöüß])(olivenöl|olivenoel|würzöl|wuerzoel|öle|oele|öl|oel)($|[^a-zäöüß])/, k:'oel', label:'Olivenöl und Würzöl'},
 {re:/(nüsse|nuesse|nusskerne|pistazie|mandel|walnuss|macadamia|cashew|pekan)/,          k:'nuss', label:'Nüsse und Kerne'},
 {re:/(^|[^a-zäöüß])(tee|tees|kräutertee|kraeutertee|grüntee|gruentee|schwarztee)($|[^a-zäöüß])/, k:'tee', label:'Tee'}
];

function bioAntwort(s){
  if(BIO_FALLE.test(s) || !BIO_FRAGE.test(s)) return null;
  const alle = PRODUKTE.filter(p=>p.bio);
  if(!alle.length) return null;

  /* Steht eine Warengruppe im Satz, ist "Bio-Olivenoel" gemeint und
     nicht das ganze Bio-Sortiment. Oel, Nuesse und Tee haben keinen
     Eintrag in WARENGRUPPEN - sie laufen ueber classify() - und
     brauchen hier eine eigene kleine Liste. */
  const w = WARENGRUPPEN.find(w=>w.re.test(s)) || BIO_GRUPPE_EXTRA.find(g=>g.re.test(s));
  const treffer = w
    ? alle.filter(p=> w.ks ? w.ks.indexOf(p.k)>=0 : p.k===w.k)
    : alle;

  const quelle = 'Bio-Erkennung: „Bio" im Produkttitel, auf der Seite zusätzlich das Bio-Kennzeichen aus dem Shop. Ohne Beleg wird kein Artikel als Bio gezeigt.';

  if(!treffer.length){
    return {
      summary:'Du hast nach Bio in einer Warengruppe gefragt.',
      tags:['Bio', w.label],
      eyebrow:'Bio', title:'Bio bei '+w.label+': kein Artikel',
      intro:'In dieser Warengruppe trägt derzeit kein Artikel das Bio-Kennzeichen. Im übrigen Sortiment sind es '+alle.length+'.',
      visual:'help', refine:false,
      pick:()=>[], metrics:[],
      why:'Gezeigt wird nur, was belegt ist — lieber keine Liste als eine erfundene.',
      limit:'du Bio auch dort erwartest. Dann fehlt die Angabe im Shop, nicht die Ware.',
      evidence:'0 von '+PRODUKTE.filter(p=> w.ks ? w.ks.indexOf(p.k)>=0 : p.k===w.k).length+' Artikeln dieser Gruppe mit Bio-Kennzeichen',
      source:quelle
    };
  }

  const liste = nachVerkauf(treffer);
  const wo = w ? ' bei '+w.label : '';
  const gruppen = [...new Set(treffer.map(p=>p.k))].length;
  return {
    summary:'Du hast nach Bio gefragt. auteniQ zeigt, was im Sortiment als Bio belegt ist.',
    tags:['Bio', treffer.length+' Artikel'],
    eyebrow:'Bio', title:'Bio'+wo+', '+treffer.length+' Artikel',
    intro:(w ? '' : 'Aus '+gruppen+' Warengruppen. ')+'Sortiert nach Verkaufshäufigkeit, meistgekaufter Artikel zuerst.',
    visual:'help', refine:false,
    pick:()=>liste,
    metrics:[],
    why:'Als Bio gilt nur, was den Nachweis im Titel oder im Shop trägt — nichts wird dazugerechnet.',
    limit:'du eine bestimmte Kontrollstellennummer brauchst. Die steht auf dem Etikett, nicht in dieser Liste.',
    evidence:treffer.length+' von '+PRODUKTE.length+' Artikeln im Sortiment mit Bio-Kennzeichen',
    source:quelle
  };
}
/* ---------------------------------------------------------------
   Darstellungsschicht. Die Wissensschicht darueber bleibt
   unveraendert. Wer die Optik aendert, aendert nur diese Datei.
   --------------------------------------------------------------- */

/* Produktlisten an die vorhandenen Antworten haengen.
   Ohne Eintrag erscheint kein Raster - so bleiben alle Sperrfaelle
   ohne Ware, auch wenn spaeter neue Antworten dazukommen. */
Object.keys(PICK).forEach(k=>{ if(results[k]) results[k].pick=PICK[k]; });
UMLENK[0].result.pick = ZUTAT_PICK['ingwer zitrone honig'];
UMLENK[1].result.pick = ZUTAT_PICK['lavendel melisse kamille'];
UMLENK[2].result.pick = ZUTAT_PICK['minze ingwer'];
/* Darm/Verstopfung (3) und Magen/Bauch (4) sind eine Familie und
   bekommen DASSELBE Menue. Vorher hing der Kamillentee nur an 4 und
   fiel weg, sobald "darm" im Satz stand - die Schleife nahm 3.
   Gefunden von Alexander am 31.07.2026. Testfall vorhanden. */
UMLENK[3].result.pick = ZUTAT_PICK['magen darm'];
UMLENK[4].result.pick = ZUTAT_PICK['magen darm'];

/* Warengruppen-Antwort in die Kette einhaengen: nach allen
   Fachregeln, vor der Rueckfrage. Die Sperrliste laeuft davor. */
/* Preisgrenze und Bestseller nennen ihre Treffer als Titel. Diese
   Titel werden auf die Artikel im Sortiment gelegt, damit auch dort
   echte Bilder erscheinen statt einer Textliste. */
function normTitel(s){
  return s.toLowerCase().replace(/[^a-z0-9äöüß]+/g,' ')
   .replace(/\b(bio|nativ|extra|von|der|die|das|aus|mit|und|im|ml|kg|monate|gereifter|100)\b/g,' ')
   .replace(/\s+/g,' ').trim();
}
function findeArtikel(titel){
  const worte=normTitel(titel).split(' ').filter(w=>w.length>3);
  let best=null, score=0;
  for(const p of PRODUKTE){
    const hat=new Set(normTitel(p.t).split(' '));
    const s=worte.filter(w=>hat.has(w)).length/Math.max(worte.length,1);
    if(s>score){ score=s; best=p; }
  }
  return score>=0.5 ? best : null;
}

const classifyKern = classify;
function classifyVoll(text){
  const s=(text||'').toLowerCase().trim();
  const r=classifyKern(text);
  /* Eine echte Rechnung darf eine allgemeinere Antwort ueberholen -
     "wie viel Salz sind in 30 g Honig" landete sonst im Snack-Filter,
     weil dort das Wort "salz" steht. Nur wenn wirklich gerechnet werden
     kann, und niemals bei einer gesperrten oder umgelenkten Frage. */
  if(!r.redirect && !r.noProduct){
    /* Rezept zuerst: "Rezepte für Tee" landete sonst einfach bei den
       Tee-Produkten (results.tea), weil das Wort "Tee" schon vorher
       traf - die Rezepte selbst kamen nie dran. Gefunden 31.07.2026. */
    const rz=rezeptAntwort(s);     if(rz) return rz;
    const ez=erzeugerAntwort(s);   if(ez) return ez;
    const so=sorteAntwort(s);      if(so) return so;
    /* Bio muss die Warengruppen- und Kategorieantwort ueberholen:
       "Bio-Olivenoel" ist enger als "Olivenoel". Ergaenzt 15.08.2026. */
    const bi=bioAntwort(s);        if(bi) return bi;
    /* Geschmacksprofile der Honige, ergaenzt 15.08.2026. */
    const se=sensorikAntwort(s);   if(se) return se;
    /* Geschmacksprofile der Oele, ergaenzt 16.08.2026. Steht direkt hinter
       dem Honig und vor den Polyphenolen: die Funktion tritt bei jedem
       Polyphenolwort selbst zurück, damit die Zahlenantwort und der
       Zielkonflikt "polyphenolreich, aber mild" unberührt bleiben. */
    const oe=oelSensorikAntwort(s);if(oe) return oe;
    /* Polyphenole (13.08.2026) stehen an derselben Stelle wie Sorte und
       Erzeuger: hinter Sperrliste und Umlenkung, vor Preis- und
       Warengruppen-Antwort. "Polyphenole gegen Bluthochdruck" erreicht
       diese Zeile deshalb nie. */
    const py=polyphenolAntwort(s); if(py) return py;
    const b=berechnungAntwort(s);  if(b && b.rechnung) return b;
    /* Naehrwertfrage ohne Mengenangabe: "wie viel Salz ist in den
       Oliven?" hatte bis 13.08.2026 keine eigene Antwort und landete
       ueber das Wort "salz" im Snack-Filter. Steht hinter der
       Berechnung, damit eine Frage MIT Menge weiter dort landet. */
    const nw=naehrwertAntwort(s);  if(nw) return nw;
    const v=vergleichAntwort(s);   if(v) return v;
    /* Nur die engen Wörter: "Was kostet der Versand für Olivenöl?" ist
       eine Versandfrage, "Welches Öl liefert ihr?" nicht. */
    const vs=versandAntwort(s,true); if(vs) return vs;
  }
  if(r===results.generic){
    /* Reihenfolge: erst Rezept, dann Vergleich, dann Berechnung, dann
       Warengruppe. "Rezepte mit Honig" landete sonst bei der Warengruppe
       Honig, weil "honig" allein in classify() gar keinen Treffer hat
       und generic() noProduct=true hat - die erste Rezept-Pruefung weiter
       oben greift dort nicht. Gefunden 31.07.2026. Sonst schluckt die
       Warengruppe auch "vergleiche Honig A und Honig B". */
    const rz=rezeptAntwort(s);     if(rz) return rz;
    const ez=erzeugerAntwort(s);   if(ez) return ez;
    const so=sorteAntwort(s);      if(so) return so;
    const bi=bioAntwort(s);        if(bi) return bi;
    const se=sensorikAntwort(s);   if(se) return se;
    const oe=oelSensorikAntwort(s);if(oe) return oe;
    /* "hydroxytyrosol" allein hat in classify() kein Schluesselwort und
       landet deshalb bei generic - hier greift die Antwort. */
    const py=polyphenolAntwort(s); if(py) return py;
    const v=vergleichAntwort(s);   if(v) return v;
    const b=berechnungAntwort(s);  if(b) return b;
    const nw=naehrwertAntwort(s);  if(nw) return nw;
    const w=warengruppenAntwort(s);
    if(w) return w;
    /* Versand ganz am Ende: eine erkennbare Warengruppe gewinnt, damit
       "Welches Öl liefert ihr?" das Sortiment zeigt und nicht die
       Versandtabelle. Ergänzt 16.08.2026. */
    const vs=versandAntwort(s,false); if(vs) return vs;
  }
  /* Liste aus Titeln in echte Artikel uebersetzen */
  if(!r.noProduct && !r.pick && Array.isArray(r.metrics) && /^(Unter |Meistverkauft|Günstigster|Teuerster)/.test(r.eyebrow||'')){
    const treffer=r.metrics
      .map(([,label])=>findeArtikel(String(label).split(' — ')[0]))
      .filter(Boolean);
    if(treffer.length===r.metrics.length){ r.pick=()=>treffer; r.metrics=[]; }
  }
  return r;
}

/* Weg-1-Hinweis und Nachsatz. EINZIGE Stelle im Code, an der diese
   Texte stehen. Jede Aenderung hier wirkt auf alle Faelle, die sie
   verwenden - danach die Testsuite gegen alle laufen lassen. */
const KOPF = {
  arzt:       'Bei anhaltenden Beschwerden hilft Fachwissen weiter — eine Ärztin, ein Arzt, Fachliteratur oder ein guter Fachbeitrag.',
  wert:       'Messbar sind Zahlen, keine Urteile.',
  versprechen:'Longevity ist ein Versprechen. auteniQ liefert Messwerte.',
  krankheit:  'Ohne Produktliste — auch ohne reine Zahlen.',
  preis:      'Kein Treffer, ehrlich gesagt — statt einer Notlösung.'
};
const NACH = { arzt:'auteniQ kennt die Zahlen der Produkte, nicht deinen Befund.', wert:'', versprechen:'', krankheit:'', preis:'' };

const eur = n => n.toFixed(2).replace('.',',')+' €';
const kurz = t => t.split('|')[0].trim();

function produktKarte(p){
  const gp = grundpreis(p);
  const zahl = gp
    ? '<span class="k">'+eur(gp.wert)+' je 100 '+gp.einheit+'</span>'
    : '<span class="warn">Füllmenge fehlt</span>';
  return '<article class="pcard">'
    +'<div class="pimg"><img src="'+p.i+'" alt="" loading="lazy"></div>'
    +'<div class="pbody"><h3>'+kurz(p.t)+'</h3>'
    +'<div class="pfoot"><span class="pp">'+eur(p.p)+'</span>'+zahl+'</div>'
    +'<div class="psku">Art. '+p.s+(p.koffein?' · enthält Koffein':'')+'</div>'
    +'</div></article>';
}

function nameOf(r){
  for(const k in results) if(results[k]===r) return k;
  for(let i=0;i<UMLENK.length;i++) if(UMLENK[i].result===r) return 'umlenkung '+(i+1);
  if(r.eyebrow==='Warengruppe') return 'warengruppe';
  /* Ergänzt 16.08.2026: diese Antwortarten liefen im Tracking bisher
     alle als "unbekannt" und waren damit nicht auswertbar. */
  if(r.eyebrow==='Bio') return 'bio';
  if(r.eyebrow==='Versandkosten') return 'versandkosten';
  if(r.eyebrow==='Verwendung') return 'verwendung';
  if(r.eyebrow==='Passt dazu') return 'passt dazu';
  if(r.eyebrow==='Geschmack') return /von 1 bis 5/.test(r.intro||'') ? 'sensorik öl' : 'sensorik honig';
  if(r.eyebrow==='Nährwert') return /Wert fehlt/.test(r.title||'') ? 'nährwert ohne beleg' : 'nährwert';
  if(r.bannerType==='preis') return 'preis ohne treffer';
  if(/^Gesamtpolyphenole/.test(r.eyebrow||'')) return 'polyphenole';
  if(/Treffer/.test(r.title||'')) return 'preisgrenze';
  if(/Top/.test(r.title||'')) return 'bestseller';
  if(/^(Günstigster|Teuerster)/.test(r.eyebrow||'')) return 'preis-superlativ';
  if(r.eyebrow==='Aus dem Rezept-Magazin') return 'rezepte';
  return 'unbekannt';
}
/* ---------------------------------------------------------------
   Zweite Produktebene: Notizen aus dem Shop-Titel, Erklaertexte je
   Warengruppe, belegte Naehrwerte, Vergleich und Berechnung.
   Nichts hier ist geschaetzt. Fehlt ein Wert, bleibt er leer.
   --------------------------------------------------------------- */

/* Geschmacksnotiz - ausschliesslich das Adjektiv aus dem eigenen
   Produkttitel (Belegstufe B). Verkostete Werte fehlen noch alle. */
const NOTIZ = {
 /* Honig: bleibt bewusst das Titelwort. Das ausfuehrliche
    Verkostungsprofil steht getrennt darunter in SENSORIK und wird mit
    eigener Quelle ausgewiesen. Titel ohne Adjektiv (10001 Bluetenhonig,
    10009 Wildkraeuterhonig) bekommen weiterhin keine Notiz. */
 '10014':'mediterran', '10004':'duftend', '10003':'duftend',
 '10013':'kräftig', '10002':'cremig', '10021':'kaltgepresst', '10019':'polyphenolreich',
 '10107':'polyphenolreich', '10108':'polyphenolreich', '10054':'geröstet',
 '10063':'geröstet', '10064':'natur', '10051':'geschält', '10167':'ungesalzen',
 '10168':'gesalzen', '10169':'geschält', '10156':'geröstet', '10135':'geröstet',
 '10072':'säuerlich', '10071':'säuerlich', '10069':'sonnengereift', '10070':'sonnensüß',
 '10067':'karamellig', '10200':'minzig', '10197':'minzig', '10195':'minzig',
 '10209':'mild', '10206':'blumig', '10199':'mild', '10132':'würzig', '10207':'würzig'
};
PRODUKTE.forEach(p=>{ p.n = NOTIZ[p.s] || ''; });

/* -----------------------------------------------------------------
   SENSORIK — Verkostungsprofile aller sieben Honige.

   Zwei Quellen, sauber getrennt:

   staerke und eigen  = eigene Verkostung von auteniQ, Alexander,
     02.08.2026 ("Honig Verkostung.docx"). Belegstufe A: selbst probiert.
     Skala 1 bis 10, dieselbe fuer alle sieben Sorten.
   herkunft, geschmack, farbe, textur = Angaben des Erzeugers und die
     eigene Shopbeschreibung. Belegstufe B.

   Die Zahl ordnet die Sorten untereinander. Sie ist ein Geschmacks-
   eindruck, keine Messung, und wird auch so ausgewiesen.
   ----------------------------------------------------------------- */
const SENSORIK_QUELLE = 'Geschmacksstärke aus der eigenen Verkostung von auteniQ, 02.08.2026 (Belegstufe A). Herkunft, Farbe und Textur nach Angaben des Erzeugers Apícola Cuartero (Belegstufe B). Ein Eindruck, keine Messung.';

/* Die Skala im Klartext - dieselben Stufen, die in der Verkostung
   vergeben wurden. Kuno erklaert damit die Zahl, statt sie nur zu
   nennen. */
const SENS_STUFE = [
 {bis:2,  text:'sehr mild, zurückhaltend, kaum eigene Note'},
 {bis:4,  text:'mild, mit erkennbarer Sortencharakteristik'},
 {bis:6,  text:'ausgewogen bis charaktervoll, deutliches Eigenprofil'},
 {bis:8,  text:'kräftig, würzig oder malzig, meist langer Nachhall'},
 {bis:10, text:'sehr kräftig und dominant, eventuell herb'}
];
function sensStufe(n){
  for(const s of SENS_STUFE) if(n<=s.bis) return s.text;
  return '';
}
/* In der Verkostung standen Zwischenwerte wie "4 - 5". Halbe Punkte
   werden deshalb als Spanne ausgegeben, nicht als Komma-Zahl. */
function staerkeText(n){
  return (n%1 ? (n-0.5)+'–'+(n+0.5) : String(n))+' von 10';
}

/* noten      = alle Geschmacksbegriffe aus der Verkostung, kurz genug
                fuer einen Filterknopf. Reihenfolge: staerkster zuerst.
   konsistenz = die Konsistenz als ein Wort, damit auch danach
                gefiltert werden kann. Alexander hat sie fuer jede
                Sorte einzeln bewertet.
   textur     = derselbe Befund als ganzer Satz fuer die Antwort.
   eigen      = O-Ton aus der Verkostung. */
const SENSORIK = {
 '10004':{herkunft:'Zitronenhaine von Valencia bis Murcia',
          geschmack:'Frisch und fein zitrusblumig, mit heller Süße und einer leichten, sauberen Zitrusnote',
          noten:['zitrusfrisch','fruchtig','floral','hell','sanft süß'],
          konsistenz:'feinkristallin',
          farbe:'Hellstrohgelb', textur:'feinkörnig kristallisierend und cremig', staerke:4,
          eigen:'Riecht schwach nach Zitronenschale. Leichte Frische, ein leichter Säureeindruck. Eher leicht und duftig als schwer.'},
 '10014':{herkunft:'Orangenhaine an Spaniens Mittelmeerküste',
          geschmack:'Zart fruchtig und blumig, mit sanfter Zitrusfrische und weichem Nachhall',
          noten:['floral','fruchtig','orangenblüte','frisch','süß'],
          konsistenz:'feincremig',
          farbe:'Hellgolden', textur:'feincremige Kristallisation, zart streichfähig', staerke:4.5,
          eigen:'Floral und etwas fruchtig, ein Hauch von Orangenblüte, Orange oder Mandarine. Nicht parfümiert, frisch und süß. Eine Spur kräftiger als die Zitronenblüte.'},
 '10001':{herkunft:'Wiesen des Ebro-Tals mit Klee, Luzerne und Kräutern',
          geschmack:'Rund, blumig und feinfruchtig, ergänzt durch eine leichte Kräuternote',
          noten:['blumig','fruchtig','kräuterig','rund','weicher nachhall'],
          konsistenz:'grobkörnig',
          farbe:'Hellgold bis zart bernstein', textur:'grob kristallin', staerke:5,
          eigen:'Der klassische Honiggeschmack der Reihe: blumig, fruchtig, etwas kräuterig. Unkompliziert und einsteigerfreundlich, bleibt länger am Gaumen als Orange und Zitrone.'},
 '10003':{herkunft:'Kastilische Hochebene mit warmen Tagen und kühlen Nächten',
          geschmack:'Kühl-floral, kräuterfrisch und balsamisch, mit einer sehr dezenten Mentholnote',
          noten:['floral','kräuterig','kühle frische','balsamisch','langer nachhall'],
          konsistenz:'feinkristallin',
          farbe:'Hellbernstein', textur:'fein kristallin und cremig, streichzart', staerke:6,
          eigen:'Floral und kräuterig mit kühler Frische. Nichts Parfümiertes, keinerlei medizinische oder ätherische Note. Etwas aromatischer und leicht kräftiger als der Wiesenhonig.'},
 '10009':{herkunft:'Mediterranes Buschland auf sonnenwarmen Kalkböden',
          geschmack:'Warm und kräuterig mit Anklängen von Thymian, Rosmarin und Salbei',
          noten:['würzig','kräuterig','warm','balsamisch','vielschichtig'],
          konsistenz:'feinkörnig',
          farbe:'Bernstein bis dunkelbernstein', textur:'fein- bis mittelkörnig kristallisierend, cremiger Schmelz', staerke:6.5,
          eigen:'Voll und vielschichtig, würzig mit einem Stück Süße, mediterrane Wärme. Einzelne Kräuter sind allerdings kaum herauszuschmecken. Der Übergang von den floralen zu den charaktervollen Sorten.'},
 '10013':{herkunft:'Spanische Bergwälder mit Eichen, Waldkräutern und Sommerblüten',
          geschmack:'Harzig und malzig, mit Noten von Karamell und Trockenfrucht und einem langen, warmen Nachhall',
          noten:['harzig','malzig','karamellig','mineralisch','langer nachhall'],
          konsistenz:'flüssig',
          farbe:'Dunkelbernstein bis mahagoni', textur:'bleibt lange fließfähig, kristallisiert langsam, samtiger Schmelz beim Rühren', staerke:7.5,
          eigen:'Dunkel und würzig, mit langem, warmem Nachhall und mineralischem Eindruck. Bergblüten und Eichenhonigtau in einem Glas.'},
 '10002':{herkunft:'Bergheiden und Waldsäume in höheren Lagen',
          geschmack:'Würzig-malzig, vollmundig und balsamisch, mit feinen Harz- und Karamellnoten',
          noten:['malzig','karamellig','harzig','balsamisch','leichte herbe'],
          konsistenz:'cremig',
          farbe:'Dunkelbernstein', textur:'schonend cremig gerührt, fest und streichzart — ohne Zusätze', staerke:8,
          eigen:'Der cremigste und wohl kräftigste der Reihe, mit einer angenehmen Spur Herbe. Malz, Karamell und Harz einzeln herauszuschmecken gelingt nicht — es bleibt die Summe aus allem. Die cremige Textur hinterlässt den stärksten Eindruck.'}
};

/* ---------------------------------------------------------------
   OLIVENOEL-SENSORIK - Blindverkostung vom 12.08.2026
   Sechs Oele nebeneinander in blauen Glaesern, Farbe und Etikett
   verdeckt. Skala 1 bis 5 - ausdruecklich NICHT die 1-bis-10-Skala
   der Honige. Deshalb ein eigener Block, eigene Stufentexte und eine
   eigene Antwortfunktion; die Honig-Antwort filtert weiter auf
   p.k==='honig' und bleibt unberuehrt.

   Die Zahlen stehen wortgleich in den Shop-Metafeldern sensorik.*,
   die Saetze unter sensorik.passt_zu und sensorik.passt_eher_nicht
   ebenfalls (abgeglichen 16.08.2026). Wichtig: products.json liefert
   keine Metafelder - der Live-Abgleich in kuno-render.js zieht nur
   Preis, Lieferbarkeit, Link und das Bio-Tag. Aendert sich ein
   Metafeld im Shop, muss es hier von Hand nachgezogen werden.
   --------------------------------------------------------------- */
const OEL_SENSORIK_QUELLE = 'Blindverkostung von auteniQ am 12.08.2026: sechs \u00d6le nebeneinander in blauen Gl\u00e4sern, Farbe und Etikett verdeckt, Skala 1 bis 5. Belegstufe A f\u00fcr die selbst verkosteten \u00d6le. Belegstufe B, wo das Profil aus der Erzeugerbeschreibung stammt. Wortgleich mit den Shop-Feldern sensorik.* am Produkt. Ein Eindruck, keine Messung.';

const SENSORIK_OEL = {
 '10162':{bitterkeit:2, schaerfe:2, frucht:4, nuss:4, rundheit:5, intensitaet:3, nachklang:4, beleg:'A',
   satz:'Fruchtig, nussig, rund \u2013 mit einem Nachgeschmack, der bleibt.',
   glas:'Glas 5 \u2013 der Geschmacksfavorit dieser Runde.',
   passt:['Blattsalat und Tomate','Gegarter Fisch','Burrata und Mozzarella','\u00dcber Gem\u00fcse, kurz vor dem Servieren','Gutes Brot'],
   passtNicht:['Scharfes Anbraten \u2013 die Frucht verfliegt','Gerichte, in denen das \u00d6l nicht auffallen soll']},

 '10019':{bitterkeit:2, schaerfe:2, frucht:3, nuss:4, rundheit:4, intensitaet:2, nachklang:2, beleg:'A',
   satz:'Cremig und nussig, mild fruchtig, mit leichter Sch\u00e4rfe im Nachgang.',
   passt:['T\u00e4glich in der K\u00fcche','Dressings und Marinaden','Anbraten und Schmoren','Backen','Kartoffeln, Gem\u00fcse, Ei'],
   passtNicht:['Wer Bitterkeit und Sch\u00e4rfe sucht, greift besser zum Holiston']},

 '10021':{bitterkeit:2, schaerfe:3, frucht:3, nuss:4, rundheit:4, intensitaet:3, nachklang:3, beleg:'A',
   satz:'Rund und ausgewogen, zum Abgang hin deutlich sch\u00e4rfer als die Schwester ohne Bio-Siegel.',
   passt:['Salat und rohes Gem\u00fcse','Suppe und H\u00fclsenfr\u00fcchte, zum Schluss dar\u00fcber','Anbraten und Schmoren','Allrounder f\u00fcr den Vorrat'],
   passtNicht:['Gerichte, in denen das \u00d6l im Hintergrund bleiben soll']},

 '10107':{bitterkeit:5, schaerfe:5, frucht:4, nuss:2, rundheit:2, intensitaet:5, nachklang:5, beleg:'A',
   satz:'Ausgepr\u00e4gt bitter, deutlich scharf im Abgang, dahinter gr\u00fcne Frucht \u2013 kein \u00d6l f\u00fcr den Hintergrund.',
   passt:['Tropfenweise \u00fcber Suppe und H\u00fclsenfr\u00fcchte','Gegrilltes Gem\u00fcse','Bruschetta','Kr\u00e4ftiger K\u00e4se','Rindercarpaccio'],
   passtNicht:['Anbraten und Backen \u2013 daf\u00fcr ist es zu schade','Milde Gerichte, die es \u00fcberdeckt']},

 /* Belegstufe B: im Blindtest lief dieses Oel als "Glas 2, als
    Supermarktoel getippt" - falsch geraten. Ein eigenes Profil wurde
    dabei nicht protokolliert, die Zahlen stammen aus der
    Erzeugerbeschreibung. Deshalb B statt A, und die Antwort sagt es. */
 '10020':{bitterkeit:3, schaerfe:3, frucht:3, nuss:2, rundheit:4, intensitaet:3, nachklang:3, beleg:'B',
   satz:'Frucht und Kr\u00e4uter, harmonische Bitterkeit, pfeffriges Finish.',
   glas:'Glas 2 \u2013 im Blindtest als Supermarkt\u00f6l getippt. Falsch geraten.',
   passt:['Vom Salat bis zum Steak','Anbraten und R\u00f6sten','Wenn das \u00d6l das ganze Jahr gleich schmecken soll'],
   passtNicht:['Wer ein sortenreines \u00d6l sucht \u2013 das hier ist bewusst eine Cuv\u00e9e']}
};

/* Brateignung getrennt gefuehrt: sie gilt auch fuer 10163, zu dem es
   kein Verkostungsprofil gibt. Deshalb bekommt 10163 auch kein
   p.sens - sonst braeche notizen() ueber die fehlenden Noten. */
const OEL_BRATEN = {
 '10019':{ok:1, beleg:'A', grund:'Anbraten und Schmoren stehen im Verwendungsfeld des Artikels.'},
 '10021':{ok:1, beleg:'A', grund:'Anbraten und Schmoren stehen im Verwendungsfeld des Artikels.'},
 '10020':{ok:1, beleg:'B', grund:'Anbraten und R\u00f6sten stehen im Verwendungsfeld des Artikels.'},
 '10163':{ok:1, beleg:'B', grund:'Als ergiebiges K\u00fcchen\u00f6l gef\u00fchrt. Angabe des Erzeugers, nicht verkostet.'},
 '10162':{ok:0, beleg:'A', grund:'Scharfes Anbraten \u2013 die Frucht verfliegt.'},
 '10107':{ok:0, beleg:'A', grund:'Anbraten und Backen \u2013 daf\u00fcr ist es zu schade.'}
};

/* Die Filterbegriffe eines Oels werden aus den verkosteten Zahlen
   ABGELEITET, nicht von Hand vergeben: alles ab 4 von 5 ist eine
   erkennbare Note. So kann hier kein Wort stehen, das nicht im Glas
   war - dieselbe Regel wie bei den Honignoten, nur maschinell. */
const OEL_ACHSE = [['rundheit','rund'],['frucht','fruchtig'],['nuss','nussig'],['bitterkeit','bitter'],['schaerfe','scharf']];
const OEL_STUFE = ['\u2014','sehr zur\u00fcckhaltend','zur\u00fcckhaltend','mittel','deutlich','sehr ausgepr\u00e4gt'];
function oelStufe(n){ return OEL_STUFE[n]||''; }
function oelWert(n){ return n+' von 5'; }
Object.keys(SENSORIK_OEL).forEach(function(nr){
  const v=SENSORIK_OEL[nr];
  v.noten = OEL_ACHSE.filter(a=>v[a[0]]>=4).sort((a,b)=>v[b[0]]-v[a[0]]).map(a=>a[1]);
  v.konsistenz = v.intensitaet>=4 ? 'kr\u00e4ftig' : (v.intensitaet<=2 ? 'zur\u00fcckhaltend' : 'ausgewogen');
  v.braten = (OEL_BRATEN[nr]||{}).ok===1;
});

/* Geschmacksbegriffe eines Artikels — die einzige Stelle, an der
   entschieden wird, was auf der Karte steht und was als Filterknopf
   erscheint. Verkostete Artikel zeigen alle Begriffe plus die
   Konsistenz, alle anderen weiter ihr Titelwort. */
function notizen(p){
  /* Defensiv seit 16.08.2026: die Öle bringen eigene Notenlisten mit,
     ein Artikel ohne Konsistenzwort darf hier nicht mehr abstürzen. */
  if(p.sens && p.sens.noten) return p.sens.noten.concat(p.sens.konsistenz?[p.sens.konsistenz]:[]);
  return p.n ? [p.n] : [];
}

PRODUKTE.forEach(p=>{
  if(SENSORIK[p.s])     p.sens = SENSORIK[p.s];
  if(SENSORIK_OEL[p.s]) p.sens = SENSORIK_OEL[p.s];
});

/* Geschmacksfrage zum Honig: "wie schmeckt der Heidehonig", "welcher
   Honig ist mild", "Honig von mild nach kraeftig".

   Zwei Bedingungen, damit diese Antwort nichts verdeckt, wofuer es
   schon eine bessere gibt:
   1. ein Geschmackswort steht im Satz,
   2. es geht erkennbar um Honig.
   Deshalb bleibt "Olivenoel, das nicht so scharf schmeckt" bei den
   Oelen. Ein Vergleich bleibt ausdruecklich ein Vergleich. */
const SENS_WORT = /(schmeck|geschmack|sensorik|verkost|aroma|mild|kräftig|kraeftig|intensiv|lieblich|herb)/;
const SENS_VERGLEICH = /vergleich|unterschied|oder besser|versus|\bvs\b/;

function sensorikAntwort(s){
  if(!SENS_WORT.test(s)) return null;
  if(s.indexOf('honig')<0) return null;
  if(SENS_VERGLEICH.test(s)) return null;

  const honige = PRODUKTE.filter(p=>p.k==='honig');
  const mitProfil = honige.filter(p=>p.sens);
  if(!mitProfil.length) return null;

  /* Ist eine bestimmte Sorte gemeint? Geprueft werden nur die langen
     Titelwoerter, die selbst "honig" enthalten - "spaniens" oder
     "sommerwiesen" sollen keine Sorte auswaehlen. Der Wortanfang wird
     mitgeprueft, sonst faende "bluetenhonig" auch den
     Orangenbluetenhonig. */
  const genannt = honige.filter(p=>{
    const worte = p.t.toLowerCase().split(/[^a-zäöüß]+/)
      .filter(w=>w.length>7 && w.indexOf('honig')>=0);
    return worte.some(w=>new RegExp('(^|[^a-zäöüß])'+w).test(s));
  });

  const ohne = honige.filter(p=>!p.sens);
  const luecke = ohne.length
    ? ' Ohne Verkostungsprofil, deshalb am Ende: '+ohne.map(p=>kurz(p.t)).join(', ')+'.'
    : '';

  /* Eine Sorte gefragt, Profil vorhanden. */
  if(genannt.length===1 && genannt[0].sens){
    const p=genannt[0], v=p.sens;
    return {
      summary:'Du hast nach dem Geschmack einer Sorte gefragt.',
      tags:['Geschmack', kurz(p.t), staerkeText(v.staerke), v.konsistenz],
      eyebrow:'Geschmack', title:kurz(p.t),
      intro:v.noten.join(' · ')+'. '+v.geschmack+'. Konsistenz: '+v.textur+'. Farbe: '+v.farbe+'. Herkunft: '+v.herkunft+'. Geschmacksstärke '+staerkeText(v.staerke)+' — '+sensStufe(v.staerke)+'.',
      visual:'help', refine:false,
      pick:()=>[p], metrics:[],
      why:'Aus dem Glas: die Stärke stammt aus der eigenen Verkostung, die Beschreibung vom Erzeuger. Nichts dazugedichtet.',
      limit:'du deinen eigenen Geschmack meinst. Eine Zahl ersetzt den eigenen Löffel nicht.',
      eigen:v.eigen||'',
      datenlage:'1 Sorte, eigene Verkostung · Belegstufe A',
      evidence:'eigene Verkostung',
      source:SENSORIK_QUELLE
    };
  }

  /* Eine Sorte gefragt, Profil fehlt. Ehrlich benennen statt raten. */
  if(genannt.length===1){
    const p=genannt[0];
    const mildeste = mitProfil.slice().sort((a,b)=>a.sens.staerke-b.sens.staerke)[0];
    return {
      summary:'Zu dieser Sorte liegt noch kein Verkostungsprofil vor.',
      tags:['Geschmack', kurz(p.t)],
      eyebrow:'Geschmack', title:'Noch kein Verkostungsprofil',
      intro:'Für diese Sorte hat der Erzeuger noch kein Verkostungsprofil geliefert. Geraten wird hier nichts. Belegt sind '+mitProfil.length+' andere Sorten — die mildeste ist '+kurz(mildeste.t)+'.',
      visual:'help', refine:false,
      pick:()=>[p].concat(mitProfil), metrics:[],
      why:'Lieber eine offene Lücke als eine erfundene Geschmacksbeschreibung.',
      limit:'du gerade diese Sorte beschrieben haben willst — das Profil wird nachgereicht.',
      datenlage:mitProfil.length+' von '+honige.length+' Honigsorten mit Verkostungsprofil · Belegstufe B',
      evidence:'für diese Sorte kein Profil',
      source:SENSORIK_QUELLE
    };
  }

  /* Sonst: alle Sorten nach Intensitaet. Sorten ohne Profil fallen
     nicht heraus, sie stehen am Ende und werden benannt. */
  const kraeftigZuerst = /(kräftig|kraeftig|intensiv|stark|herb)/.test(s);
  const liste = mitProfil.slice().sort((a,b)=> kraeftigZuerst
    ? b.sens.staerke-a.sens.staerke
    : a.sens.staerke-b.sens.staerke).concat(ohne);
  return {
    summary:'Du hast nach Geschmack gefragt. Die Sorten stehen nach der verkosteten Stärke geordnet.',
    tags:['Geschmack', liste.length+' Sorten'],
    eyebrow:'Geschmack', title:kraeftigZuerst ? 'Von kräftig nach mild' : 'Von mild nach kräftig',
    intro:'Geordnet nach der Geschmacksstärke auf einer Skala von 1 bis 10, '
      +(kraeftigZuerst ? 'die kräftigste zuerst. ' : 'die mildeste zuerst. ')
      +'Alle sieben Sorten wurden nebeneinander probiert, deshalb sind die Zahlen untereinander vergleichbar.'+luecke,
    visual:'help', refine:false,
    pick:()=>liste, metrics:mitProfil.slice()
      .sort((a,b)=>a.sens.staerke-b.sens.staerke)
      .map(p=>[staerkeText(p.sens.staerke), kurz(p.t)+' — '+p.sens.noten.slice(0,3).join(', ')+', '+p.sens.konsistenz]),
    why:'Die Reihenfolge kommt aus einer Verkostung, nicht aus einer Auswahl von Hand.',
    limit:'du nach eigenem Geschmack entscheiden willst. Eine Skala ersetzt den eigenen Löffel nicht.',
    datenlage:mitProfil.length+' von '+honige.length+' Honigsorten verkostet · Belegstufe A',
    evidence:mitProfil.length+' von '+honige.length+' Sorten verkostet',
    source:SENSORIK_QUELLE
  };
}


/* ---------------------------------------------------------------
   Geschmacksfrage zum Olivenoel. Eigene Funktion statt einer
   Erweiterung von sensorikAntwort(): die Skalen sind verschieden
   (Honig 1-10, Oel 1-5), und die Oele beantworten zusaetzlich zwei
   Fragen, die es beim Honig nicht gibt - Brateignung und "wozu passt
   das".

   Vier Bedingungen, damit nichts verdeckt wird, wofuer es schon eine
   bessere Antwort gibt:
   1. Es geht erkennbar um Oel. "Oliven" allein reicht nicht - das
      sind die Tafeloliven (dieselbe Wortgrenzen-Falle wie in
      WARENGRUPPEN, Regel 4).
   2. Kein Polyphenol- oder Hydroxytyrosolwort im Satz: dafuer gibt es
      polyphenolAntwort(). Damit bleibt auch der Zielkonflikt
      "polyphenolreich, aber mild" bei results.oils, wo er seit dem
      30.07.2026 seine eigene Antwort hat.
   3. Kein Vergleich - ein Vergleich bleibt ein Vergleich.
   4. Steht "Honig" im Satz, gewinnt der Honig. Die Sperrliste steht
      ohnehin davor, sie wird in classifyVoll gar nicht erst verlassen.
   --------------------------------------------------------------- */
const OEL_WORT = /(oliven\u00f6l|olivenoel|brat\u00f6l|(^|[^a-z\u00e4\u00f6\u00fc\u00df])\u00f6l(e|s|en)?($|[^a-z\u00e4\u00f6\u00fc\u00df]))/;
const OEL_BRATFRAGE = /(braten|anbrat|erhitz|frittier|schmoren|d\u00fcnsten|duensten|pfanne|wok)/;
const OEL_PASSTFRAGE = /(passt|passen|wozu|womit|kombinier|dazu|verwend|benutz|nehme ich|nimmt man|eignet sich|geeignet)/;
const OEL_GERICHT = /(salat|fisch|suppe|brot|gem\u00fcse|gemuese|k\u00e4se|kaese|pasta|nudeln|steak|fleisch|carpaccio|bruschetta|mozzarella|burrata|kartoffel|dressing|marinade|h\u00fclsenfr\u00fcchte|huelsenfruechte|tomate|grill|dessert)/;

/* Erst die eindeutigen Namen, dann die Marke. "Holiston" allein meint
   zwei Artikel - dann werden auch beide gezeigt, statt zu raten. */
const OEL_NAME = {
 '10107':/(holiston ultra|ultra premium)/,
 '10108':/(holiston premium)/,
 '10021':/((bio|\u00f6ko|oeko)[^a-z]{0,3}mestral|mestral[^.]{0,14}bio)/,
 '10019':/(premium[^a-z]{0,3}mestral|mestral[^.]{0,14}premium)/,
 '10162':/(nature.{0,3}s?.{0,3}blend)/,
 '10163':/(chef.{0,3}s?.{0,3}table)/,
 '10020':/(gota de oro|gota)/
};
const OEL_MARKE = {holiston:['10107','10108'], mestral:['10019','10021'], eleology:['10162','10163'], arbequina:['10019','10021']};
function oelGenannt(s){
  const tr=[];
  Object.keys(OEL_NAME).forEach(nr=>{ if(OEL_NAME[nr].test(s) && tr.indexOf(nr)<0) tr.push(nr); });
  if(tr.length) return tr;
  Object.keys(OEL_MARKE).forEach(m=>{ if(s.indexOf(m)>=0) OEL_MARKE[m].forEach(nr=>{ if(tr.indexOf(nr)<0) tr.push(nr); }); });
  return tr;
}
function oelArtikel(nr){ return PRODUKTE.find(p=>p.s===nr); }

/* Reihenfolge zaehlt: "nicht so scharf" enthaelt "scharf" und muss vor
   der Schaerfe-Regel stehen, sonst kaeme die schaerfste Liste zurueck.
   Genau derselbe Fehler wie "Heuschnupfen"/"Schnupfen" in der
   Sperrliste. */
const OEL_ACHS_FRAGE = [
 {re:/(nicht so scharf|nicht scharf|nicht zu scharf|ohne sch\u00e4rfe|wenig sch\u00e4rfe|kaum sch\u00e4rfe|nicht so kr\u00e4ftig|mild|sanft|zur\u00fcckhaltend|unaufdringlich|dezent)/, feld:'intensitaet', wort:'Intensit\u00e4t', hoch:false},
 {re:/(sch\u00e4rfst|schaerfst|scharf|sch\u00e4rfe|pfeffrig)/,           feld:'schaerfe',   wort:'Sch\u00e4rfe',     hoch:true},
 {re:/(bitterst|bitter|herb)/,                                 feld:'bitterkeit', wort:'Bitterkeit',  hoch:true},
 {re:/(fruchtig|frucht)/,                                      feld:'frucht',     wort:'Fruchtigkeit',hoch:true},
 {re:/(nussig|nuss)/,                                          feld:'nuss',       wort:'Nussigkeit',  hoch:true},
 {re:/(rund|harmonisch|ausgewogen|weich|vollmundig)/,          feld:'rundheit',   wort:'Rundheit',    hoch:true},
 {re:/(kr\u00e4ftigst|intensivst|kr\u00e4ftig|kraeftig|intensiv|stark|wuchtig)/, feld:'intensitaet', wort:'Intensit\u00e4t', hoch:true},
 {re:/(nachklang|abgang|nachhall|l\u00e4nge)/,                      feld:'nachklang',  wort:'Nachklang',   hoch:true}
];

function oelProfilText(p){
  const v=p.sens;
  return kurz(p.t)+' \u2014 '+v.satz
    +' Bitterkeit '+oelWert(v.bitterkeit)+', Sch\u00e4rfe '+oelWert(v.schaerfe)
    +', Fruchtigkeit '+oelWert(v.frucht)+', Nussigkeit '+oelWert(v.nuss)
    +', Rundheit '+oelWert(v.rundheit)+', Intensit\u00e4t '+oelWert(v.intensitaet)
    +', Nachklang '+oelWert(v.nachklang)+'. Belegstufe '+v.beleg+'.';
}

function oelSensorikAntwort(s){
  const namen = oelGenannt(s);
  if(!OEL_WORT.test(s) && !namen.length) return null;
  if(s.includes('polyphen') || s.includes('hydroxytyrosol')) return null;
  if(SENS_VERGLEICH.test(s)) return null;
  if(s.indexOf('honig')>=0) return null;

  const oele     = PRODUKTE.filter(p=>p.k==='oel');
  const mitProfil= oele.filter(p=>p.sens && p.sens.satz);
  if(!mitProfil.length) return null;
  const ohne     = oele.filter(p=>!(p.sens && p.sens.satz));
  const luecke   = ohne.length
    ? 'Ohne Verkostungsprofil: '+ohne.map(p=>kurz(p.t)).join(', ')+'. Diese \u00d6le standen nicht im Blindtest.'
    : '';
  const stufeA = mitProfil.filter(p=>p.sens.beleg==='A').length;

  /* ---- 1. Brateignung ------------------------------------------- */
  if(OEL_BRATFRAGE.test(s)){
    const ja   = Object.keys(OEL_BRATEN).filter(nr=>OEL_BRATEN[nr].ok===1).map(oelArtikel).filter(Boolean);
    const nein = Object.keys(OEL_BRATEN).filter(nr=>OEL_BRATEN[nr].ok===0).map(oelArtikel).filter(Boolean);
    return {
      summary:'Du fragst, welches \u00d6l in die Pfanne darf.',
      tags:['Verwendung','Braten',ja.length+' \u00d6le'],
      eyebrow:'Verwendung', title:ja.length+' von '+oele.length+' \u00d6len sind zum Braten vorgesehen',
      intro:'Die Angabe kommt aus dem Verwendungsfeld des jeweiligen Artikels, nicht aus einer Messung. Geeignet: '
        + ja.map(p=>kurz(p.t)+' (Belegstufe '+OEL_BRATEN[p.s].beleg+')').join(', ')+'. '
        + 'Besser nicht: '+nein.map(p=>kurz(p.t)+' \u2014 '+OEL_BRATEN[p.s].grund).join(' ')+' '
        + 'Zu den vier W\u00fcrz- und \u00fcbrigen \u00d6len im Sortiment liegt keine Angabe zur Brateignung vor.',
      visual:'oils', refine:false,
      pick:()=>ja,
      metrics: ja.map(p=>['zum Braten', kurz(p.t)+' \u00b7 Belegstufe '+OEL_BRATEN[p.s].beleg])
        .concat(nein.map(p=>['eher nicht', kurz(p.t)+' \u00b7 '+OEL_BRATEN[p.s].grund])),
      why:'Steht die Verwendung am Artikel, wird sie genannt. Wo sie fehlt, wird sie nicht erg\u00e4nzt.',
      limit:'du einen Rauchpunkt in Grad brauchst \u2014 diese Zahl liegt f\u00fcr keines der \u00d6le vor.',
      luecke:'Rauchpunkt: f\u00fcr kein \u00d6l im Sortiment ist ein Wert in Grad belegt. Die Einteilung oben ist eine Verwendungsangabe, keine Messung.',
      datenlage:ja.length+' \u00d6le zum Braten vorgesehen, '+nein.length+' ausdr\u00fccklich nicht \u00b7 Belegstufe A und B, je Artikel ausgewiesen',
      evidence:Object.keys(OEL_BRATEN).length+' von '+oele.length+' \u00d6len mit Verwendungsangabe',
      source:OEL_SENSORIK_QUELLE
    };
  }

  /* ---- 2. "Wozu passt ...?" ------------------------------------- */
  const gerichte = [...new Set(s.match(new RegExp(OEL_GERICHT.source,'g'))||[])];
  if(OEL_PASSTFRAGE.test(s) && (namen.length || gerichte.length)){
    /* 2a. Ein bestimmtes \u00d6l ist gemeint. */
    if(namen.length){
      const gemeint = namen.map(oelArtikel).filter(Boolean);
      const mit = gemeint.filter(p=>p.sens && p.sens.passt);
      if(mit.length){
        const fehlt = gemeint.filter(p=>!(p.sens && p.sens.passt));
        return {
          summary:'Du fragst, wozu dieses \u00d6l passt.',
          tags:['Verwendung'].concat(mit.map(p=>kurz(p.t))),
          eyebrow:'Passt dazu', title:mit.length===1?kurz(mit[0].t):'Zwei \u00d6le tragen diesen Namen',
          intro: mit.map(p=>kurz(p.t)+': '+p.sens.passt.join(', ')+'. Eher nicht: '+p.sens.passtNicht.join(', ')+'. Belegstufe '+p.sens.beleg+'.').join(' ')
            + (fehlt.length?' Ohne Angabe: '+fehlt.map(p=>kurz(p.t)).join(', ')+'.':''),
          visual:'oils', refine:false,
          pick:()=>mit.concat(fehlt),
          metrics: mit.map(p=>[p.sens.satz, kurz(p.t)+' \u00b7 Belegstufe '+p.sens.beleg]),
          why:'Die Verwendungsangaben stehen wortgleich am Artikel im Shop. Kuno formuliert sie nicht um.',
          limit:'du eine Empfehlung f\u00fcr ein bestimmtes Rezept suchst \u2014 dann hilft die Rezeptsuche weiter.',
          eigen: mit.map(p=>p.sens.glas).filter(Boolean).join(' '),
          datenlage: mit.length+' \u00d6l'+(mit.length===1?'':'e')+' mit Verwendungsangabe \u00b7 Belegstufe '+[...new Set(mit.map(p=>p.sens.beleg))].join(' und '),
          evidence:'Verwendungsangabe am Artikel',
          source:OEL_SENSORIK_QUELLE
        };
      }
    }
    /* 2b. Ein Gericht ist gemeint. */
    if(gerichte.length){
      const treffer = mitProfil.filter(p=>p.sens.passt.some(z=>gerichte.some(g=>z.toLowerCase().indexOf(g)>=0)));
      const warnung = mitProfil.filter(p=>p.sens.passtNicht.some(z=>gerichte.some(g=>z.toLowerCase().indexOf(g)>=0)));
      if(treffer.length){
        return {
          summary:'Du fragst nach einem \u00d6l f\u00fcr ein bestimmtes Gericht.',
          tags:['Verwendung'].concat(gerichte),
          eyebrow:'Passt dazu', title:treffer.length+' \u00d6l'+(treffer.length===1?'':'e')+' nennen das ausdr\u00fccklich',
          intro:'Gesucht wurde in den Verwendungsangaben der Artikel, nicht geraten. '
            + treffer.map(p=>kurz(p.t)+': '+p.sens.passt.filter(z=>gerichte.some(g=>z.toLowerCase().indexOf(g)>=0)).join(', ')+' (Belegstufe '+p.sens.beleg+')').join('. ')+'. '
            + (warnung.length?'Ausdr\u00fccklich abgeraten wird bei: '+warnung.map(p=>kurz(p.t)).join(', ')+'. ':'')
            + luecke,
          visual:'oils', refine:false,
          pick:()=>treffer,
          metrics: treffer.map(p=>[p.sens.satz, kurz(p.t)+' \u00b7 Belegstufe '+p.sens.beleg]),
          why:'Nur \u00d6le, an denen die Verwendung wirklich steht. Wer nichts dazu sagt, wird nicht empfohlen.',
          limit:'du ein \u00d6l suchst, zu dem noch keine Verwendungsangabe vorliegt.',
          datenlage:treffer.length+' von '+mitProfil.length+' verkosteten \u00d6len passen zur Suche \u00b7 '+stufeA+' davon Belegstufe A',
          evidence:treffer.length+' \u00d6le mit passender Verwendungsangabe',
          source:OEL_SENSORIK_QUELLE
        };
      }
    }
  }

  /* ---- 3. Ein bestimmtes \u00d6l, Geschmacksfrage ---------------------- */
  if(namen.length===1 && oelArtikel(namen[0]) && oelArtikel(namen[0]).sens && oelArtikel(namen[0]).sens.satz
     && (SENS_WORT.test(s) || OEL_ACHS_FRAGE.some(a=>a.re.test(s)))){
    const p=oelArtikel(namen[0]), v=p.sens;
    return {
      summary:'Du hast nach dem Geschmack eines bestimmten \u00d6ls gefragt.',
      tags:['Geschmack', kurz(p.t), 'Belegstufe '+v.beleg],
      eyebrow:'Geschmack', title:kurz(p.t),
      intro:v.satz+' Auf der Skala von 1 bis 5: Bitterkeit '+oelWert(v.bitterkeit)+' ('+oelStufe(v.bitterkeit)+'), Sch\u00e4rfe '+oelWert(v.schaerfe)+' ('+oelStufe(v.schaerfe)+'), Fruchtigkeit '+oelWert(v.frucht)+', Nussigkeit '+oelWert(v.nuss)+', Rundheit '+oelWert(v.rundheit)+', Intensit\u00e4t '+oelWert(v.intensitaet)+', Nachklang '+oelWert(v.nachklang)+'. Belegstufe '+v.beleg+'. Passt zu: '+v.passt.join(', ')+'.',
      visual:'oils', refine:false,
      pick:()=>[p],
      metrics:[[oelWert(v.bitterkeit),'Bitterkeit'],[oelWert(v.schaerfe),'Sch\u00e4rfe'],[oelWert(v.frucht),'Fruchtigkeit'],[oelWert(v.nuss),'Nussigkeit'],[oelWert(v.rundheit),'Rundheit'],[oelWert(v.intensitaet),'Intensit\u00e4t'],[oelWert(v.nachklang),'Nachklang']],
      why:'Aus dem Glas: alle sechs \u00d6le wurden am selben Tag nebeneinander probiert, deshalb sind die Zahlen untereinander vergleichbar.',
      limit:'du deinen eigenen Geschmack meinst. Eine Zahl ersetzt den eigenen L\u00f6ffel nicht.',
      eigen:v.glas||'',
      datenlage:'1 \u00d6l aus der Blindverkostung vom 12.08.2026 \u00b7 Belegstufe '+v.beleg,
      evidence:'Belegstufe '+v.beleg,
      source:OEL_SENSORIK_QUELLE
    };
  }

  /* ---- 4. Liste nach einer Achse -------------------------------- */
  const achse = OEL_ACHS_FRAGE.find(a=>a.re.test(s));
  if(!achse) return null;
  const liste = mitProfil.slice().sort((a,b)=> achse.hoch
    ? b.sens[achse.feld]-a.sens[achse.feld]
    : a.sens[achse.feld]-b.sens[achse.feld]);
  const spitze = liste[0];
  return {
    summary:'Du hast nach dem Geschmack der \u00d6le gefragt. Sie stehen nach der verkosteten '+achse.wort+' geordnet.',
    tags:['Geschmack', achse.wort, liste.length+' \u00d6le'],
    eyebrow:'Geschmack',
    title: achse.hoch ? 'Nach '+achse.wort+', die st\u00e4rkste zuerst' : 'Von mild nach kr\u00e4ftig',
    intro:'Geordnet nach '+achse.wort+' auf einer Skala von 1 bis 5, '
      + (achse.hoch?'der h\u00f6chste Wert zuerst. ':'der niedrigste Wert zuerst. ')
      + 'Alle f\u00fcnf \u00d6le wurden am 12.08.2026 nebeneinander in blauen Gl\u00e4sern probiert, deshalb sind die Zahlen untereinander vergleichbar. '
      + kurz(spitze.t)+' steht vorn: '+spitze.sens.satz+' '
      + luecke,
    visual:'oils', refine:false,
    pick:()=>liste,
    metrics: liste.map(p=>[oelWert(p.sens[achse.feld]), kurz(p.t)+' \u00b7 '+achse.wort+' '+oelStufe(p.sens[achse.feld])+' \u00b7 Belegstufe '+p.sens.beleg]),
    why:'Die Reihenfolge kommt aus einer Blindverkostung, nicht aus einer Auswahl von Hand. Farbe und Etikett waren dabei verdeckt.',
    limit:'du nach eigenem Geschmack entscheiden willst. Eine Skala ersetzt den eigenen L\u00f6ffel nicht.',
    datenlage:mitProfil.length+' von '+oele.length+' \u00d6len verkostet \u00b7 '+stufeA+' Belegstufe A, '+(mitProfil.length-stufeA)+' Belegstufe B',
    evidence:mitProfil.length+' von '+oele.length+' \u00d6len mit Profil',
    source:OEL_SENSORIK_QUELLE
  };
}

/* Kurzer, neutraler Erklaertext je Warengruppe. Keine Wirkaussage. */
const ERKLAERT = {
 honig:{h:'Das ist Honig',t:'Honig entsteht, wenn Bienen Blütennektar oder Honigtau eintragen und eindicken. Sortenname und Farbe kommen von der Pflanze, an der gesammelt wurde.'},
 oel:{h:'Das ist Olivenöl nativ extra',t:'Nativ extra heißt: nur mechanisch gepresst, ohne Wärme oder Lösungsmittel, und im Geschmackstest fehlerfrei. Polyphenolwerte gelten immer für eine bestimmte Charge.'},
 essig:{h:'Das ist Aceto Balsamico di Modena',t:'Traubenmost und Weinessig reifen in Holzfässern. Die Medaillen geben die Reifestufe des Herstellers an, nicht eine amtliche Güteklasse.'},
 schinken:{h:'Das ist Ibérico Bellota',t:'Schweine der Rasse Ibérico, in der Eichelmast gefüttert, luftgetrocknet über Jahre. Die Monatsangabe nennt die Reifezeit.'},
 nuss:{h:'Nüsse und Kerne',t:'Roh, geröstet oder gesalzen unterscheiden sich im Geschmack und in den Werten je 100 g. Die Füllmenge steht im Titel.'},
 trockenfrucht:{h:'Trockenfrüchte',t:'Wasser wird entzogen, der natürliche Zucker bleibt und tritt dadurch je 100 g stärker hervor.'},
 schoko:{h:'Schokolade',t:'Der Kakaoanteil bestimmt Bitterkeit und Süße. Bei Tafeln von 70 bis 92 Prozent verschiebt sich beides deutlich.'},
 tee:{h:'Tee und Kräuteraufgüsse',t:'Grün-, Schwarz- und Kräutertee unterscheiden sich in Zutat und Koffein. Kaltaufguss braucht mehr Zeit, nicht mehr Blattmenge.'},
 matcha:{h:'Das ist Matcha',t:'Gemahlener Grüntee, der vollständig getrunken wird. Deshalb enthält Matcha mehr Koffein als aufgegossener Tee.'},
 riegel:{h:'Gemüseriegel',t:'Gemüse, Saaten und Gewürze gepresst. Bei diesen Riegeln fehlt bisher das Stückgewicht, deshalb steht keine Zahl je Riegel.'},
 nussmus:{h:'Nussmus und Cremes',t:'Gemahlene Nüsse, teils mit Zutaten wie Zucker. Der Nussanteil steht auf dem Etikett.'},
 tomate:{h:'Sonnengetrocknete Tomaten',t:'In der Sonne getrocknet, dadurch konzentrierter Geschmack. Fein gehackt, in Streifen oder ganz.'},
 oliven:{h:'Tafeloliven',t:'Rohe Oliven schmecken bitter. Erst Salzlake oder Lauge macht sie essbar — deshalb bringt jede Tafelolive Salz mit. Die Sorte bestimmt Größe, Biss und Aroma.'},
 suesses:{h:'Fruchtgummi und Süßes',t:'Zuckerarm heißt nicht zuckerfrei. Die Zahl je 100 g steht auf dem Etikett.'},
 saat:{h:'Saaten',t:'Lein, Chia und Quinoa vom Erzeuger. Ballaststoffe und Eiweiß je 100 g stehen auf dem Etikett.'},
 erg:{h:'Nahrungsergänzung',t:'Angaben gelten je Kapsel oder je Portion. Die Prozentangabe bezieht sich auf die Referenzmenge eines Erwachsenen.'},
 set:{h:'Sets und Vorratspakete',t:'Beim Set gilt der Setpreis. Die Reichweite richtet sich nach dem Bestandteil, der zuerst leer ist.'}
};

/* Belegte Naehrwerte je 100 g. Nur was auf dem Etikett steht.
   Alle sieben Honige haben identische Werte - das ist der Befund,
   nicht eine Vereinfachung. Quelle: Etikett, geprueft 30.07.2026. */
const NAEHRWERT = {};
['10001','10002','10003','10004','10009','10013','10014'].forEach(s=>{
  NAEHRWERT[s]={kcal:320,zucker:79,salz:0.03,eiweiss:0.4,quelle:'Etikett'};
});
/* Am 13.08.2026 aus der Naehrwerttabelle der echten Produktseite
   uebernommen, Werte je 100 g, jede Zahl zweimal abgerufen und
   verglichen. Anlass war Alexanders Frage nach dem Salz in den Oliven -
   der Wert stand die ganze Zeit im Shop, nur nicht in Kunos Tabelle.
   Ein fehlendes Feld bleibt leer, es wird nichts ergaenzt. */
NAEHRWERT['10172']={kcal:211,zucker:0,salz:3.3,eiweiss:1.6,fett:21,quelle:'Produktseite, Nährwertangaben je 100 g'};
NAEHRWERT['10167']={kcal:647,zucker:4.9,salz:0.02,eiweiss:20,fett:53,quelle:'Produktseite, Nährwertangaben je 100 g'};
/* 10168 (dieselbe Pistazie, gesalzen) bleibt bewusst leer. Die Werte
   von 10167 zu uebernehmen waere eine Schaetzung - und ausgerechnet
   der Salzwert waere die eine Zahl, die sicher abweicht. */
/* 10007: Energie, Fett und Zucker stehen eindeutig da. Das Salz steht
   NUR in der Fliesstext-Liste, nicht in der Naehrwerttabelle, und das
   Eiweiss widerspricht sich zwischen beiden (33 g im Text, 32 g in der
   Tabelle). Deshalb steht hier kein Eiweisswert. Beides gehoert
   korrigiert, bevor die Zahl irgendwo sichtbar wird. */
NAEHRWERT['10007']={kcal:321,zucker:0,salz:4.1,eiweiss:null,fett:21,quelle:'Produktseite, Abschnitt Inhaltsstoffe & Nährwerte'};

/* Vergleich: "vergleiche X und Y" */
function findeNachName(wort){
  const w=wort.toLowerCase().trim();
  if(w.length<4) return null;
  /* Der exakte Wort-Treffer zuerst. "Oliven" meint die Tafeloliven
     10172 - im Olivenoel steht "Olivenöl" als EIN Wort, das ist ein
     anderer Begriff. Bis 13.08.2026 gewann der Teilstring, und die
     Frage nach dem Salz in den Oliven landete beim Oel. Dieselbe
     Fehlerart wie bei nuss/Genuss und niere/stornieren, nur an einer
     anderen Stelle (siehe Abschnitt 0, Regel 3). */
  const exakt = PRODUKTE.find(p=>normTitel(p.t).split(' ').includes(w));
  if(exakt) return exakt;
  return PRODUKTE.find(p=>p.t.toLowerCase().includes(w))
      || PRODUKTE.find(p=>normTitel(p.t).split(' ').some(t=>t.startsWith(w.slice(0,6))));
}
/* "den Geschmack von Bluetenhonig" ist kein Artikelname, "Bluetenhonig"
   schon. Loest der ganze Satzteil nicht auf, werden ruecklaeufig seine
   langen Woerter probiert - das hintere Wort ist fast immer der Name.
   Ergaenzt 15.08.2026, vorher landete "Unterschied im Geschmack
   zwischen X und Y" bei einer voellig anderen Antwort. */
function nameAusTeil(teil){
  const direkt=findeNachName(teil);
  if(direkt) return direkt;
  const worte=teil.split(/[^a-zäöüß0-9]+/).filter(w=>w.length>4);
  for(let i=worte.length-1;i>=0;i--){
    const t=findeNachName(worte[i]);
    if(t) return t;
  }
  return null;
}
function vergleichAntwort(s){
  if(!/vergleich|unterschied|oder besser|versus|\bvs\b/.test(s)) return null;
  const rest=s.replace(/vergleiche?|unterschied( zwischen)?|besser|versus|\bvs\b|zwischen/g,' ');
  const teile=rest.split(/\bund\b|,|\bgegen\b|\boder\b/).map(t=>t.trim()).filter(t=>t.length>3);
  if(teile.length<2) return null;
  const a=nameAusTeil(teile[0]), b=nameAusTeil(teile[1]);
  if(!a||!b||a===b) return null;
  const zeile=(feld,wa,wb,gleich)=>({feld,a:wa,b:wb,u:gleich});
  const ga=grundpreis(a), gb=grundpreis(b);
  const na=NAEHRWERT[a.s], nb=NAEHRWERT[b.s];
  /* Liegt ein Verkostungsprofil vor, steht es in der Zeile statt des
     knappen Titelworts. Ergaenzt 15.08.2026. */
  const notiz=p=>p.sens ? p.sens.geschmack : (p.n||'noch nicht verkostet');
  const zeilen=[
    zeile('Geschmacksnotiz', notiz(a), notiz(b), notiz(a)===notiz(b)?'gleich':'unterschiedlich'),
    zeile('Füllmenge', mengeText(a), mengeText(b), mengeText(a)===mengeText(b)?'gleich':'unterschiedlich'),
    zeile('Preis', eur(a.p), eur(b.p), a.p===b.p?'gleich':eur(Math.abs(a.p-b.p))+' Unterschied'),
    zeile('Preis je '+(ga?ga.einheit:'kg'), ga?eur(ga.wert):'—', gb?eur(gb.wert):'—',
          (ga&&gb)?(Math.abs(ga.wert-gb.wert)<0.005?'gleich':eur(Math.abs(ga.wert-gb.wert))+' Unterschied'):'nicht berechenbar')
  ];
  if(na&&nb){
    zeilen.push(zeile('Energie je 100 g', na.kcal+' kcal', nb.kcal+' kcal', na.kcal===nb.kcal?'gleich':'unterschiedlich'));
    zeilen.push(zeile('Zucker je 100 g', zahl(na.zucker)+' g', zahl(nb.zucker)+' g', na.zucker===nb.zucker?'gleich':'unterschiedlich'));
    zeilen.push(zeile('Salz je 100 g', zahl(na.salz)+' g', zahl(nb.salz)+' g', na.salz===nb.salz?'gleich':'unterschiedlich'));
  }
  const belegt=(na&&nb)?7:4;
  const gleichAlle=na&&nb&&na.kcal===nb.kcal&&na.zucker===nb.zucker;
  return {
    eyebrow:'Vergleich', title:kurz(a.t)+' und '+kurz(b.t),
    intro:gleichAlle
      ? 'Bei den Nährwerten gibt es keinen Unterschied. Was die beiden trennt, ist der Geschmack und der Preis je Kilogramm.'
      : 'Gegenübergestellt sind nur Werte, die für beide Artikel belegt sind.',
    tags:['Vergleich', kurz(a.t), kurz(b.t)],
    vergleich:{a:a,b:b,zeilen:zeilen},
    refine:false, metrics:[],
    why:'Verglichen wird nur, was auf beiden Etiketten steht. Fehlt ein Wert bei einem der beiden, entfällt die Zeile.',
    limit:'du nach Geschmack entscheiden willst — die Verkostungswerte sind noch nicht erhoben.',
    evidence:belegt+' von '+belegt+' verglichenen Feldern belegt',
    source:'Preise aus dem Shop, Stand 31.07.2026 · Nährwerte vom Etikett · nichts geschätzt.'
  };
}

/* Berechnung: "wie viel Zucker sind in 30 g Honig" */
const REFERENZ={salz:{menge:6,text:'Orientierungswert der Deutschen Gesellschaft für Ernährung: höchstens 6 g Salz am Tag'}};
/* -----------------------------------------------------------------
   Naehrwertfrage OHNE Mengenangabe.

   Gefunden von Alexander am 13.08.2026: "Wie viel Salz ist denn in den
   Oliven enthalten?" - Kuno zeigte acht Nuss-Artikel und die Salzzahl
   einer Pistazie. Die Oliven waren nicht einmal dabei.

   Ursache: berechnungAntwort() verlangt eine Grammzahl im Satz. Ohne
   sie fiel die Frage durch bis zur letzten Zeile von classify(), wo
   das blosse Wort "salz" die Snack-Antwort ausloest.

   Alexanders Vorgabe war eindeutig: entweder die Zahl, oder ehrlich
   sagen, dass der Wert fehlt, und etwas anderes anbieten - nie
   irgendetwas Beliebiges zeigen.

   Diese Funktion beantwortet die Frage je 100 g. Fehlt der Wert, sagt
   sie genau das, zeigt den richtigen Artikel und bietet einen Weg
   weiter an. Sie greift nur, wenn ein Naehrstoff, eine Frageform UND
   ein erkennbarer Artikel zusammenkommen - sonst gibt sie null zurueck
   und die bisherige Kette laeuft unveraendert weiter.
   ----------------------------------------------------------------- */
const NAEHRSTOFF_NAME={zucker:'Zucker',salz:'Salz',kcal:'Energie',eiweiss:'Eiweiß',fett:'Fett'};
function naehrstoffAus(s){
  return /zucker/.test(s)?'zucker'
       : /salz|natrium|salzgehalt/.test(s)?'salz'
       : /kalorien|energie|kcal|brennwert/.test(s)?'kcal'
       : /eiweiß|eiweiss|protein/.test(s)?'eiweiss'
       : /fettgehalt|wie ?viel fett/.test(s)?'fett'
       : null;
}
/* Die Frageworte selbst duerfen nie als Artikelname gelten - "zucker"
   traf sonst den Artikel "Zuckerarm". "enthalten" und "gehalt" sind am
   13.08.2026 dazugekommen, sie standen woertlich in Alexanders Frage. */
const STOPPWORT=/^(zucker|salz|salzgehalt|zuckergehalt|fettgehalt|kalorien|energie|brennwert|eiweiss|eiweiß|protein|portion|gramm|viel|wieviel|stecken|enthält|enthalten|steckt|drin|denn|berechne|davon|einer|eurem|meine|meinem|natrium)$/;
function artikelAusFrage(s){
  const kandidaten=s.replace(/[^a-zäöüß ]/g,' ').split(/\s+/)
    .filter(w=>w.length>4 && !STOPPWORT.test(w));
  for(let i=kandidaten.length-1;i>=0;i--){
    const t=findeNachName(kandidaten[i]);
    if(t) return t;
  }
  return null;
}
function naehrwertAntwort(s){
  const stoff=naehrstoffAus(s);
  if(!stoff) return null;
  if(!/wie ?viel|wieviel|gehalt|enthält|enthalten|steckt|stecken|drin|angabe/.test(s)) return null;
  /* Steht eine Menge im Satz, gehoert die Frage der Berechnung. */
  if(/(\d+(?:[.,]\d+)?)\s*(g|gramm)\b/.test(s)) return null;
  const wort=artikelAusFrage(s);
  if(!wort) return null;
  const nw=NAEHRWERT[wort.s];
  const name=NAEHRSTOFF_NAME[stoff];
  const einheit=stoff==='kcal'?'kcal':'g';
  if(!nw || nw[stoff]==null){
    return {
      eyebrow:'Nährwert', title:name+' in '+kurz(wort.t)+' — Wert fehlt noch',
      intro:'Für diesen Artikel steht '+name.toLowerCase()+' noch nicht in der Datenbank. Geschätzt wird nichts, auch nicht aus einem ähnlichen Produkt.',
      tags:['Nährwert','Wert fehlt',name],
      refine:false, metrics:[],
      pick:()=>[wort],
      choice:[
        {title:'Belegte Werte dieses Artikels',desc:'Was für '+kurz(wort.t)+' tatsächlich hinterlegt ist.',ask:'Vergleiche '+kurz(wort.t)+' und Blütenhonig'},
        {title:'Artikel mit belegtem '+name,desc:'Die Artikel, bei denen die Zahl vom Etikett vorliegt.',ask:name+' je 100 g im Sortiment'}
      ],
      why:'Eine Zahl erscheint erst, wenn sie vom Etikett oder aus der Nährwerttabelle des Shops kommt.',
      limit:'du eine Näherung möchtest — die gibt es hier nicht.',
      evidence:'0 von 1 Wert belegt',
      source:'Nährwerte werden nur aus der Deklaration übernommen, nie aus dem Web ergänzt.'
    };
  }
  const wert=nw[stoff];
  const ref=REFERENZ[stoff];
  return {
    eyebrow:'Nährwert', title:name+' in '+kurz(wort.t),
    intro:name+' je 100 g, direkt aus der Nährwertangabe des Artikels. Für eine Portionsmenge nenne sie einfach mit, zum Beispiel „'+name.toLowerCase()+' in 30 g".',
    tags:['Nährwert','je 100 g',name],
    metrics:[[zahl(wert)+' '+einheit, name+' je 100 g']]
      .concat(ref ? [[Math.round(wert/ref.menge*100)+' %', 'von '+ref.text+', bezogen auf 100 g']] : []),
    refine:false,
    pick:()=>[wort],
    why:'Die Grundlage ist die Nährwertangabe des Herstellers je 100 g. Wie viel davon auf deinem Teller landet, bestimmst du.',
    limit:'du eine persönliche Tagesmenge suchst — die hängt von Alter, Bewegung und Vorerkrankungen ab.',
    evidence:'1 von 1 Wert belegt',
    source:nw.quelle ? ('Quelle: '+nw.quelle+', geprüft 13.08.2026.') : 'Nährwerte vom Etikett.'
  };
}

function berechnungAntwort(s){
  const m=s.match(/(\d+(?:[.,]\d+)?)\s*(g|gramm)\b/);
  const stoff=/zucker/.test(s)?'zucker':/salz/.test(s)?'salz':/kalorien|energie|kcal/.test(s)?'kcal':/eiweiß|eiweiss|protein/.test(s)?'eiweiss':null;
  if(!m||!stoff||!/wie ?viel|berechne|enthält|stecken|sind in/.test(s)) return null;
  const menge=Number(m[1].replace(',','.'));
  /* Die Frageworte selbst duerfen nicht als Artikelname gelten:
     "zucker" traf sonst den Artikel "Zuckerarm". Gefunden 31.07.2026. */
  const STOPP=/^(zucker|salz|salzgehalt|kalorien|energie|eiweiss|eiweiß|protein|portion|gramm|viel|wieviel|stecken|enthält|berechne|davon|einer|meine|meinem)$/;
  const kandidaten=s.replace(/[^a-zäöüß ]/g,' ').split(/\s+/)
    .filter(w=>w.length>4 && !STOPP.test(w));
  let wort=null;
  for(let i=kandidaten.length-1;i>=0 && !wort;i--) wort=findeNachName(kandidaten[i]);
  if(!wort) return null;
  const nw=NAEHRWERT[wort.s];
  const name={zucker:'Zucker',salz:'Salz',kcal:'Energie',eiweiss:'Eiweiß'}[stoff];
  const einheit=stoff==='kcal'?'kcal':'g';
  /* Ein einzelnes leeres Feld zaehlt wie ein fehlender Satz. Beim
     Schinkenwuerfel 10007 widerspricht sich das Eiweiss zwischen
     Text und Tabelle - dann erscheint hier keine Zahl. */
  if(!nw || nw[stoff]==null){
    return {
      eyebrow:'Berechnung', title:name+' in '+zahl(menge)+' g '+kurz(wort.t)+' — Wert fehlt noch',
      intro:'Für diesen Artikel liegt der Wert noch nicht in der Datenbank. Geschätzt wird nichts.',
      tags:['Berechnung','Wert fehlt'], refine:false, metrics:[],
      pick:()=>[wort],
      why:'Eine Zahl erscheint erst, wenn sie vom Etikett kommt.',
      limit:'du eine Näherung möchtest — die gibt es hier nicht.',
      evidence:'0 von 1 Wert belegt',
      source:'Nährwerte werden nur vom Etikett übernommen.'
    };
  }
  const wert=nw[stoff]*menge/100;
  const ref=REFERENZ[stoff];
  return {
    eyebrow:'Berechnung', title:name+' in '+zahl(menge)+' g '+kurz(wort.t),
    intro:'Gerechnet mit dem Wert vom Etikett, nicht mit einem Durchschnitt.',
    tags:['Berechnung', zahl(menge)+' g', name],
    rechnung:{
      produkt:wort, stoff:name, menge:menge, basis:nw[stoff], einheit:einheit,
      ergebnis:wert,
      formel:zahl(nw[stoff])+' '+einheit+' je 100 g × '+zahl(menge)+' g ÷ 100 = '+zahl(wert)+' '+einheit,
      anteil: ref ? Math.round(wert/ref.menge*100) : null,
      referenz: ref ? ref.text : null
    },
    refine:false, metrics:[], pick:()=>[wort],
    why:'Die Grundlage ist die Nährwertangabe des Herstellers je 100 g. Die Portionsgröße bestimmst du.',
    limit:'du eine persönliche Tagesmenge suchst — die hängt von Alter, Bewegung und Vorerkrankungen ab.',
    evidence:'1 von 1 Wert belegt (Etikett)',
    source:'Nährwerte vom Etikett, geprüft 30.07.2026 · Werte gerundet.'
  };
}

/* Rezepte: echte Artikel aus dem Shopify-Magazin "Rezepte"
   (auteniq.de/blogs/rezepte), Stand 31.07.2026, 41 Artikel per GraphQL
   gezogen. Titel, Bild, Kategorie (g, aus dem echten Shopify-Tag) und
   Stichwort (w, nur wenn der Titel selbst das Wort enthaelt) - nichts
   davon ist erfunden oder zusammengefasst. Ein Rezept ist eine
   Geschmacksfrage, keine Gesundheitsfrage - die HCVO betrifft diese
   Antwort nicht. Gebaut, weil "Rezepte für Tee" bisher nur Tee-Produkte
   zeigte und die Rezepte selbst fehlten (Alexander, 31.07.2026). */
const REZEPTE = [
 {h:'lazy-daze-ice-tea',t:'Lazy Daze Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/samova-lazy-daze-drink-olden-daze_800x800_2x_1920x1920_e00c218c-1a4e-4455-a425-fa9994aff8cc.webp?v=1780058710'},
 {h:'team-spirit-eistee',t:'Team Spirit Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Team_Spirit_Eistee_da3d0aec-e440-4e47-92c8-533412dfe213.png?v=1780490616'},
 {h:'high-darling-ice-tea',t:'High Darling Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/High_Darling_Ice_Tea.png?v=1780490552'},
 {h:'maybe-baby-ice-tea',t:'Maybe Baby Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Maybe_Baby_Icetea.png?v=1780490555'},
 {h:'istanbul-nights-ice-tea',t:'Istanbul Nights Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Istanbul_Nights_Icetea.png?v=1780490557'},
 {h:'scuba-garden-ice-tea',t:'Scuba Garden Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Scuba_Garden_Icetea.png?v=1780490559'},
 {h:'heidis-delight-ice-tea',t:"Heidi's Delight Ice Tea",g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Heidis_Delight_Icetea.png?v=1780490562'},
 {h:'space-cookie-chai-latte',t:'Space Cookie Chai Latte',g:'warm',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Space_Cookie_Chai_Latte.png?v=1780490564'},
 {h:'low-rider-on-ice',t:'Low Rider on Ice – grüner Eistee mit Limette',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Low_Rider_on_Ice.png?v=1780490592'},
 {h:'master-mint-on-ice',t:'Master Mint on Ice – Minz-Eistee mit Lemongrass',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Master_Mint_on_Ice.png?v=1780490594'},
 {h:'english-breakfast-on-ice',t:'English Breakfast on Ice – Schwarztee-Eistee mit Zitrone',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/English_Breakfast_on_Ice.png?v=1780490596'},
 {h:'jasmine-green-on-ice',t:'Jasmine Green on Ice – blumiger Grüntee-Cocktail',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Jasmine_Green_on_Ice.png?v=1780490599'},
 {h:'straight-forward-on-ice',t:'Straight Forward on Ice – Assam-Eistee mit Zitrone',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Straight_Forward_on_Ice.png?v=1780490601'},
 {h:'karibu-sundowner',t:'Karibu Sundowner – wärmender Rooibos-Punsch',g:'warm',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Karibu_Sundowner.png?v=1780490603'},
 {h:'rodeo-rose-eistee',t:'Rodeo Rose Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Rodeo_Rose_Eistee.png?v=1780490277'},
 {h:'garden-party-fruity-garden',t:'Garden Party Fruity Garden',g:'kalt',w:'',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Garden_Party_Fruity_Garden.png?v=1780490615'},
 {h:'gin-soul-tonic',t:'Gin Soul Tonic',g:'kalt',w:'tee',alk:true,b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Gin_Soul.png?v=1780490612'},
 {h:'inner-light-eistee-mit-limette',t:'Inner Light Ice Tea mit Limette',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Inner_Light_Eistee.png?v=1780490283'},
 {h:'orange-safari-eistee-mit-birne',t:'Orange Safari Ice Tea mit Birne',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Orange_Safari_Eistee.png?v=1780490289'},
 {h:'smooth-operator-kamillen-latte',t:'Smooth Operator Chai Latte',g:'warm',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Smooth_Operator_Kamillen-Latte.png?v=1780490295'},
 {h:'digital-detox-ice-tea',t:'Digital Detox Ice Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Digital_Detox_Rezept.png?v=1780996411'},
 {h:'business-trip-classic-iced-tea',t:'Business Trip Classic Iced Tea',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Business_Trip_Rezept.png?v=1780996413'},
 {h:'saint-peters-nordsee-eistee',t:"Saint Peter's Nordsee-Eistee",g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Saint_Peters_Rezept.png?v=1780996415'},
 {h:'gruentee-pesto',t:'Grüntee-Pesto mit japanischem Bio-Tee',g:'kochen',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Gruentee_Pesto_20ad4fce-9295-43bf-9773-7305a93bb8af.png?v=1781695303'},
 {h:'hojicha-apfel-muffins',t:'Hojicha-Apfel-Muffins',g:'backen',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Muffins_49b7d3a7-c7e8-434b-b4c1-7cfe5f2ed9e5.png?v=1781695306'},
 {h:'matcha-latte',t:'Matcha Latte mit Bio-Matcha',g:'warm',w:'matcha',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Matcha_Latte_8ac408ba-0b57-4f71-a55b-e6adaba65cbe.png?v=1781695309'},
 {h:'matcha-tiramisu',t:'Matcha Tiramisu',g:'backen',w:'matcha',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Matcha_Tiramisu_071a7437-ae2b-4e12-a644-0101fa2bec1e.png?v=1781695348'},
 {h:'soft-matcha-cookies',t:'Soft Matcha Cookies',g:'backen',w:'matcha',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Cookies_6639f1c0-969d-4c30-9bd8-a59662ad4de5.png?v=1781695351'},
 {h:'japanischer-gruener-eistee',t:'Japanischer Grüntee-Eistee',g:'kalt',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Eistee_7231864f-e257-48a9-b67e-5a13fb2cc497.png?v=1781695355'},
 {h:'wakoucha-orangen-aufguss',t:'Wakoucha-Orangen-Aufguss',g:'warm',w:'tee',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Orangen_aufguss_273249a0-9533-46ef-b276-aaaa59c46b74.png?v=1781695392'},
 {h:'iced-strawberry-matcha-latte',t:'Iced Strawberry Matcha Latte',g:'kalt',w:'matcha',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Iced_Strawberry_Matcha_97e86fbf-c500-4228-9b55-afc6af50b362.png?v=1781695394'},
 {h:'matcha-kokos-latte-vanille',t:'Matcha-Kokos-Latte mit Vanille',g:'warm',w:'matcha',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Vanille_Kokos_Matcha_0d72db52-c3d0-41b5-b191-a107bb44cf77.png?v=1781695397'},
 {h:'pan-con-tomate-mit-iberico-schinken',t:'Pan con tomate mit Ibérico-Schinken',g:'kochen',w:'schinken',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-pan-con-tomate.jpg?v=1783434716'},
 {h:'huevos-rotos-mit-iberico-schinken',t:'Huevos rotos mit Ibérico-Schinken',g:'kochen',w:'schinken',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-huevos-rotos.jpg?v=1783434719'},
 {h:'heisse-schokolade-geschmolzen',t:'Heiße Schokolade – geschmolzen statt angerührt',g:'warm',w:'schoko',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-heisse-schokolade.jpg?v=1783434736'},
 {h:'zartbitter-brownies',t:'Zartbitter-Brownies – saftig durch echte Schokolade',g:'backen',w:'schoko',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-brownies.jpg?v=1783434724'},
 {h:'gazpacho-kalte-tomatensuppe',t:'Gazpacho – kalte Suppe für heiße Tage',g:'kochen',w:'tomate',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-gazpacho.jpg?v=1783434722'},
 {h:'aioli-selbst-geruehrt',t:'Aioli: aus Knoblauch und Olivenöl gerührt',g:'kochen',w:'oel',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-aioli.jpg?v=1783434731'},
 {h:'overnight-oats-mit-chia-und-leinsamen',t:'Overnight Oats mit Chia und Leinsamen',g:'backen',w:'',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-overnight-oats.jpg?v=1783434733'},
 {h:'quinoa-salat-mit-sommergemuese',t:'Quinoa-Salat mit Sommergemüse',g:'kochen',w:'',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-quinoa-salat.jpg?v=1783434728'},
 {h:'erdnusssauce-aus-geroesteten-erdnuessen',t:'Erdnusssauce aus gerösteten Erdnüssen',g:'kochen',w:'erdnuss',b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/rezept-erdnusssauce.jpg?v=1783436879'}
];
const REZEPT_TAG_LABEL = {kalt:'Kalte Getränke',warm:'Warme Getränke',kochen:'Herzhaft gekocht',backen:'Backen & Dessert'};
const REZEPT_WORT_ZU_K = {tee:'tee',matcha:'matcha',schinken:'schinken',schoko:'schoko',oel:'oel',tomate:'tomate'};
function rezeptURL(h){ return 'https://auteniq.de/blogs/rezepte/'+h; }
/* Dieselbe Wortliste wie in categoryOf() / classify() - "öl" bekommt
   dieselbe Grenzpruefung, weil \b bei "ö" nicht funktioniert. */
function findeStichwort(s){
  if(s.includes('honig')) return 'honig';
  if(s.includes('matcha')) return 'matcha';
  if(s.includes('schinken')) return 'schinken';
  if(s.includes('schoko')) return 'schoko';
  if(s.includes('tomate')) return 'tomate';
  if(s.includes('olivenöl')||s.includes('olivenoel')) return 'oel';
  if(/(^|[^a-zäöüß])öl($|[^a-zäöüß])/.test(s)) return 'oel';
  if(s.includes('tee')) return 'tee';
  return null;
}
function rezeptAntwort(s){
  if(!/rezept/.test(s)) return null;
  const wort = findeStichwort(s);
  const kalt   = /(kalt|eis\b|eistee|ice|erfrisch)/.test(s);
  const warm   = /(warm|heiß|heiss)/.test(s);
  const backen = /(back|kuchen|dessert|süß|suess|keks|muffin)/.test(s);
  const kochen = /(koch|gericht|herzhaft|mittagessen|abendessen)/.test(s);
  let treffer = REZEPTE.slice();
  if(wort)   treffer = treffer.filter(r=>r.w===wort);
  if(kalt)   treffer = treffer.filter(r=>r.g==='kalt');
  if(warm)   treffer = treffer.filter(r=>r.g==='warm');
  if(backen) treffer = treffer.filter(r=>r.g==='backen');
  if(kochen) treffer = treffer.filter(r=>r.g==='kochen');

  if(!treffer.length){
    if(!wort) return null;
    /* Stichwort war eindeutig, aber das Magazin fuehrt dazu noch kein
       Rezept - ehrlich sagen statt ein falsches zeigen. */
    return {
      noProduct:true,
      summary:'Für dieses Stichwort führt das Rezept-Magazin aktuell kein eigenes Rezept.',
      tags:['Rezepte','kein Treffer'],
      eyebrow:'Ehrliche Antwort',title:'Noch kein Rezept dazu im Magazin',
      intro:'Das Rezept-Magazin von auteniQ wächst laufend. Für dieses Stichwort ist aktuell keins dabei.',
      visual:'help',
      choice:[{title:'Alle Rezepte ansehen',desc:'Kalt, warm, gekocht und gebacken.',ask:'Zeig mir Rezepte'}],
      evidence:'',source:'Shopify-Magazin „Rezepte", Stand 31.07.2026 — 41 Artikel.'
    };
  }
  const kOf = wort ? REZEPT_WORT_ZU_K[wort] : null;
  const label = wort ? (wort==='oel'?'Olivenöl':wort.charAt(0).toUpperCase()+wort.slice(1))
              : (kalt?REZEPT_TAG_LABEL.kalt:warm?REZEPT_TAG_LABEL.warm:backen?REZEPT_TAG_LABEL.backen:kochen?REZEPT_TAG_LABEL.kochen:'');
  return {
    summary:'Du suchst Rezepte, keine reine Produktliste. Das liefert auteniQ aus dem echten Rezept-Magazin.',
    tags:['Rezepte', label].filter(Boolean),
    eyebrow:'Aus dem Rezept-Magazin', title:treffer.length+' Rezept'+(treffer.length===1?'':'e')+(label?(' — '+label):''),
    intro:'Direkt aus dem auteniQ-Magazin, nicht erfunden oder zusammengefasst. Ein Klick führt zum vollständigen Rezept.',
    visual:'tea',
    rezept:{artikel:treffer.slice(0,8)},
    pick: kOf ? ()=>PRODUKTE.filter(p=>p.k===kOf).slice(0,6) : ()=>[],
    refine:false, metrics:[],
    why:'Die Rezepte kommen aus dem echten Shopify-Magazin „Rezepte" - Titel, Bild und Link, nichts zusammengefasst.',
    limit:'du die Zubereitung mit Mengenangaben direkt hier suchst — die vollständige Anleitung steht im verlinkten Beitrag.',
    evidence:treffer.length+' von 41 Magazin-Artikeln passen',
    source:'Shopify-Magazin „Rezepte" (auteniq.de/blogs/rezepte), Stand 31.07.2026.'
  };
}

/* Hersteller/Erzeuger: echte Artikel aus dem Shopify-Magazin "Erzeuger"
   (auteniq.de/blogs/erzeuger). Verknuepft wird eine Marke NUR, wenn sie
   woertlich im echten Produkttitel (produkte.js) steht - dieselbe
   Beweisregel wie bei REZEPTE. Geprueft am 31.07.2026 per GraphQL gegen
   die 137 echten Artikel, am 01.08.2026 erneut geprueft und um drei
   Treffer erweitert:
    - Mestral/Cambrils: die Produktbeschreibung von 10019 nennt woertlich
      "Kooperative Cambrils in Katalonien" - Alexander hat zusaetzlich
      persoenlich bestaetigt, dass Mestral und Cambrils zwei Namen fuer
      denselben Erzeuger sind (01.08.2026).
    - Cinco Jotas: der Markenname steht wörtlich in echten Bundle-Titeln
      ("Cinco Jotas Einsteiger-Set", "Cinco Jotas Schinkenwürfel Lingote"),
      auch wenn der Solo-Artikel 10007 selbst nur noch "Lingote" heisst.
      "lingote" wird mitverknuepft, weil im Shop kein anderes "Lingote"
      als das von Cinco Jotas existiert.
    - La Lola: die Pistazien-Produkttitel schreiben die Marke ohne
      Leerzeichen ("LaLola1947") - der erste Abgleich am 31.07. suchte
      nach "la lola" mit Leerzeichen und fand deshalb keinen Treffer,
      obwohl die Marke woertlich im Titel steht. Beide Schreibweisen
      sind jetzt als Suchbegriff hinterlegt.
   Wo das Wort weiterhin nur in einem Bild-Dateinamen steht oder gar
   nicht vorkommt (Capuliato, Holiston/Eleology - fuer beide existiert
   noch kein Erzeuger-Portraet im Magazin), bleibt die Zuordnung bewusst
   offen - siehe STAND.md. */
const ERZEUGER = [
 {h:'acetaia-giusti',t:'Acetaia Giusti aus Modena, Italien',land:'Italien',marke:['giusti'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/erzeuger-giusti.jpg?v=1783074676'},
 {h:'borduito',t:'Borduito aus Andria, Apulien',land:'Italien',marke:['borduito'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Borduito_sgusciate-2.jpg?v=1783074679'},
 {h:'fairafric',t:'fairafric aus Amanase, Ghana',land:'Ghana',marke:['fairafric'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/fairafricbunterMix_c79ca5d3-a324-480a-ad3b-49abf34ec279.png?v=1783107752'},
 {h:'soells-hof',t:'Sölls Hof von der Schwäbischen Alb, Deutschland',land:'Deutschland',marke:['sölls hof','soells hof'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/chiasamen.webp?v=1783107748'},
 {h:'saarnuss',t:'SaarNuss aus Saarbrücken, Deutschland',land:'Deutschland',marke:['saarnuss'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Professional-e-commerce-product-photograph-of-raw-unshelled-peanuts-some-peanut_a11d1294-9238-4201-956c-3c29d7bb352f.jpg?v=1783107750'},
 {h:'samova',t:'samova aus Hamburg, Deutschland',land:'Deutschland',marke:['samova'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/samova-home-bestseller-teaser_1920x1920_8d628d60-487c-4d2d-a116-c24138fd0c3a.webp?v=1783107560'},
 {h:'keiko',t:'KEIKO aus Kagoshima, Japan',land:'Japan',marke:['keiko'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/Keiko_History_3.webp?v=1783107561'},
 {h:'mateo-aceites',t:'Mateo Aceites aus Sabadell, Katalonien',land:'Spanien',marke:['gota de oro','mateo aceites'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/gota_de_oro_5_0ac7709c-2028-47b7-a2f0-45dffab1698a.png?v=1783107747'},
 {h:'cooperativa-agricola-cambrils',t:'Cooperativa Agrícola Cambrils aus Tarragona, Spanien',land:'Spanien',marke:['mestral'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/cambrils3.jpg?v=1783072555'},
 {h:'cinco-jotas',t:'Cinco Jotas aus Jabugo, Andalusien',land:'Spanien',marke:['cinco jotas','lingote'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/cincojotas3.png?v=1783072557'},
 {h:'la-lola-1947',t:'La Lola 1947 aus Villacañas, Kastilien-La Mancha',land:'Spanien',marke:['lalola1947','la lola'],b:'https://cdn.shopify.com/s/files/1/0961/6336/5203/articles/erzeuger-lalola-feld.jpg?v=1783074678'}
];
/* Marken, nach denen Kunden vermutlich fragen werden, deren Zuordnung
   aber NICHT im Produkttitel belegt ist - eigene, ehrlichere Antwort
   als ein einfaches "kein Treffer". Fuer Holiston/Eleology fehlt schlicht
   noch ein Erzeuger-Portraet im Magazin. */
const ERZEUGER_UNBESTAETIGT = ['capuliato','holiston','eleology'];
function erzeugerURL(h){ return 'https://auteniq.de/blogs/erzeuger/'+h; }
function erzeugerAntwort(s){
  if(!/(hersteller|erzeuger|produzent|wer (stellt|macht|produziert)|von wem kommt|wo kommt .* her)/.test(s)) return null;
  const treffer = ERZEUGER.find(e=>e.marke.some(m=>s.includes(m)));
  if(treffer){
    return {
      summary:'Du fragst nach dem Hersteller. Das beantwortet das echte Erzeuger-Porträt im Magazin, nicht Kuno selbst.',
      tags:['Erzeuger',treffer.land],
      eyebrow:'Aus dem Erzeuger-Magazin', title:treffer.t,
      intro:'Direkt aus dem auteniQ-Magazin, nicht zusammengefasst. Ein Klick führt zum vollständigen Porträt.',
      visual:'help',
      erzeuger:{artikel:[treffer]},
      pick:()=>[],
      refine:false, metrics:[],
      why:'Verknüpft wird eine Marke nur, wenn sie wörtlich im Produkttitel steht - dieselbe Regel wie bei den Rezepten.',
      limit:'du eine Marke suchst, die noch kein Porträt hat oder deren Zuordnung noch nicht bestätigt ist.',
      evidence:'1 von 1 Marke im Produkttitel bestätigt',
      source:'Shopify-Magazin „Erzeuger" (auteniq.de/blogs/erzeuger), Stand 31.07.2026.'
    };
  }
  const unklar = ERZEUGER_UNBESTAETIGT.find(m=>s.includes(m));
  if(unklar){
    return {
      noProduct:true,
      summary:'Zu dieser Marke gibt es noch kein bestätigtes Erzeuger-Porträt.',
      tags:['Erzeuger','Zuordnung offen'],
      eyebrow:'Ehrliche Antwort',title:'Diese Zuordnung ist noch nicht bestätigt',
      intro:'Der Markenname steht bisher nicht wörtlich im Produkttitel. Damit hier nichts Falsches steht, zeigt Kuno lieber nichts als eine Vermutung.',
      visual:'help',
      choice:[{title:'Alle Erzeuger-Porträts ansehen',desc:'Acht bestätigte Marken im Magazin.',ask:'Welche Hersteller habt ihr?'}],
      evidence:'',source:'Shopify-Magazin „Erzeuger", Stand 31.07.2026 — Zuordnung noch offen.'
    };
  }
  /* Frage war eindeutig nach "Hersteller", aber keine bekannte Marke
     genannt - die ganze Liste zeigen statt eines Nulltreffers. */
  return {
    summary:'Du fragst allgemein nach den Herstellern. Das zeigt das echte Erzeuger-Magazin.',
    tags:['Erzeuger'],
    eyebrow:'Aus dem Erzeuger-Magazin', title:ERZEUGER.length+' Erzeuger-Porträts',
    intro:'Direkt aus dem auteniQ-Magazin. Ein Klick führt zum vollständigen Porträt.',
    visual:'help',
    erzeuger:{artikel:ERZEUGER.slice()},
    pick:()=>[],
    refine:false, metrics:[],
    why:'Alle Porträts, bei denen die Marke im Produkttitel bestätigt ist.',
    limit:'du einen einzelnen Hersteller suchst — dann hilft der Markenname in der Frage.',
    evidence:ERZEUGER.length+' von '+ERZEUGER.length+' Porträts mit bestätigter Marke',
    source:'Shopify-Magazin „Erzeuger" (auteniq.de/blogs/erzeuger), Stand 31.07.2026.'
  };
}

/* Sorte statt Marke: Olivensorten (Spanien, Griechenland) und die
   Mandel-"Sorten" bei Borduito. Alexander wollte nicht nur die Marke,
   sondern die tatsaechliche Sorte/den Verschnitt angeben (01.08.2026).
   Jeder Eintrag stammt woertlich aus der echten Shopify-Produktbe-
   schreibung (Belegstufe B) - keine Sorte wird vermutet oder ergaenzt.
   Bei der Gota de Oro (Cuvée) nennt der Hersteller die Einzelsorten
   nicht - das steht so, statt Namen zu erfinden. Bei Borduito sind
   die "5 Sorten" tatsaechlich 5 Verarbeitungsformen derselben Mandel,
   keine botanischen Sorten - auch das wird ehrlich unterschieden. */
const SORTE = [
 {s:'10021', marke:'mestral', sorte:'Arbequina (sortenrein)', land:'Spanien, Katalonien',
  text:'Sortenreine Arbequina von der Kooperative Cambrils - mild, fein-fruchtig, ohne schwere Nebentöne.',
  kw:['arbequina']},
 {s:'10019', marke:'mestral', sorte:'Arbequina (sortenrein)', land:'Spanien, Katalonien',
  text:'Dieselbe Sorte wie das Bio-Öl, früher und polyphenolreicher geerntet - die sortentypische Aromatik bleibt erhalten.',
  kw:['arbequina']},
 {s:'10172', marke:'mestral', sorte:'Arbequina (Tafelolive)', land:'Spanien, Katalonien',
  text:'Dieselbe Olivensorte, hier als milde Tafelolive statt als Öl.',
  kw:['arbequina']},
 {s:'10020', marke:'gota de oro', sorte:'Cuvée aus andalusischen Sorten (nicht einzeln benannt)', land:'Spanien, Andalusien',
  text:'Mateo komponiert die Cuvée „Gota de Oro" aus mehreren andalusischen Sorten - welche das genau sind, nennt der Hersteller nicht.',
  kw:['cuvée','cuvee','coupage']},
 {s:'10107', marke:'holiston', sorte:'80 % Olympia, 20 % Koroneiki (Blend)', land:'Griechenland, Rhodos',
  text:'Handgepflückt bei früher Ernte. Die Olympia bringt Volumen, die Koroneiki die Schärfe.',
  kw:['koroneiki','olympia']},
 {s:'10108', marke:'holiston', sorte:'Koroneiki (sortenrein, 100 %)', land:'Griechenland, Rhodos',
  text:'Reinsortiges Koroneiki-Öl, zugänglicher im Charakter als der Olympia-Koroneiki-Blend derselben Familie.',
  kw:['koroneiki']},
 {s:'10162', marke:'eleology', sorte:'Koroneiki und Athinolia (Cuvée)', land:'Griechenland, Peloponnes',
  text:'Zwei Sorten aus demselben Bio-Hain, gemeinsam geerntet und schonend verarbeitet.',
  kw:['athinolia','koroneiki']},
 {s:'10163', marke:'eleology', sorte:'Koroneiki und Koutsourelia (Cuvée)', land:'Griechenland',
  text:'Würziger und vollmundiger als die Nature’s-Blend-Cuvée desselben Hauses.',
  kw:['koutsourelia','koroneiki','cuvée','cuvee','coupage']},
 {s:'WV-501', marke:'borduito', sorte:'5 Mandel-Verarbeitungsformen (keine botanischen Sorten)', land:'Italien, Apulien',
  text:'„5 Sorten" meint hier fünf Formen derselben Mandel: ungeschält, geschält, geschält & geröstet, ganze Bio-geröstete und Mandelgranulat - keine fünf Mandelsorten im botanischen Sinn.',
  kw:['borduito']}
];
const SORTE_MARKEN = ['mestral','holiston','eleology','gota de oro','borduito'];
function sorteAntwort(s){
  const VARIETAL = /(arbequina|koroneiki|athinolia|koutsourelia|olympia)/;
  const vTreffer = s.match(VARIETAL);
  const cuvee = s.includes('cuvée')||s.includes('cuvee')||s.includes('coupage');
  const marke = SORTE_MARKEN.find(m=>s.includes(m));
  /* "sorte" statt \bsorte\b: In zusammengesetzten Woertern wie
     "Olivensorte" oder "Mandelsorten" liegt zwischen "n" und "s" keine
     Wortgrenze, \b haette hier genau denselben Fehler wie bei "Öl"
     (siehe Abschnitt 0, Regel 4). Ein Teilwort-Treffer reicht bewusst. */
  const sorteWort = s.includes('sorte');
  const generisch = (s.includes('oliven')||s.includes('mandel')) && sorteWort;
  if(!vTreffer && !cuvee && !generisch && !(marke && sorteWort)) return null;

  let treffer;
  if(vTreffer){
    treffer = SORTE.filter(x=>x.kw.includes(vTreffer[1]));
  } else if(marke){
    treffer = SORTE.filter(x=>x.marke===marke);
  } else if(cuvee){
    treffer = SORTE.filter(x=>x.kw.some(k=>['cuvée','cuvee','coupage'].includes(k)));
  } else {
    treffer = SORTE.slice();
  }
  if(!treffer.length) return null;
  const artikel = einmalig(treffer.map(x=>PRODUKTE.find(p=>p.s===x.s)).filter(Boolean));

  return {
    summary:'Du fragst nach der Olivensorte oder dem Verschnitt, nicht nach der Marke. Das steht wörtlich in der echten Produktbeschreibung.',
    tags:['Sorte','Herkunft'],
    eyebrow:'Sorte statt Marke',
    title: treffer.length===1 ? treffer[0].sorte : 'Sorten und Verschnitte im Sortiment',
    intro: treffer.map(x=>x.land+': '+x.text).join(' '),
    visual:'oils',
    metrics: treffer.map(x=>[x.sorte, x.land]),
    pick:()=>artikel,
    refine:false,
    why:'Die Sortenangabe kommt wörtlich aus der echten Shopify-Produktbeschreibung, nicht aus einer Vermutung zur Marke.',
    limit:'du eine Sorte suchst, die im Sortiment nicht geführt wird — dann zeigt Kuno nichts, statt zu raten.',
    evidence:treffer.length+' von '+SORTE.length+' Sorten-Einträgen passen',
    source:'Produktbeschreibungen im Shop, Stand 01.08.2026.'
  };
}

/* -----------------------------------------------------------------
   POLYPHENOLE - eigene Antwortart, gebaut am 13.08.2026
   Vorher konnte Kuno die Frage gar nicht beantworten: die Zahl stand
   nur als Text im Produkttitel und war kein rechenbares Feld. Die
   rechenbaren Zahlen liegen jetzt in produkte.js (poly_min, poly_max,
   poly_beleg), der vollstaendige Nachweis je Artikel steht hier:
   Spanne, Wert im Shop-Feld, Belegstufe, Hydroxytyrosol, Quelle im
   Klartext. Stand: Shopify live 13.08.2026, Herstellerrecherche Manuel
   11.08.2026. Nichts gerundet, nichts ergaenzt, keine Spanne zu einem
   Mittelwert zusammengezogen. Wo keine Zahl vorliegt, steht das so.

   RECHTLICH (HCVO-Fach 2: Stoff und Menge nennen, niemals eine Wirkung):
   "Gesamtpolyphenole" ist eine reine Mengenangabe und in diesem Rahmen
   zulaessig. Der zugelassene Wortlaut nach Verordnung (EU) Nr. 432/2012
   setzt mindestens 5 mg Hydroxytyrosol und Derivate je 20 g Oel voraus
   (rund 250 mg/kg) und verlangt zusaetzlich den Hinweis auf 20 g Oel
   taeglich. Fuer KEINES der neun Oele liegt ein Hydroxytyrosol-Wert vor.
   Deshalb darf dieser Wortlaut hier nicht verwendet werden - genannt
   werden darf nur die Bedingung, nie die Aussage selbst. Die Testsuite
   prueft den gesamten Antworttext programmatisch gegen die Wortliste
   hilft/wirkt/lindert/heilt/gesund/foerdert/unterstuetzt/schuetzt/
   entzuendungshemmend/antioxidativ und gegen die Umschreibungen
   "gilt als", "viele halten fuer", "traditionell".
   ----------------------------------------------------------------- */
const POLYPHENOL = [
 {s:'10107', t:'Holiston Ultra Premium, Rhodos, 500 ml',
  spanne:'900–1800 mg/kg', shopwert:'900 (Untergrenze der Spanne)', beleg:'C', hydroxytyrosol:'fehlt',
  quelle:'Herstellerangabe im Produkttitel. holiston.gr nennt keine Zahl. Drittquellen nennen abweichend über 500, 853, bis 900 und 1000 (Ernte 2024).'},
 {s:'10108', t:'Holiston Premium, Rhodos, 500 ml',
  spanne:'600–1000 mg/kg', shopwert:'600 (Untergrenze der Spanne)', beleg:'C', hydroxytyrosol:'fehlt',
  quelle:'Herstellerangabe im Produkttitel. Ein Händler nennt über 500.'},
 {s:'10021', t:'Bio-Olivenöl Mestral Arbequina, 3 L',
  spanne:'271 mg/kg', shopwert:'271 (Metafeld analyse.polyphenole_gesamt_mg_kg, gefüllt 16.08.2026)', beleg:'B', hydroxytyrosol:'fehlt',
  quelle:'Eigene Shop-Angabe, Analyseergebnis dieser Charge. Das Zertifikat liegt noch nicht vor. mestralcambrils.com nennt keinen Wert.'},
 {s:'10019', t:'Premium-Olivenöl Mestral Arbequina, 3 L',
  spanne:'keine Zahl', shopwert:'—', beleg:'—', hydroxytyrosol:'fehlt', widerspruch:true,
  quelle:'Titel sagt „Polyphenolreich", es gibt aber weder im Shop noch beim Hersteller einen Wert.'},
 {s:'10016', t:'Edles Würzöl mit schwarzem Trüffel, 250 ml',
  spanne:'keine Zahl', shopwert:'—', beleg:'—', hydroxytyrosol:'fehlt',
  quelle:'Kein Wert im Shop, kein Wert beim Hersteller.'},
 {s:'10017', t:'Gourmet-Würzöl mit fermentiertem schwarzem Knoblauch, 250 ml',
  spanne:'keine Zahl', shopwert:'—', beleg:'—', hydroxytyrosol:'fehlt',
  quelle:'Kein Wert im Shop, kein Wert beim Hersteller.'},
 {s:'10020', t:'Cuvée „Gota de Oro", 1 L',
  spanne:'231 mg/kg', shopwert:'231 (Metafeld analyse.polyphenole_gesamt_mg_kg, gefüllt 16.08.2026)', beleg:'B', hydroxytyrosol:'fehlt',
  quelle:'Angabe Alexander, 16.08.2026. Die Cuvée wechselt jährlich, eine Ernteangabe fehlt noch.'},
 {s:'10162', t:'Eleology »Nature’s Blend«, 500 ml',
  spanne:'keine Zahl', shopwert:'—', beleg:'—', hydroxytyrosol:'fehlt',
  quelle:'Kein Wert im Shop. eleology.gr sperrt automatisierten Zugriff.'},
 {s:'10163', t:'Eleology »Chef’s Table«, 5 L',
  spanne:'keine Zahl', shopwert:'—', beleg:'—', hydroxytyrosol:'fehlt',
  quelle:'Kein Wert im Shop. eleology.gr sperrt automatisierten Zugriff.'}
];
/* Pflicht-Datenlage-Zeile. Diese vier Fakten gehoeren an jede
   Polyphenol-Antwort, deshalb stehen sie an genau einer Stelle. */
const POLYPHENOL_DATENLAGE = '4 von 9 Ölen haben überhaupt eine Zahl · 0 von 9 haben einen Laborbericht · Hydroxytyrosol fehlt bei allen 9 · die Zahlen bei Holiston sind Herstellerangaben aus dem Produkttitel, keine Messung.';
/* Hydroxytyrosol und der zugelassene Wortlaut - ebenfalls nur hier.
   Die Bedingung wird genannt, die Aussage selbst nie. */
const POLYPHENOL_HYDROXYTYROSOL = 'Hydroxytyrosol: Der Wert fehlt bei allen neun Ölen. Die einzige Spur ist ein Händlerzitat einer Analyse der Universität Athen für Holiston — 15,98 mg Hydroxytyrosol, Tyrosol und Derivate je 20 g, rund 799 mg/kg, Ernte unbenannt, Originalzertifikat liegt nicht vor. Ausdrücklich Belegstufe C und damit kein Wert für ein einzelnes Öl im Sortiment. Der zugelassene Wortlaut nach Verordnung (EU) Nr. 432/2012 setzt mindestens 5 mg Hydroxytyrosol und Derivate je 20 g Öl voraus, rund 250 mg/kg, und verlangt zusätzlich den Hinweis auf 20 g Öl täglich. Diese Bedingung ist bei keinem der neun Öle mit einem eigenen Wert belegt. Kuno nennt deshalb nur die Bedingung und verwendet den Wortlaut selbst nicht.';

function polyphenolAntwort(s){
  /* Teilwort-Pruefung, bewusst ohne \b: "Polyphenolgehalt",
     "polyphenolreichstes" und "Hydroxytyrosolwert" sind deutsche
     Komposita - dieselbe Wortgrenzen-Schwaeche wie bei "Öl" und
     "Sorte" (siehe Regel 4 in STAND.md). */
  const polyWort   = s.includes('polyphenol') || s.includes('hydroxytyrosol');
  const oelBezug   = s.includes('öl') || s.includes('oel') || s.includes('oliven');
  const superlativ = /(meiste|am meisten|höchst|hoechst|reichst|stärkst|staerkst|vergleich|ranking|welches|welche)/.test(s);
  /* Rangfrage: Oel-Bezug plus Superlativ, wenn "polyphenol" fällt -
     "welches öl hat die meisten polyphenole", "polyphenolreichstes öl",
     "olivenöl polyphenole vergleich". */
  const rangfrage  = s.includes('polyphenol') && oelBezug && superlativ;
  if(!polyWort && !rangfrage) return null;
  /* Der Zielkonflikt bleibt bei results.oils: "hohe Polyphenole, aber
     mild" ist eine Geschmacksfrage mit Zielkonflikt und hat dort seit
     dem 30.07.2026 eine eigene Antwort (zwei Oele statt eines faulen
     Kompromisses) samt Testpunkt. Diese Frage will keine Zahlenliste,
     sondern eine Loesung - deshalb tritt die Polyphenol-Antwort hier
     bewusst zurueck. */
  if(/(mild|nicht scharf|nicht so scharf|wenig schärfe|ohne schärfe|kaum schärfe)/.test(s)) return null;

  /* Sortiert wird ueber das rechenbare Feld poly_min aus produkte.js,
     nicht ueber den Text der Spanne. */
  const mitZahl = POLYPHENOL.map(x=>({x, p:PRODUKTE.find(p=>p.s===x.s)}))
    .filter(e=>e.p && typeof e.p.poly_min==='number')
    .sort((a,b)=>b.p.poly_min-a.p.poly_min);
  const ohneZahl = POLYPHENOL.filter(x=>{
    const p=PRODUKTE.find(q=>q.s===x.s);
    return !p || typeof p.poly_min!=='number';
  });
  const artikel = einmalig(mitZahl.map(e=>e.p));
  const wid = ohneZahl.find(x=>x.widerspruch);

  return {
    summary:'Du fragst nach der Menge an Polyphenolen. Kuno nennt die Zahl, wo eine belegte Zahl vorliegt, und die Lücke, wo keine vorliegt.',
    tags:['Polyphenole','Mengenangabe','Belegstufe'],
    eyebrow:'Gesamtpolyphenole, reine Mengenangabe',
    title: mitZahl.length+' von '+POLYPHENOL.length+' Ölen haben eine Zahl',
    intro:'Absteigend nach der Untergrenze der Spanne. '
      + mitZahl.map(e=>'Art. '+e.x.s+' '+e.x.t+': '+e.x.spanne
          +', Wert im Shop-Feld: '+e.x.shopwert+', Belegstufe '+e.x.beleg
          +'. Quelle: '+e.x.quelle).join(' '),
    visual:'oils',
    metrics: mitZahl.map(e=>[e.x.spanne, 'Art. '+e.x.s+' · Belegstufe '+e.x.beleg]),
    pick:()=>artikel,
    refine:false,
    luecke: ohneZahl.length+' Öle haben keine Zahl: '
      + ohneZahl.map(x=>'Art. '+x.s+' '+x.t+' — '+x.quelle).join(' · ')
      + (wid ? (' Widerspruch bei Art. '+wid.s+': Titel sagt polyphenolreich, Zahl fehlt.') : ''),
    hydroxytyrosol: POLYPHENOL_HYDROXYTYROSOL,
    datenlage: POLYPHENOL_DATENLAGE,
    why:'Die Zahlen stehen wörtlich so im Shop oder in der Herstellerangabe im Produkttitel. Keine Spanne wurde zu einem Mittelwert zusammengezogen, kein fehlender Wert geschätzt.',
    limit:'du einen Laborbericht oder einen Hydroxytyrosol-Wert brauchst — beides liegt für keines der neun Öle vor.',
    evidence: mitZahl.length+' von '+POLYPHENOL.length+' Ölen mit Zahl · 0 von '+POLYPHENOL.length+' mit Laborbericht',
    source:'Shopify live 13.08.2026 · Herstellerrecherche Manuel 11.08.2026. Belegstufe C = Herstellerangabe ohne Analyse, Belegstufe B = eigene Shop-Kurzbeschreibung.'
  };
}

function mengeText(p){
  const f=mengeAusTitel(p.t);
  if(!f) return 'nicht angegeben';
  return f.menge>=1000 ? zahl(f.menge/1000)+' '+(f.einheit==='g'?'kg':'l') : zahl(f.menge)+' '+f.einheit;
}
/* ---------------------------------------------------------------
   PASST DAZU - kulinarische Paarung fuer Cross-Selling.

   Zwei Ebenen, die nie vermischt werden:
   1. GRUPPE zu GRUPPE - Oel passt zu Essig, Honig passt zu Tee.
      Symmetrisch, gilt fuer das ganze Sortiment, hier gepflegt.
   2. ARTIKEL zu ARTIKEL - dieses Oel zu diesem Essig. Asymmetrisch,
      nur wo Alexander es entscheidet. Feld ARTIKEL_PAAR unten.

   Das ist eine GESCHMACKSFRAGE, keine Gesundheitsfrage. Deshalb
   gilt hier die HCVO nicht und die Paarung darf auch als
   oeffentliches Metafeld sensorik.passt_zu erscheinen - anders als
   der ZUTATEN-INDEX, der im Code bleiben muss.
   --------------------------------------------------------------- */

const PASST_ZU = [
 {a:'oel',    b:'essig',         t:'Öl und Essig ergeben zusammen das Dressing.'},
 {a:'oel',    b:'tomate',        t:'Getrocknete Tomaten in Öl eingelegt oder auf Brot.'},
 {a:'oel',    b:'schinken',      t:'Ein Strich Öl auf der Scheibe, dazu Brot.'},
 {a:'essig',  b:'tomate',        t:'Ein Tropfen Balsamico hebt die Süße der Tomate.'},
 {a:'essig',  b:'schinken',      t:'Balsamico neben Ibérico, klassisch als Tapa.'},
 {a:'essig',  b:'schoko',        t:'Balsamico und dunkle Schokolade — der Klassiker aus Modena.'},
 {a:'honig',  b:'tee',           t:'Honig in den Aufguss, wenn er nicht mehr kocht.'},
 {a:'honig',  b:'nussmus',       t:'Nussmus und Honig auf einer Scheibe Brot.'},
 {a:'honig',  b:'nuss',          t:'Nüsse in Honig, das einfachste Dessert.'},
 {a:'honig',  b:'saat',          t:'Saaten, Honig und Joghurt zum Frühstück.'},
 {a:'honig',  b:'matcha',        t:'Matcha Latte wird mit Honig gesüßt.'},
 {a:'nuss',   b:'trockenfrucht', t:'Nüsse und Trockenfrüchte als eigene Mischung.'},
 {a:'nuss',   b:'schoko',        t:'Nüsse neben dunkler Schokolade.'},
 {a:'nussmus',b:'trockenfrucht', t:'Datteln mit Nussmus gefüllt.'},
 {a:'riegel', b:'nuss',          t:'Riegel und Nüsse für den Vorrat unterwegs.'},
 {a:'tee',    b:'suesses',       t:'Etwas Süßes neben die Tasse.'},
 {a:'tee',    b:'schoko',        t:'Kräftiger Tee und dunkle Schokolade.'},
 {a:'schinken',b:'tomate',       t:'Ibérico, Tomate, Brot — mehr braucht es nicht.'}
];

/* Artikel-zu-Artikel: nur bestaetigte Paare. Leer, bis Alexander
   sie freigibt - erfundene Paare gehoeren hier nicht hinein. */
const ARTIKEL_PAAR = {
  /* '10021': ['10029','10046'],  Beispielform, noch nicht freigegeben */
};

function passtDazu(liste){
  if(!liste || !liste.length) return null;
  /* Nur wenn die Antwort eine erkennbare Warengruppe zeigt */
  const k=liste[0].k;
  if(!liste.every(p=>p.k===k)) return null;

  /* Artikel-Paare haben Vorrang, wenn hinterlegt */
  const direkt=[];
  liste.forEach(p=>(ARTIKEL_PAAR[p.s]||[]).forEach(nr=>{
    const t=PRODUKTE.find(x=>x.s===nr); if(t) direkt.push(t);
  }));
  if(direkt.length) return {grund:'Von Hand zusammengestellt.', artikel:einmalig(direkt).slice(0,4)};

  const paare=PASST_ZU.filter(p=>p.a===k||p.b===k);
  if(!paare.length) return null;
  const artikel=[];
  const gruende=[];
  /* Aus der Zielgruppe wird der Bestseller vorgeschlagen, sonst der
     guenstigste Einstieg. Der billigste Artikel ist nicht immer der
     beste Vorschlag - bei Olivenoel waeren das die Tafeloliven. */
  const rang=t=>{
    const i=BESTSELLER_SNAPSHOT.findIndex(b=>normTitel(b.t).slice(0,18)===normTitel(t).slice(0,18));
    return i<0 ? 99 : i;
  };
  paare.forEach(p=>{
    const ziel=(p.a===k)?p.b:p.a;
    const treffer=PRODUKTE.filter(x=>x.k===ziel)
      .sort((a,b)=>(rang(a.t)-rang(b.t)) || (a.p-b.p));
    if(treffer.length){ artikel.push(treffer[0]); gruende.push(p.t); }
  });
  if(!artikel.length) return null;
  return {grund:gruende.slice(0,2).join(' '), artikel:einmalig(artikel).slice(0,4)};
}



/* ---------------------------------------------------------------
   VERSAND - Kosten, Zielländer und die Grenzen, 16.08.2026

   ALLE WERTE STEHEN IN DER KONSTANTE VERSAND DIREKT DARUNTER.
   Wer die Pauschale oder die Freigrenze aendern will, aendert genau
   diese Zahlen - sonst nichts. Kein Preis steht irgendwo im Text.

   ACHTUNG, ZWEI ORTE: Die echten Werte pflegt Shopify unter
   Einstellungen -> Versand und Zustellung. Kuno liest sie NICHT von
   dort - products.json liefert keine Versandprofile, und der
   Live-Abgleich in kuno-render.js holt nur Preis, Lieferbarkeit,
   Produktlink und das Bio-Tag. Wird im Shop etwas geaendert, muss es
   hier von Hand nachgezogen werden, sonst sagt Kuno etwas anderes als
   die Kasse.

   Keine Lieferzeit: fuer keine Zone ist eine Dauer in Tagen belegt.
   Kuno nennt deshalb keine Zahl, sondern sagt, wo sie steht.
   --------------------------------------------------------------- */
const VERSAND = {
  stand:   '16.08.2026',
  inland:  {name:'Deutschland', preis:4.90, freiAb:49.00},
  zonen: [
    {preis: 9.90, laender:['\u00d6sterreich','Niederlande','Frankreich','Belgien','Luxemburg','D\u00e4nemark',
                           'Tschechien','Polen','Italien','Spanien','Portugal','Schweden','Finnland',
                           'Ungarn','Slowakei','Slowenien']},
    {preis:14.90, laender:['Griechenland','Irland','Kroatien','Bulgarien','Rum\u00e4nien','Estland','Lettland']}
  ],
  /* Ausdruecklich benannt, statt auszuweichen: was nicht im Regal
     steht, wird nicht angeboten - das gilt auch fuer Laender. */
  ohneLieferung: ['Schweiz','Vereinigtes K\u00f6nigreich'],
  gratisProfile: ['Kostenloser Versand','Probepaket Schinken + Buch'],
  gratisSatz: 'Einzelne Artikel werden unabh\u00e4ngig vom Warenwert versandkostenfrei geliefert; das steht dann auf der Produktseite.',
  lieferzeitSatz: 'Eine Lieferzeit in Tagen ist nirgends hinterlegt. Sie steht im Bestellablauf, bevor die Bestellung abgeschickt wird.',
  quelle: 'Versandprofile aus Shopify, Einstellungen \u2192 Versand und Zustellung, Stand 16.08.2026. \u00c4ndert sich dort etwas, muss es in der Konstante VERSAND nachgezogen werden.'
};

/* Schreibweisen, unter denen ein Land gesucht wird. Der Schluessel ist
   der Name aus VERSAND, die Liste sind die Wortformen in einer Frage. */
const LAND_SCHREIBWEISE = {
  '\u00d6sterreich':['\u00f6sterreich','oesterreich'],
  'D\u00e4nemark':['d\u00e4nemark','daenemark'],
  'Rum\u00e4nien':['rum\u00e4nien','rumaenien'],
  'Vereinigtes K\u00f6nigreich':['vereinigtes k\u00f6nigreich','gro\u00dfbritannien','grossbritannien','england','schottland','wales','\u00bb?uk\u00ab?'],
  'Schweiz':['schweiz'],
  'Deutschland':['deutschland','inland','innerhalb deutschlands']
};
function landFormen(name){
  return LAND_SCHREIBWEISE[name] || [name.toLowerCase()];
}
/* Eigene Wortgrenze statt \b: Umlaute gelten fuer JavaScript nicht als
   Wortzeichen (Regel 4). Damit trifft "Porto" nicht "Portugal" und
   "Italien" nicht "italienisch". */
function wortDrin(s, wort){
  return new RegExp('(^|[^a-z\u00e4\u00f6\u00fc\u00df])(' + wort + ')($|[^a-z\u00e4\u00f6\u00fc\u00df])').test(s);
}
function landAus(s){
  const alle = [VERSAND.inland.name]
    .concat(VERSAND.zonen.reduce((a,z)=>a.concat(z.laender),[]))
    .concat(VERSAND.ohneLieferung);
  return alle.find(n=>landFormen(n).some(f=>wortDrin(s,f))) || null;
}
/* "nach \u00d6sterreich", aber "in die Schweiz" und "ins Vereinigte
   K\u00f6nigreich". Nur die Ausnahmen stehen hier, alles andere bekommt
   "nach". */
const LAND_PRAEP = {
  'Schweiz':'in die Schweiz',
  'Vereinigtes K\u00f6nigreich':'ins Vereinigte K\u00f6nigreich',
  'Niederlande':'in die Niederlande',
  'Slowakei':'in die Slowakei'
};
function nachLand(n){ return LAND_PRAEP[n] || ('nach ' + n); }
/* Laendernamen mit Artikel: "Die Schweiz gehoert nicht dazu", nicht
   "Schweiz gehoert nicht dazu". */
const LAND_ARTIKEL = {
  'Schweiz':'Die Schweiz',
  'Vereinigtes K\u00f6nigreich':'Das Vereinigte K\u00f6nigreich',
  'Niederlande':'Die Niederlande',
  'Slowakei':'Die Slowakei'
};
function mitArtikel(n){ return LAND_ARTIKEL[n] || n; }
function grossErste(t){ return t.charAt(0).toUpperCase() + t.slice(1); }
function zoneVon(name){ return VERSAND.zonen.find(z=>z.laender.indexOf(name)>=0) || null; }

/* Enge Woerter: eindeutig eine Kostenfrage. Sie duerfen auch dann
   greifen, wenn die Frage schon eine Produktantwort hat
   ("Was kostet der Versand fuer Olivenoel?").
   Weite Woerter: koennen auch Sortiment meinen ("Welches Oel liefert
   ihr?"), deshalb greifen sie nur, wenn sonst nichts passt. */
const VERSAND_ENG = /(versandkosten|versandpauschale|versandkostenfrei|versandfrei|gratisversand|gratis versand|kostenlose[rn]? versand|kostenfreie[rn]? versand|frachtkosten|lieferkosten|portokosten|(^|[^a-z\u00e4\u00f6\u00fc\u00df])(versand|porto)($|[^a-z\u00e4\u00f6\u00fc\u00df]))/;
const VERSAND_WEIT = /(liefert ihr|liefern sie|liefert auteniq|lieferung|liefergebiet|beliefer|verschickt ihr|versendet ihr|verpackung|verpackt|ab wann kostenlos|ab welchem betrag|ab wie viel|ab welchem warenwert|versenden nach|schicken nach|versendet ihr nach)/;
/* Wortstaemme, die zufaellig dieselben Buchstaben tragen. Sie werden
   vor der Pruefung entfernt: "Lieferant", "lieferbar", "Portobello",
   "Versandhandel". "Portugal" braucht das nicht - die Wortgrenze oben
   erledigt es schon, und Portugal ist ein echtes Zielland. */
const VERSAND_FALLE = /lieferant\w*|lieferbar\w*|lieferzeit\w*|portobello\w*|versandhandel\w*|versandapotheke\w*/g;

function versandAntwort(s, streng){
  const rein = (s||'').replace(VERSAND_FALLE,' ');
  const land = landAus(rein);
  /* "Liefert ihr Honig?" fragt nach dem Sortiment, nicht nach dem
     Porto. Die weiten W\u00f6rter greifen deshalb nur, wenn kein
     Warengruppen- oder \u00d6lwort im Satz steht - es sei denn, ein
     Zielland ist genannt. */
  const produktBezug = gruppeGenannt(rein) || OEL_WORT.test(rein);
  const gefragt = VERSAND_ENG.test(rein)
    || (!!land && /(liefer|schick|versend|verschick|bestell)/.test(rein))
    || (!streng && VERSAND_WEIT.test(rein) && !produktBezug);
  if(!gefragt) return null;

  const zone2 = VERSAND.zonen[0], zone3 = VERSAND.zonen[1];
  const tail = ' ' + VERSAND.gratisSatz + ' ' + VERSAND.lieferzeitSatz;
  const basis = {
    visual:'help', refine:false, noProduct:true,
    eyebrow:'Versandkosten',
    luecke:'Lieferzeit: f\u00fcr keine Zone ist eine Dauer in Tagen belegt. Kuno nennt deshalb keine Zahl.',
    why:'Die Zahlen stehen so in den Versandprofilen des Shops. Nichts gerundet, nichts gesch\u00e4tzt.',
    limit:'du eine Lieferzeit in Tagen brauchst \u2014 die ist nicht hinterlegt.',
    source:VERSAND.quelle
  };

  /* 1. Land, in das nicht geliefert wird. Offen sagen. */
  if(land && VERSAND.ohneLieferung.indexOf(land)>=0){
    return Object.assign({}, basis, {
      summary:'Du fragst nach einem Land, in das auteniQ nicht liefert.',
      tags:['Versand',land,'keine Lieferung'],
      title:grossErste(nachLand(land)) + ' liefert auteniQ nicht',
      intro:'Diese Adresse l\u00e4sst sich im Shop nicht ausw\u00e4hlen. Geliefert wird nach Deutschland und in '
        + (zone2.laender.length+zone3.laender.length) + ' weitere L\u00e4nder der EU. ' + mitArtikel(land) + ' geh\u00f6rt nicht dazu, '
        + 'auch nicht gegen Aufpreis.' + tail,
      metrics:[['keine Lieferung', land]],
      datenlage:'2 L\u00e4nder ausdr\u00fccklich ausgeschlossen: ' + VERSAND.ohneLieferung.join(' und ')
        + ' \u00b7 ' + (1+zone2.laender.length+zone3.laender.length) + ' L\u00e4nder belieferbar',
      evidence:'nicht belieferbar',
      choice:[{title:'Versandkosten im Inland',desc:'Deutschland und die EU-L\u00e4nder im \u00dcberblick.',ask:'Was kostet der Versand?'}]
    });
  }

  /* 2. Deutschland - der einzige Fall mit Freigrenze. Die Sprache ist
     bewusst dieselbe wie im Warenkorb: "bis zum kostenfreien Versand". */
  if(land === VERSAND.inland.name){
    return Object.assign({}, basis, {
      summary:'Du fragst nach den Versandkosten innerhalb Deutschlands.',
      tags:['Versand','Deutschland',eur(VERSAND.inland.preis)],
      title:'Innerhalb Deutschlands ' + eur(VERSAND.inland.preis) + ', ab ' + eur(VERSAND.inland.freiAb) + ' nichts',
      intro:'Innerhalb Deutschlands kostet der Versand ' + eur(VERSAND.inland.preis) + '. Ab ' + eur(VERSAND.inland.freiAb)
        + ' Warenwert entf\u00e4llt er. Im Warenkorb steht, wie viel noch bis zum kostenfreien Versand fehlt.' + tail,
      metrics:[[eur(VERSAND.inland.preis),'Deutschland'],[eur(0),'ab ' + eur(VERSAND.inland.freiAb) + ' Warenwert']],
      datenlage:'Pauschale und Freigrenze aus dem Versandprofil Deutschland \u00b7 Stand ' + VERSAND.stand,
      evidence:'Versandprofil Deutschland',
      choice:[{title:'Versand ins Ausland',desc:'Preise je Zielland.',ask:'Liefert ihr ins Ausland?'}]
    });
  }

  /* 3. Ein Zielland im Ausland. Nur dieses nennen, nicht die ganze
     Tabelle - und dazusagen, dass die Freigrenze dort nicht gilt. */
  const zone = land ? zoneVon(land) : null;
  if(zone){
    return Object.assign({}, basis, {
      summary:'Du fragst nach den Versandkosten in ein bestimmtes Land.',
      tags:['Versand',land,eur(zone.preis)],
      title:grossErste(nachLand(land)) + ' kostet der Versand ' + eur(zone.preis),
      intro:grossErste(nachLand(land)) + ' kostet der Versand ' + eur(zone.preis) + '. Die Freigrenze von ' + eur(VERSAND.inland.freiAb)
        + ' gilt nur innerhalb Deutschlands \u2014 im Ausland bleibt es bei diesem Preis, egal wie viel im Korb liegt.' + tail,
      metrics:[[eur(zone.preis),land],[eur(VERSAND.inland.preis),'Deutschland, ab ' + eur(VERSAND.inland.freiAb) + ' kostenfrei']],
      datenlage:'Versandprofil ' + eur(zone.preis) + ' mit ' + zone.laender.length + ' L\u00e4ndern \u00b7 Stand ' + VERSAND.stand,
      evidence:'Versandprofil ' + eur(zone.preis),
      choice:[{title:'Alle Versandkosten',desc:'Deutschland und beide Auslandszonen.',ask:'Was kostet der Versand?'}]
    });
  }

  /* 4. Ohne Land: die ganze Tabelle. */
  return Object.assign({}, basis, {
    summary:'Du fragst nach den Versandkosten.',
    tags:['Versand',eur(VERSAND.inland.preis),'ab ' + eur(VERSAND.inland.freiAb) + ' kostenfrei'],
    title:'Innerhalb Deutschlands ' + eur(VERSAND.inland.preis) + ', ab ' + eur(VERSAND.inland.freiAb) + ' nichts',
    intro:'Innerhalb Deutschlands kostet der Versand ' + eur(VERSAND.inland.preis) + '. Ab ' + eur(VERSAND.inland.freiAb)
      + ' Warenwert entf\u00e4llt er \u2014 im Warenkorb steht, wie viel noch bis zum kostenfreien Versand fehlt. '
      + 'Ins Ausland kostet er ' + eur(zone2.preis) + ' (' + zone2.laender.join(', ') + ') oder '
      + eur(zone3.preis) + ' (' + zone3.laender.join(', ') + '). Dort gibt es keine Freigrenze. '
      + 'Nicht geliefert wird ' + VERSAND.ohneLieferung.map(nachLand).join(' und ') + '.' + tail,
    metrics:[
      [eur(VERSAND.inland.preis),'Deutschland'],
      [eur(0),'Deutschland ab ' + eur(VERSAND.inland.freiAb)],
      [eur(zone2.preis),zone2.laender.length + ' L\u00e4nder'],
      [eur(zone3.preis),zone3.laender.length + ' L\u00e4nder'],
      ['keine Lieferung',VERSAND.ohneLieferung.join(', ')]
    ],
    datenlage:(1+zone2.laender.length+zone3.laender.length) + ' L\u00e4nder belieferbar, '
      + VERSAND.ohneLieferung.length + ' ausdr\u00fccklich nicht \u00b7 Keine Lieferzeit hinterlegt \u00b7 Stand ' + VERSAND.stand,
    evidence:'3 Versandprofile aus dem Shop',
    choice:[
      {title:'Ab wann kostenfrei?',desc:'Die Freigrenze im Inland.',ask:'Ab welchem Betrag ist der Versand kostenlos?'},
      {title:'Liefert ihr ins Ausland?',desc:'Preise je Zielland.',ask:'Liefert ihr nach \u00d6sterreich?'}
    ]
  });
}

/* ---------------------------------------------------------------
   MEHRFACHFRAGEN - zwei Themen in einem Satz, 16.08.2026

   Bis heute galt: erster Treffer gewinnt, der Rest fiel still unter
   den Tisch. "Welcher Honig ist mild und welches Olivenoel ist
   scharf?" beantwortete nur den Honig. "Habt ihr Bio-Honig und
   Bio-Schokolade?" meldete "kein Artikel" - und verschwieg die
   sieben Bio-Schokoladen.

   Der Weg hierher ist bewusst additiv: classifyVoll() bleibt Zeile
   fuer Zeile unveraendert und laeuft weiter als Erstes. Erst wenn
   danach ein zweites, eigenstaendiges Thema uebrig bleibt, kommt eine
   zweite Antwort dazu. Damit kann nichts kippen, was heute schon
   funktioniert - die Ganzsatz-Antwort ist immer noch dieselbe.

   Vier Dinge duerfen dabei nicht brechen, alle mit eigenem Testpunkt:
   1. Vergleich bleibt Vergleich. vergleichAntwort() zerlegt selbst an
      "und", um zwei Produktnamen zu finden. Erkennt der Gesamtsatz
      einen Vergleich, wird gar nicht erst zerlegt.
   2. Die Sperrliste gewinnt immer. Trifft irgendein Teil die Sperre,
      bleibt es bei der einen Umlenkungsantwort ohne Produktraster -
      der unverfaengliche Teil wird nur als anklickbare Rueckfrage
      angeboten.
   3. Produktnamen mit "und" werden nicht zerrissen ("Borduito
      geschaelte und geroestete Mandeln", "2, 3 und 4 Goldmedaillen").
      Deshalb werden echte Titel vor dem Zerlegen maskiert.
   4. Kein nacktes Komma als Trenner. "ein mildes, fruchtiges
      Olivenoel" ist eine Frage, keine zwei.
   --------------------------------------------------------------- */

/* Phrasen, in denen "und" mitten im Namen steht. Sie entstehen aus den
   echten Titeln und Warengruppen-Bezeichnungen, nicht aus einer von
   Hand gepflegten Liste - sonst veraltet sie beim naechsten Artikel. */
const SCHUTZ_PHRASEN = (function(){
  const p = [];
  const nimm = txt => String(txt||'').toLowerCase().split('|').forEach(teil=>{
    const t = teil.trim();
    if(/ und | sowie /.test(t)) p.push(t);
  });
  PRODUKTE.forEach(x=>nimm(x.t));
  WARENGRUPPEN.forEach(w=>nimm(w.label));
  REZEPTE.forEach(r=>nimm(r.t));
  /* Zwei Wendungen, die als Kollektionsname im Shop stehen, aber in
     keinem Artikeltitel - deshalb hier von Hand. */
  ['n\u00fcsse und nussmus','\u00f6l und essig'].forEach(x=>p.push(x));
  /* Laengste zuerst, sonst frisst eine kurze Phrase eine laengere an. */
  return [...new Set(p)].filter(x=>x.length>6).sort((a,b)=>b.length-a.length);
})();

/* Trenner: " und ", " sowie ", "au\u00dferdem", ";" und "?".
   Ausdruecklich NICHT das Komma und ausdruecklich NICHT "&" - beide
   stehen viel zu oft mitten in einem Produktnamen. */
const FRAGE_TRENNER = /\s+und\s+auch\s+|\s+und\s+|\s+sowie\s+|\s+au(?:\u00df|ss)erdem\s+|\s*;\s*|\s*\?\s*/;

function zerlegeFrage(text){
  let s = (text||'').toLowerCase().trim();
  const marken = [];
  SCHUTZ_PHRASEN.forEach(ph=>{
    let i;
    while((i = s.indexOf(ph)) >= 0){
      const m = '\u0001' + marken.length + '\u0001';
      marken.push(ph);
      s = s.slice(0,i) + m + s.slice(i+ph.length);
    }
  });
  /* Zahlenaufzaehlungen sind nie zwei Fragen: "2,3 und 4 Goldmedaillen".
     Steht links und rechts von "und" eine Ziffer, bleibt es stehen -
     unabhaengig davon, wie der Titel im Shop geschrieben ist. */
  s = s.replace(/(\d)\s+und\s+(\d)/g, function(m,a,b){
    const k = '\u0001' + marken.length + '\u0001';
    marken.push(' und ');
    return a + k + b;
  });
  return s.split(FRAGE_TRENNER)
    .map(t=>{ marken.forEach((ph,i)=>{ t = t.split('\u0001'+i+'\u0001').join(ph); }); return t.trim(); })
    .filter(t=>t.length>2);
}

/* Zwei Antworten gelten als dieselbe, wenn Rubrik und Titel gleich
   sind. Reicht: die Titel tragen die Warengruppe und die Trefferzahl. */
function antwortSchluessel(r){ return (r.eyebrow||'') + '|' + (r.title||''); }
function istLeerAntwort(r){ return r === results.generic || nameOf(r) === 'generic'; }

/* Gibt eine Liste mit einer oder zwei Antworten zurueck. Die
   Reihenfolge folgt der Reihenfolge der Themen im Satz. */
function classifyAlle(text){
  const haupt = classifyVoll(text);

  /* 1. Ein Vergleich wird nie zerlegt. */
  if(haupt.vergleich) return [haupt];

  const teile = zerlegeFrage(text);
  if(teile.length < 2) return [haupt];

  const paare = teile.map(t=>({t:t, r:classifyVoll(t)}));

  /* 2. Sperrliste gewinnt immer: eine Antwort, kein Produktraster.
     Der unverfaengliche Teil wird als anklickbare Rueckfrage
     angeboten - dasselbe Muster wie bei der Buero-Frage vom
     13.08.2026, nur diesmal aus dem zweiten Satzteil gebaut. */
  const sperrTeil = paare.find(p=>p.r.redirect);
  if(haupt.redirect || sperrTeil){
    const sperr = haupt.redirect ? haupt : sperrTeil.r;
    const sk = antwortSchluessel(sperr);
    const frei = paare.filter(p=>!p.r.redirect && !istLeerAntwort(p.r)
                                 && antwortSchluessel(p.r) !== sk
                                 && !SPERRE.test(p.t));
    if(!frei.length) return [sperr];
    /* Niemals das gemeinsame results-Objekt anfassen - sonst haengt
       der Knopf an jeder spaeteren Frage mit derselben Umlenkung. */
    const kopie = Object.assign({}, sperr);
    kopie.choice = (sperr.choice||[]).slice().concat(frei.slice(0,1).map(p=>({
      title: p.r.title || 'Den anderen Teil zeigen',
      desc:  'Der zweite Teil deiner Frage, ohne den gesundheitlichen Teil.',
      ask:   p.t
    })));
    return [kopie];
  }

  /* 3. Zweites Thema suchen. Ein Teil zaehlt nur, wenn er fuer sich
     genommen eine eigene Antwortart liefert - nicht die Rueckfrage
     und nicht dieselbe wie der ganze Satz. */
  const hk = antwortSchluessel(haupt);
  const kandidaten = [];
  paare.forEach(p=>{
    if(istLeerAntwort(p.r)) return;
    if(antwortSchluessel(p.r) === hk) return;
    if(kandidaten.some(k=>antwortSchluessel(k.r) === antwortSchluessel(p.r))) return;
    kandidaten.push(p);
  });
  if(!kandidaten.length) return [haupt];

  /* Hoechstens zwei Antworten, in der Reihenfolge der Themen im Satz. */
  const zweite = kandidaten[0];
  const hIdx = paare.findIndex(p=>antwortSchluessel(p.r) === hk);
  const zIdx = paare.indexOf(zweite);
  return (hIdx >= 0 && zIdx < hIdx) ? [zweite.r, haupt] : [haupt, zweite.r];
}
